(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireedca"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireedca"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("adV76", function(module, exports) {
parcelRequire("iqkY1");
var $9sPuh = parcelRequire("9sPuh");

var $iPW16 = parcelRequire("iPW16");
const fitmix = document.getElementById("fitmix-container");
const productTemplateContainer = document.querySelector('[data-section-type="product-template"]');
let productTryOnButton = document.querySelector(".try-on-product-button");
let fitmixInstance = null;
if (!fitmix || !productTemplateContainer || !productTryOnButton) return;
let frameId = productTryOnButton?.dataset?.frameId;
const lang = productTryOnButton?.dataset?.lang;
let pendingAction = null;
let params = {
    apiKey: "FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt",
    lang: lang ? lang : "en",
    mode: "live",
    frame: frameId,
    onStopVto: hide,
    watermark: false,
    uiConfiguration: {
        liveRelaunchDetectionButton: false,
        livePhotoButton: false
    }
};
(0, $iPW16.applyFitmixDisclaimerParams)(params, {
    container: productTemplateContainer,
    compactMobile: true
});
async function initFitMix() {
    if (fitmixInstance) return;
    try {
        productTryOnButton.setAttribute("aria-disabled", "true");
        await (0, $9sPuh.loadScriptOnIntent)("https://vto-advanced-integration-api.fittingbox.com/index.js", productTryOnButton, {
            mobile: "immediate",
            desktop: "immediate",
            idleTimeout: 3000,
            checkGlobal: "FitMix",
            sessionKey: "fitmix_interaction",
            enableClickIntent: true
        });
        fitmixInstance = FitMix.createWidget("fitmix-container", params, function() {
            productTryOnButton.setAttribute("aria-disabled", "false");
            if (pendingAction === "open") {
                openVto();
                pendingAction = null;
            }
        });
    } catch (error) {
        console.error(error);
        productTryOnButton.setAttribute("aria-disabled", "false");
    }
}
function hide() {
    fitmix.style.display = "none";
    if (productTemplateContainer) productTemplateContainer.classList.remove("try-on-enabled");
}
function show() {
    fitmix.style.display = "block";
    if (productTemplateContainer) productTemplateContainer.classList.add("try-on-enabled");
}
function openVto() {
    sessionStorage.setItem("fitmix_interaction", "true");
    fitmixInstance.startVto("live");
    show();
}
function stopVto() {
    fitmixInstance.stopVto();
    const resizeFlickityEvent = new CustomEvent("product:try-on:closed");
    document.dispatchEvent(resizeFlickityEvent);
}
function toggleTryOn() {
    sessionStorage.setItem("fitmix_interaction", "true");
    if (productTryOnButton.getAttribute("aria-disabled") === "true") {
        if (pendingAction === "open") return;
        pendingAction = "open";
        return;
    }
    if (!fitmixInstance) {
        pendingAction = "open";
        initFitMix();
        return;
    }
    if (!productTemplateContainer?.classList.contains("try-on-enabled")) openVto();
    else stopVto();
}
function setTryOnBtnEvent() {
    if (productTryOnButton) productTryOnButton.addEventListener("click", toggleTryOn);
}
document.addEventListener("product-variant-switch:end", ()=>{
    initTryOnButton();
    setTryOnFrame();
});
function initTryOnButton() {
    productTryOnButton = document.querySelector(".try-on-product-button");
    if (productTryOnButton?.dataset?.frameId) setTryOnBtnEvent();
}
function setTryOnFrame() {
    frameId = productTryOnButton?.dataset?.frameId;
    if (!frameId) {
        if (fitmixInstance) stopVto();
    } else {
        params.frame = frameId;
        fitmixInstance?.setFrame(frameId);
    }
}
setTryOnBtnEvent();

});
parcelRegister("iqkY1", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $d69aeb50f48a55e4$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "isTryOnMobile", function () { return $d69aeb50f48a55e4$export$1b5ceeba37b47ff7; });
$parcel$export(module.exports, "isDesktopViewport", function () { return $d69aeb50f48a55e4$export$da99ac526a3dd23d; });
$parcel$export(module.exports, "loadScriptOnIntent", function () { return (parcelRequire("9sPuh")).loadScriptOnIntent; });

var $9sPuh = parcelRequire("9sPuh");
function $d69aeb50f48a55e4$export$61fc7d43ac8f84b0(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
function $d69aeb50f48a55e4$export$1b5ceeba37b47ff7() {
    return window.innerWidth < 1000;
}
function $d69aeb50f48a55e4$export$da99ac526a3dd23d() {
    return window.matchMedia("(min-width: 1000px)").matches;
}

});
parcelRegister("9sPuh", function(module, exports) {

$parcel$export(module.exports, "loadScriptOnIntent", function () { return $6e3eaae17e451e5d$export$fcd80e45dad276ba; });
/**
 * Intent-based script loader utilities
 * Provides smart loading strategies based on user intent and device type
 */ /**
 * Loads a script asynchronously with duplicate prevention
 * @param {string} scriptUrl - URL of the script to load
 * @param {string|null} checkGlobal - Optional window property name to check if script is already loaded (e.g., 'FitMix')
 * @returns {Promise} Resolves when script is loaded, rejects on error
 */ function $6e3eaae17e451e5d$export$f9b12240710a10d(scriptUrl, checkGlobal = null) {
    return new Promise((resolve, reject)=>{
        if (checkGlobal && window[checkGlobal]) {
            resolve();
            return;
        }
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
        if (existingScript) {
            existingScript.addEventListener("load", resolve);
            existingScript.addEventListener("error", reject);
            return;
        }
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.type = "text/javascript";
        script.async = true;
        script.addEventListener("load", resolve);
        script.addEventListener("error", ()=>reject(new Error(`Failed to load script: ${scriptUrl}`)));
        document.head.appendChild(script);
    });
}
function $6e3eaae17e451e5d$export$fcd80e45dad276ba(scriptUrl, element, options = {}) {
    const { mobile: mobile = "viewport", desktop: desktop = "hover", idleTimeout: idleTimeout = 5000, mobileBreakpoint: mobileBreakpoint = 1000, checkGlobal: checkGlobal = null, sessionKey: sessionKey = null, sessionValue: sessionValue = "true", enableClickIntent: enableClickIntent = false } = options;
    return new Promise((resolve, reject)=>{
        const isMobile = window.innerWidth < mobileBreakpoint;
        let strategy = isMobile ? mobile : desktop;
        if (sessionKey && sessionStorage.getItem(sessionKey) === sessionValue) strategy = "immediate";
        let loaded = false;
        const loadScript = async ()=>{
            if (loaded) return;
            loaded = true;
            try {
                await $6e3eaae17e451e5d$export$f9b12240710a10d(scriptUrl, checkGlobal);
                resolve();
            } catch (error) {
                reject(error);
            }
        };
        switch(strategy){
            case "immediate":
                loadScript();
                break;
            case "viewport":
                if ("IntersectionObserver" in window) {
                    const observer = new IntersectionObserver((entries)=>{
                        entries.forEach((entry)=>{
                            if (entry.isIntersecting) {
                                observer.disconnect();
                                loadScript();
                            }
                        });
                    }, {
                        rootMargin: "50px"
                    });
                    observer.observe(element);
                } else loadScript();
                break;
            case "hover":
                const hoverHandler = ()=>{
                    element.removeEventListener("mouseenter", hoverHandler);
                    loadScript();
                };
                element.addEventListener("mouseenter", hoverHandler);
                Promise.all([
                    new Promise((resolve)=>setTimeout(resolve, idleTimeout)),
                    new Promise((resolve)=>{
                        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
                            timeout: idleTimeout
                        });
                        else resolve();
                    })
                ]).then(loadScript);
                break;
            case "idle":
                if ("requestIdleCallback" in window) requestIdleCallback(()=>loadScript(), {
                    timeout: idleTimeout
                });
                else setTimeout(loadScript, idleTimeout);
                break;
            default:
                reject(new Error(`Unknown loading strategy: ${strategy}`));
        }
        if (enableClickIntent) {
            const clickHandler = ()=>{
                element.removeEventListener("click", clickHandler);
                loadScript();
            };
            element.addEventListener("click", clickHandler);
        }
    });
}

});


parcelRegister("iPW16", function(module, exports) {

$parcel$export(module.exports, "applyFitmixDisclaimerParams", function () { return $db69fe51edda53e0$export$419cdda0d3e6cdae; });
function $db69fe51edda53e0$var$buildPdpMobileDisclaimerCss() {
    return `
    @media (max-width: 767px) {
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] {
        justify-content: center !important;
        align-items: center;
        padding: 12px 50px;
        min-height: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        box-sizing: border-box;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div {
        max-width: 100%;
        width: 100%;
        margin-inline: auto;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:first-child {
        padding-bottom: 14px;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] {
        gap: 12px;
        align-items: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] > div {
        gap: 12px !important;
        align-items: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] img,
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] svg,
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] [class*="icon"] {
        height: 100px !important;
        max-height: 100px !important;
        width: auto !important;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-introduction"] p {
        font-size: 12px !important;
        line-height: 1.4 !important;
        max-width: 100% !important;
        text-align: center;
      }
      #vtoAdvDisclaimer [data-style="vto-adv-disclaimer-terms-policy"] {
        padding-top: 14px;
        font-size: 12px;
        line-height: 1.4;
        text-align: center;
      }
      #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:last-child {
        padding: 12px 0 0 !important;
      }
      #vtoAdvDisclaimerBtnAgree {
        font-size: 13px !important;
        padding: 11px 12px !important;
        min-height: 42px;
      }
      #vtoAdvDisclaimer.disclaimer-policy-open [data-style="vto-adv-disclaimer-explanation"],
      #vtoAdvDisclaimer.disclaimer-policy-open vto-advanced-disclaimer-explanation {
        max-height: 40vh;
        font-size: 12px;
      }
    }
  `;
}
function $db69fe51edda53e0$var$htmlToPlainText(html) {
    if (!html || typeof html !== "string") return "";
    const el = document.createElement("div");
    el.innerHTML = html;
    return (el.textContent || "").trim();
}
function $db69fe51edda53e0$var$escapeCssContent(value) {
    return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\r/g, "").replace(/\n/g, "\\A ");
}
function $db69fe51edda53e0$var$buildDisclaimerCopyCss() {
    const shortText = window.tryOnDisclaimerShortText?.trim();
    const activateLong = window.tryOnDisclaimerActivateLong?.trim();
    let css = "";
    if (shortText) {
        const intro = $db69fe51edda53e0$var$escapeCssContent($db69fe51edda53e0$var$htmlToPlainText(shortText));
        css += `
      [data-style="vto-adv-introduction"] p {
        font-size: 0 !important;
        line-height: 0 !important;
        color: transparent !important;
      }
      [data-style="vto-adv-introduction"] p * {
        display: none !important;
      }
      [data-style="vto-adv-introduction"] p::after {
        content: "${intro}";
        font-size: 14px;
        line-height: 1.5;
        color: #232325;
        display: block;
        white-space: normal;
        text-align: center;
        max-width: 400px;
        margin-inline: auto;
      }
    `;
    }
    if (activateLong) {
        const policyLine = $db69fe51edda53e0$var$escapeCssContent(activateLong);
        css += `
      [data-style="vto-adv-disclaimer-terms-policy"] {
        position: relative;
        cursor: pointer;
        font-size: 0 !important;
        line-height: 0 !important;
        color: transparent !important;
      }
      [data-style="vto-adv-disclaimer-terms-policy"] p {
        margin: 0;
      }
      [data-style="vto-adv-disclaimer-terms-policy"] [data-testid="dialog-button"] {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        opacity: 0 !important;
        cursor: pointer !important;
        font-size: 14px !important;
        text-decoration: none !important;
      }
      [data-style="vto-adv-disclaimer-terms-policy"]::after {
        content: "${policyLine}";
        font-size: 14px;
        line-height: 1.5;
        color: rgb(35, 35, 37);
        display: block;
        white-space: normal;
        text-align: center;
        pointer-events: none;
      }
    `;
    }
    return css;
}
function $db69fe51edda53e0$export$18faf5d4857ff1c3({ compactMobile: compactMobile = false } = {}) {
    const regularUrl = window.tryOnFontGothicRegular || "";
    const mediumUrl = window.tryOnFontGothicMedium || "";
    const bodyFont = regularUrl ? "'GothicA1-Regular', sans-serif" : "sans-serif";
    const mediumFont = mediumUrl ? "'GothicA1-Medium', sans-serif" : "sans-serif";
    const fontFaces = regularUrl && mediumUrl ? `
    @font-face {
      font-family: 'GothicA1-Regular';
      src: url('${regularUrl}') format('woff2');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'GothicA1-Medium';
      src: url('${mediumUrl}') format('woff2');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }
  ` : "";
    return `
    ${fontFaces}
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] {
      display: flex;
      flex-direction: column !important;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 100%;
      padding: 0 50px;
      box-sizing: border-box;
      font-family: ${bodyFont};
      background: #FFF;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div {
      flex: 0 0 auto;
      width: 100%;
      max-width: 386px;
      background: #FFF;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:first-child {
      display: flex !important;
      padding-bottom:30px;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child {
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;
      justify-content: flex-start;
      height: auto;
      overflow: visible;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:first-child {
      margin-top: 0 !important;
      width: 100%;
      padding:0;
    }
    #vtoAdvDisclaimer[data-style="vto-adv-disclaimer"] > div:last-child > div:last-child {
      position: relative !important;
      right: auto !important;
      bottom: auto !important;
      box-shadow: none !important;
      padding: 18px 0 0 !important;
      width: 100%;
      background: #FFF;
    }
    #vtoAdvDisclaimerBtnDisagree { display: none; }
    [data-style="vto-adv-disclaimer-explanation"],
    vto-advanced-disclaimer-explanation {
      display: none !important;
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 1.5;
      max-height: 60vh;
      overflow-y: auto;
    }
    #vtoAdvDisclaimer.disclaimer-policy-open [data-style="vto-adv-disclaimer-explanation"],
    #vtoAdvDisclaimer.disclaimer-policy-open vto-advanced-disclaimer-explanation {
      display: block !important;
    }
    [data-style="vto-adv-introduction"] {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 18px;
      height: auto !important;
      font-family: ${bodyFont};
    }
    [data-style="vto-adv-introduction"] > div {
      gap: 18px !important;
    }
    [data-style="vto-adv-introduction"] p {
      max-width: 400px !important;
      width: 100%;
    }
    [data-style="vto-adv-disclaimer-terms-policy"] {
      width: 100%;
      border-top: 1px solid #D0D0D0;
      padding-top: 30px;
      font-family: ${bodyFont};
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
    }
    [data-style="vto-adv-disclaimer-actions"] {
      width: 100%;
    }
    #vtoAdvDisclaimerBtnAgree {
      width: 100%;
      background-color: #004AC7 !important;
      color: #FFF !important;
      font-family: ${mediumFont};
      font-size: 14px;
      font-weight: 500;
    }
    ${$db69fe51edda53e0$var$buildDisclaimerCopyCss()}
    ${compactMobile ? $db69fe51edda53e0$var$buildPdpMobileDisclaimerCss() : ""}
  `;
}
function $db69fe51edda53e0$var$syncDisclaimerExplanationVisibility() {
    const root = document.getElementById("vtoAdvDisclaimer");
    if (!root) return;
    const show = root.classList.contains("disclaimer-policy-open");
    root.querySelectorAll('[data-style="vto-adv-disclaimer-explanation"], vto-advanced-disclaimer-explanation').forEach((el)=>{
        el.style.display = show ? "" : "none";
    });
}
function $db69fe51edda53e0$var$setupDisclaimerPolicyClick() {
    if (window.__luxDisclaimerPolicyClick) return;
    window.__luxDisclaimerPolicyClick = true;
    document.addEventListener("click", (e)=>{
        const root = document.getElementById("vtoAdvDisclaimer");
        if (!root?.contains(e.target)) return;
        if (!e.target.closest('[data-style="vto-adv-disclaimer-terms-policy"]')) return;
        root.classList.add("disclaimer-policy-open");
        $db69fe51edda53e0$var$syncDisclaimerExplanationVisibility();
    }, true);
}
function $db69fe51edda53e0$export$419cdda0d3e6cdae(params, { container: container, compactMobile: compactMobile = false } = {}) {
    $db69fe51edda53e0$var$setupDisclaimerPolicyClick();
    params.css = $db69fe51edda53e0$export$18faf5d4857ff1c3({
        compactMobile: compactMobile
    });
    const longText = window.tryOnDisclaimerLongText?.trim();
    const agreeButton = window.tryOnDisclaimerAgreeButton;
    const disagreeButton = window.tryOnDisclaimerDisagreeButton;
    if (longText || agreeButton || disagreeButton) {
        params.dataPrivacyDisclaimerTexts = {};
        if (longText) params.dataPrivacyDisclaimerTexts.longText = longText;
        if (agreeButton) params.dataPrivacyDisclaimerTexts.agreeButton = agreeButton;
        if (disagreeButton) params.dataPrivacyDisclaimerTexts.disagreeButton = disagreeButton;
    }
    const onPrivacyTermsShown = ()=>{
        container?.classList.add("disclaimer-shown");
    };
    const closeDisclaimer = ()=>{
        container?.classList.remove("disclaimer-shown");
        document.getElementById("vtoAdvDisclaimer")?.classList.remove("disclaimer-policy-open");
        $db69fe51edda53e0$var$syncDisclaimerExplanationVisibility();
    };
    const onAgreePrivacyTerms = closeDisclaimer;
    const onDisagreePrivacyTerms = closeDisclaimer;
    params.onPrivacyTermsShown = onPrivacyTermsShown;
    params.onAgreePrivacyTerms = onAgreePrivacyTerms;
    params.onDisagreePrivacyTerms = onDisagreePrivacyTerms;
}

});


parcelRegister("gQTes", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
var $9sPuh = parcelRequire("9sPuh");

var $iPW16 = parcelRequire("iPW16");
const fitmixTryOnContainer = document.getElementById("fitmix-container");
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const firstGlasses = tryonTemplateContainer?.querySelector(".to-glasses-wrapper[data-frame-id]");
let frameIdTryOn = firstGlasses?.dataset?.frameId;
// Early exit if try-on feature is not present on this page
if (!fitmixTryOnContainer || !frameIdTryOn) return;
const langTryOn = tryonTemplateContainer?.dataset?.lang;
let paramsTryOn = {
    apiKey: "FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt",
    lang: langTryOn ? langTryOn : "en",
    liveAutostart: false,
    mode: "live",
    frame: frameIdTryOn,
    watermark: false,
    uiConfiguration: {
        liveRelaunchDetectionButton: false,
        livePhotoButton: false
    }
};
(0, $iPW16.applyFitmixDisclaimerParams)(paramsTryOn, {
    container: tryonTemplateContainer
});
let isInitializing = false;
let fitmixInstance = null;
async function initFitMix() {
    if (isInitializing || fitmixInstance) return;
    isInitializing = true;
    try {
        await (0, $9sPuh.loadScriptOnIntent)("https://vto-advanced-integration-api.fittingbox.com/index.js", fitmixTryOnContainer, {
            mobile: "immediate",
            desktop: "immediate",
            idleTimeout: 5000,
            checkGlobal: "FitMix",
            sessionKey: "fitmix_interaction"
        });
        fitmixInstance = FitMix.createWidget("fitmix-container", paramsTryOn, onFitMixReady);
    } catch (error) {
        console.error("FitMix Init Error:", error);
        isInitializing = false;
    }
}
function onFitMixReady() {
    openVto();
}
function openVto() {
    sessionStorage.setItem("fitmix_interaction", "true");
    fitmixInstance.startVto("live");
    fitmixTryOnContainer.style.display = "block";
    const chatBox = document.querySelector(".woot--bubble-holder");
    if (chatBox) chatBox.style.display = "none";
}
function initGlassesEvents() {
    const allGlasses = tryonTemplateContainer?.querySelectorAll(".to-glasses-wrapper[data-frame-id]");
    const allConnectedProducts = tryonTemplateContainer?.querySelectorAll(".to-connected-product[data-frame-id]");
    setChangeFrameEvents(allGlasses, false);
    setChangeFrameEvents(allConnectedProducts, true);
}
function setChangeFrameEvents(frames, showOnMobile = true) {
    frames.forEach((frame)=>{
        const frameId = frame.dataset?.frameId;
        if (!frameId) return;
        frame.addEventListener("click", (e)=>{
            e.stopPropagation();
            if (!((0, $iqkY1.isTryOnMobile)() && !showOnMobile)) handleSelection(frame);
        });
    });
}
function setFrame(targetEl) {
    if (targetEl.classList.contains("to-connected-product")) handleSelection(targetEl);
    else {
        const targetElIsWrapper = targetEl.classList.contains("to-glasses-wrapper");
        const glassesWrapper = targetElIsWrapper ? targetEl : targetEl.closest(".to-glasses-wrapper");
        const tempSelFrame = glassesWrapper.querySelector(".to-connected-product.to-default-cp");
        if (tempSelFrame) handleSelection(tempSelFrame);
    }
}
function highlightFrameUI(newSelectedFrame) {
    const oldSelectedFrame = tryonTemplateContainer?.querySelector(".selected-frame");
    const isWrapper = newSelectedFrame.classList.contains("to-glasses-wrapper");
    if (oldSelectedFrame) oldSelectedFrame?.classList.remove("selected-frame");
    if (isWrapper) newSelectedFrame = newSelectedFrame.querySelector(".to-default-cp");
    newSelectedFrame?.classList.add("selected-frame");
    const frameSelectedEvent = new CustomEvent("try-on:frame-selected");
    setTimeout(()=>document.dispatchEvent(frameSelectedEvent));
    return newSelectedFrame;
}
function handleSelection(targetElement) {
    const selectedElement = highlightFrameUI(targetElement);
    const frameId = selectedElement.dataset.frameId;
    if (!fitmixInstance) {
        paramsTryOn.frame = frameId;
        initFitMix();
    } else fitmixInstance?.setFrame(frameId);
}
function selectInitialFrame() {
    let selectInitialFrame;
    if ((0, $iqkY1.isTryOnMobile)()) selectInitialFrame = tryonTemplateContainer?.querySelector(".to-connected-product.is-selected:not(.to-cp-not-available");
    else selectInitialFrame = tryonTemplateContainer?.querySelector(".to-connected-product:not(.to-cp-not-available");
    if (!selectInitialFrame) return;
    highlightFrameUI(selectInitialFrame);
}
setTimeout(selectInitialFrame);
initGlassesEvents();
document.addEventListener("try-on:loaded-glasses", ()=>setTimeout(initGlassesEvents));
document.addEventListener("try-on:frame-changed", (e)=>{
    const selectedGlasses = e.detail.selectedGlasses;
    if (selectedGlasses) setFrame(selectedGlasses);
});
const isProductPage = window.location.pathname.includes("/products/");
if (!isProductPage) initFitMix();

});

parcelRegister("h17mq", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const tryonGrid = tryonTemplateContainer?.querySelector(".to__glasses--grid");
const sectionId = tryonGrid?.dataset?.id;
const addToCartButton = tryonTemplateContainer?.querySelector(".to__add-to-cart .loader");
const tryOnGrid = tryonTemplateContainer?.querySelector(".to__glasses--grid");
if (!sectionId || !tryOnGrid) return;
function handleTryOnGridScroll() {
    const scrollPosition = tryOnGrid.scrollTop + tryOnGrid.clientHeight;
    const totalHeight = tryOnGrid.scrollHeight;
    if (totalHeight - scrollPosition <= 200) {
        tryOnGrid?.removeEventListener("scroll", handleTryOnGridScroll);
        initEventHandlers();
    }
}
tryOnGrid.addEventListener("scroll", handleTryOnGridScroll);
function initEventHandlers() {
    const nextPageEls = tryonTemplateContainer?.querySelectorAll(".to-load-more");
    const nextPageEl = nextPageEls[nextPageEls?.length - 1];
    if (!nextPageEl) return;
    const nextURL = nextPageEl.dataset.nextUrl;
    if (!nextURL) return;
    renderSectionFromFetch(nextURL);
}
async function renderSectionFromFetch(nextURL) {
    if (addToCartButton) addToCartButton.classList.add("loading");
    const isMobile = (0, $iqkY1.isTryOnMobile)();
    try {
        const response = await fetch(nextURL);
        const html = await response.text();
        const parser = new DOMParser();
        const fetchedPage = parser.parseFromString(html, "text/html")?.querySelector("body");
        const tryOnGridNew = fetchedPage?.querySelector(".to__glasses--grid");
        const fetchMoreLink = tryOnGrid?.querySelector(".to-load-more");
        const fetchMoreLinkNew = tryOnGridNew?.querySelector(".to-load-more")?.dataset.nextUrl;
        if (tryOnGridNew && !isMobile) tryOnGrid.innerHTML += tryOnGridNew.innerHTML;
        if (isMobile) fetchMoreLink?.setAttribute("data-next-url", fetchMoreLinkNew);
        if (addToCartButton) setTimeout(()=>{
            addToCartButton.classList.remove("loading");
        }, 500);
        if (!isMobile) tryOnGrid.addEventListener("scroll", handleTryOnGridScroll);
        const detail = isMobile ? {
            newSlides: Array.from(tryOnGridNew?.children).map((child)=>child.outerHTML)
        } : {};
        const loadedGlassesEvent = new CustomEvent("try-on:loaded-glasses", {
            detail: detail
        });
        document.dispatchEvent(loadedGlassesEvent);
    } catch (error) {
        console.error("Failed fetching more glasses");
    }
}
document.addEventListener("try-on:load-more-glasses", initEventHandlers);

});

parcelRegister("ghscK", function(module, exports) {
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const cartWrapper = tryonTemplateContainer?.querySelector(".to__add-to-cart");
if (!cartWrapper) return;
const overlay = cartWrapper?.querySelector(".to__catalogue--overlay");
const atcCloseBtn = cartWrapper?.querySelector(".to__atc__close");
const cartButton = cartWrapper?.querySelector(".to__add-to-cart button");
const addToCartLoader = tryonTemplateContainer?.querySelector(".to__add-to-cart .loader");
const form = cartWrapper?.querySelector("#try-on-prod-form");
const formVariantId = cartWrapper?.querySelector("[data-product-select]");
const formProductId = cartWrapper?.querySelector('[name="product-id"]');
function updateUI() {
    let selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame + [data-json]");
    if (!selectedFrame) selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame [data-json]");
    if (!selectedFrame) return;
    const productData = JSON.parse(selectedFrame.dataset.json);
    if (!productData) return;
    updateInfo(productData);
    updateStrengthOptions(productData);
    updateLensesOptions(productData);
    updateGrid(selectedFrame, productData);
    updateSubmitButtonState();
}
function updateGrid(selectedFrame, newProductData) {
    const frameWrapper = selectedFrame.closest(".to-glasses-wrapper");
    const imgEl = frameWrapper?.querySelector(".to-image");
    const titleEl = frameWrapper?.querySelector(".to-title");
    const priceEl = frameWrapper?.querySelector(".to-price");
    const defaultConnectedProd = frameWrapper?.querySelector(".to-default-cp");
    if (titleEl.innerHTML.trim() == newProductData.productTitle.trim()) return;
    if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
    if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
    if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
    if (defaultConnectedProd) {
        defaultConnectedProd.classList.remove("to-default-cp");
        selectedFrame?.previousElementSibling.classList.add("to-default-cp");
    }
}
function updateSubmitButtonState() {
    const submitButton = tryonTemplateContainer?.querySelector(".submit-try-on-atc");
    if (!submitButton) return;
    const isExpanded = cartWrapper?.classList.contains("expanded");
    const isVariantAvailable = checkSelectedVariantAvailability();
    const labelSpan = submitButton.querySelector(".label");
    // Get text from data attributes
    const addToCartText = submitButton.dataset.addToCartText;
    const soldOutText = submitButton.dataset.soldOutText;
    // Disable button and update label if cart is expanded and variant is not available
    if (isExpanded && !isVariantAvailable) {
        submitButton.disabled = true;
        if (labelSpan && soldOutText) labelSpan.textContent = soldOutText;
    } else {
        submitButton.disabled = false;
        if (labelSpan && addToCartText) labelSpan.textContent = addToCartText;
    }
}
function checkSelectedVariantAvailability() {
    const strengthInputOptions = cartWrapper?.querySelectorAll(".to__atc_option-strength input.radio_input");
    const hasStrengthOptions = strengthInputOptions && strengthInputOptions.length > 0;
    // Check if any strength option is selected and available
    const selectedStrengthOption = cartWrapper?.querySelector(".to__atc_option-strength input.radio_input:checked");
    if (selectedStrengthOption) {
        const correspondingLabel = cartWrapper?.querySelector(`.to__atc_option-strength label[for="${selectedStrengthOption.id}"]`);
        return correspondingLabel && !correspondingLabel.classList.contains("not-available");
    }
    // For products with strength variants, force an explicit available selection.
    if (hasStrengthOptions) return false;
    return true;
}
function updateInfo(newProductData) {
    const imgEl = cartWrapper?.querySelector(".to-image");
    const typeEl = cartWrapper?.querySelector(".to__atc__type");
    const titleEl = cartWrapper?.querySelector(".to__atc__title");
    const priceEl = cartWrapper?.querySelector(".to__atc__price");
    if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
    if (typeEl && newProductData.type) typeEl.innerHTML = newProductData.type;
    if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
    if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
}
function updateStrengthOptions(newProductData) {
    const strengthContainerEl = cartWrapper?.querySelector(".to__atc_option-strength");
    if (strengthContainerEl && newProductData.productStrengthOptions) {
        const options = newProductData.productStrengthOptions;
        const optionName = "Strength";
        const strengthOptionsEl = strengthContainerEl.querySelector(".to_atc__options");
        const optionsWrapper = document.createElement("div");
        optionsWrapper.classList.add("to_atc__options");
        formVariantId.value = "";
        options.forEach((option, index)=>{
            const id = `--${optionName}-${index}`;
            const radioButton = document.createElement("input");
            radioButton.type = "radio";
            radioButton.classList.add("radio_input");
            radioButton.name = `options[${optionName}]`;
            radioButton.id = id;
            radioButton.value = option.valueName;
            const label = document.createElement("label");
            label.classList.add("to__atc__option");
            label.htmlFor = id;
            label.textContent = option.valueName;
            label.setAttribute("data-variant-id", option.variantId);
            if (!option.available) {
                radioButton.disabled = true;
                label.classList.add("not-available");
            }
            if (newProductData.currentValue?.trim() === option.valueName?.trim()) {
                radioButton.setAttribute("checked", true);
                formVariantId.value = option.variantId;
            }
            optionsWrapper?.append(radioButton);
            optionsWrapper?.append(label);
        });
        formProductId.value = newProductData.id;
        strengthOptionsEl.innerHTML = optionsWrapper.innerHTML;
        strengthContainerEl.classList.add("has-strength");
        setStrengthEvents(strengthOptionsEl);
    } else if (strengthContainerEl) strengthContainerEl.classList.remove("has-strength");
}
function updateLensesOptions(newProductData) {
    const lensesContainerEl = cartWrapper?.querySelector(".to__atc_option-lenses");
    const typeOptions = newProductData.productTypeOptions;
    if (typeOptions && lensesContainerEl) {
        const lensesOptionsEl = lensesContainerEl.querySelector(".to_atc__options");
        const newOptionsWrapper = document.createElement("div");
        const currentType = newProductData.type;
        const typesMap = new Map();
        const opticalType = typeOptions.find((option)=>option.type === "Reading glasses" && option.frameId);
        if (opticalType) typesMap.set("Optical", opticalType);
        const blueLightType = typeOptions.find((option)=>option.type === "Blue light glasses" && option.frameId);
        if (blueLightType) typesMap.set("Blue light", blueLightType);
        const sunglassesType = typeOptions.find((option)=>option.type === "Sunglasses" && option.frameId);
        if (sunglassesType) typesMap.set("Sun", sunglassesType);
        typesMap.set(currentType, {
            ...newProductData,
            current: true
        });
        const types = Object.fromEntries(Array.from(typesMap));
        let index = 0;
        for(const type in types)if (Object.prototype.hasOwnProperty.call(types, type)) {
            const id = `--Lenses-${index}`;
            const radioButton = document.createElement("input");
            radioButton.type = "radio";
            radioButton.classList.add("radio_input");
            radioButton.name = `options[Lenses]`;
            radioButton.id = id;
            radioButton.value = type;
            const label = document.createElement("label");
            label.classList.add("to__atc__option");
            label.htmlFor = id;
            label.textContent = type;
            label.setAttribute("data-product-id", types[type].id);
            label.setAttribute("data-frame-id", types[type].frameId);
            label.setAttribute("data-product-type", types[type].type);
            index++;
            if (types[type].current) radioButton.setAttribute("checked", true);
            if (type == "Reading glasses") {
                newOptionsWrapper?.prepend(label);
                newOptionsWrapper?.prepend(radioButton);
            } else {
                newOptionsWrapper?.append(radioButton);
                newOptionsWrapper?.append(label);
            }
        }
        lensesOptionsEl.innerHTML = newOptionsWrapper.innerHTML;
        lensesContainerEl.classList.add("has-lenses");
        setLensesEvents(lensesContainerEl, types);
    } else if (lensesContainerEl) lensesContainerEl.classList.remove("has-lenses");
}
function setStrengthEvents(container) {
    const strengthOptions = container.querySelectorAll(".to__atc__option:not(.not-available)");
    strengthOptions?.forEach((option)=>{
        const variantId = option.dataset.variantId;
        option.addEventListener("click", ()=>{
            formVariantId.value = variantId;
            updateSubmitButtonState();
        });
    });
}
function setLensesEvents(lensesContainerEl, types) {
    const lensesOptions = lensesContainerEl?.querySelectorAll(".to__atc__option");
    lensesOptions?.forEach((lense)=>{
        const productType = lense.dataset.productType;
        const frameId = lense.dataset.frameId;
        const newProductData = Object.values(types).find((option)=>option.type == productType);
        lense.addEventListener("click", ()=>{
            updateInfo(newProductData);
            updateStrengthOptions(newProductData);
            updateSubmitButtonState();
            if (frameId && fitmixInstance) fitmixInstance?.setFrame(frameId);
        });
    });
}
function initQuantity() {
    const decrementBtn = cartWrapper.querySelector(".to__atc__quantity .decrement");
    const incrementBtn = cartWrapper.querySelector(".to__atc__quantity .increment");
    const quantityDisplay = cartWrapper.querySelector(".to__atc__quantity .quantity");
    const quantityInput = cartWrapper.querySelector('[name="quantity"]');
    let quantity = quantityDisplay ? parseInt(quantityDisplay.textContent, 10) : 1;
    decrementBtn?.addEventListener("click", ()=>{
        if (quantity > 1) {
            quantity--;
            quantityDisplay.textContent = quantity;
            quantityInput.value = quantity;
        }
    });
    incrementBtn?.addEventListener("click", ()=>{
        quantity++;
        quantityDisplay.textContent = quantity;
        quantityInput.value = quantity;
    });
}
cartButton?.addEventListener("click", (e)=>{
    if (!cartWrapper?.classList.contains("expanded")) setTimeout(()=>{
        cartWrapper?.classList.add("expanded");
        updateSubmitButtonState();
    }, 0);
    else e.preventDefault();
});
[
    overlay,
    atcCloseBtn
].forEach((el)=>{
    el?.addEventListener("click", ()=>{
        cartWrapper?.classList.remove("expanded");
        updateSubmitButtonState();
    });
});
document.addEventListener("try-on:frame-selected", updateUI);
initQuantity();
form?.addEventListener("submit", (e)=>{
    e.preventDefault();
});
// Initialize button state
updateSubmitButtonState();

});

parcelRegister("jPzyF", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
const slider = document.querySelector(".to__glasses--grid");
if (!slider) return;
let isMobile = (0, $iqkY1.isTryOnMobile)();
let oldIsMobile = isMobile;
const Flickity = themeVendor.Flickity;
let flkty;
function handleWindowResize() {
    isMobile = (0, $iqkY1.isTryOnMobile)();
    if (isMobile === oldIsMobile) return;
    oldIsMobile = isMobile;
    if (isMobile) initMobileView();
    else destroyMobileView();
}
function initMobileView() {
    flkty = new Flickity(slider, {
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
        cellSelector: ".carousel-cell",
        wrapAround: true,
        on: {
            change: (index)=>{
                debounceTriggerSetFrame(index);
                handleTryOnSliderScroll(index);
            },
            ready: ()=>{
                setTimeout(()=>flkty.resize(), 100);
            },
            staticClick: (event, pointer, cellElement, cellIndex)=>{
                if (cellElement && cellIndex !== flkty.selectedIndex) flkty.select(cellIndex);
            }
        }
    });
    allowCpExpandEvents();
    document.body?.classList.add("to_mobile");
}
function destroyMobileView() {
    flkty.destroy();
    allowCpExpandEvents(false);
    document.body?.classList.remove("to_mobile");
}
const debounceTriggerSetFrame = (0, $iqkY1.debounce)((index)=>{
    const catalougWrapper = document.querySelector(".to__catalogue--wrapper");
    let selectedGlasses = catalougWrapper?.querySelector(".to-glasses-wrapper.is-selected");
    if (!selectedGlasses) selectedGlasses = catalougWrapper?.querySelectorAll(".to-glasses-wrapper")[index - 1];
    const detail = {
        selectedGlasses: selectedGlasses
    };
    const mobileFrameSelected = new CustomEvent("try-on:frame-changed", {
        detail: detail
    });
    document.dispatchEvent(mobileFrameSelected);
}, 200);
function allowCpExpandEvents(enable = true) {
    const expandableConnectedProducts = slider?.querySelectorAll(".to-connected-products.not-expanded");
    expandableConnectedProducts.forEach((expandableCP)=>{
        const expandCpProd = expandConnectedProducts.bind(this, expandableCP);
        if (enable) expandableCP.addEventListener("click", expandCpProd);
        if (!enable) expandableCP.removeEventListener("click", expandCpProd);
    });
    function expandConnectedProducts(expandableCP) {
        expandableCP.classList.remove("not-expanded");
        expandableCP.removeEventListener("click", expandConnectedProducts);
    }
}
function appendNewSlides(e) {
    const elements = e.detail.newSlides;
    if (!elements) return;
    const parser = new DOMParser();
    let newSlides = elements.map((slide)=>parser.parseFromString(slide, "text/html")?.querySelector(".carousel-cell")).filter((slide)=>slide);
    flkty.append(newSlides);
    allowCpExpandEvents();
    document.removeEventListener("try-on:loaded-glasses", appendNewSlides);
}
function handleTryOnSliderScroll(index) {
    const expandableConnectedProducts = slider?.querySelectorAll(".to-connected-products");
    const slides = expandableConnectedProducts?.length;
    if (slides && index >= slides - 4) {
        const loadMoreGlassesEvent = new CustomEvent("try-on:load-more-glasses");
        document.dispatchEvent(loadMoreGlassesEvent);
        document.addEventListener("try-on:loaded-glasses", appendNewSlides);
    }
}
if (isMobile) initMobileView();
window.addEventListener("resize", handleWindowResize);

});

parcelRegister("aJzli", function(module, exports) {
const productPage = document.querySelector(".template-product");
const productSection = document.querySelector('[data-section-type="product-template"]');
const sectionId = productSection?.dataset?.sectionId;
if (!productPage || !productSection || !sectionId) return;
let swatches;
initEventHandlers();
async function updatePageContents(targetUrl) {
    try {
        const response = await fetch(targetUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const fetchedPage = parser.parseFromString(html, "text/html")?.querySelector("body");
        const variantSwitchStartEvent = new CustomEvent("product-variant-switch:start", {
            detail: {
                sectionId: sectionId
            }
        });
        document.dispatchEvent(variantSwitchStartEvent);
        replaceElements(fetchedPage);
        initEventHandlers();
        const variantSwitchEndEvent = new CustomEvent("product-variant-switch:end", {
            detail: {
                sectionId: sectionId
            }
        });
        document.dispatchEvent(variantSwitchEndEvent);
    } catch (err) {
        console.log("Failed to fetch page: ", err);
    }
}
function initEventHandlers() {
    document.addEventListener("click", function(e) {
        const swatch = e.target.classList.contains("siblings__swatch");
        if (!swatch) return;
        e.preventDefault();
        const targetUrl = e.target.href;
        if (!targetUrl) return;
        const retrieveFromURL = targetUrl + "?section_id=" + sectionId;
        history.pushState(null, "", targetUrl);
        updatePageContents(retrieveFromURL);
    });
}
function replaceElements(fetchedPage) {
    const galleryNew = fetchedPage?.querySelector("[data-product-single-media-slider]");
    const galleryThumbnailsNew = fetchedPage?.querySelector("[data-product-single-media-thumbs]");
    const productDetailsNew = fetchedPage?.querySelector(".product-single__details");
    const tryOnBtnNew = fetchedPage?.querySelector(".try-on-product-button");
    const gallery = document.querySelector("[data-product-single-media-slider]");
    const galleryThumbnails = document.querySelector("[data-product-single-media-thumbs]");
    const productDetails = document.querySelector(".product-single__details");
    const tryOnBtn = document.querySelector(".try-on-product-button");
    if (productDetails && productDetailsNew) productDetails.innerHTML = productDetailsNew?.innerHTML;
    if (gallery && galleryNew) gallery.innerHTML = galleryNew?.innerHTML;
    if (galleryThumbnails && galleryThumbnailsNew) galleryThumbnails.innerHTML = galleryThumbnailsNew?.innerHTML;
    if (tryOnBtn && tryOnBtnNew) tryOnBtn.outerHTML = tryOnBtnNew.outerHTML;
}

});

// Override theme breakpoint for product slider (iPad Pro compatibility)
/**
 * GlobalCountdown Web Component
 *
 * A reusable countdown timer with flexible unit display options.
 * Supports smart mode (auto-select), all units, or custom combinations.
 * Can render as visual countdown or text-only format (localized).
 *
 * @example
 * <global-countdown
 *   data-target-date="2025-12-31T23:59:59-05:00"
 *   data-units="hours:minutes:seconds"
 *   data-zero-pad
 *   data-hide-zero-units>
 * </global-countdown>
 *
 * @example Text-only mode
 * <global-countdown
 *   data-target-date="2025-12-31T23:59:59-05:00"
 *   data-units="hours:minutes:seconds"
 *   data-text-only
 *   data-hide-zero-units>
 * </global-countdown>
 */ class $be36d76f30f554f6$var$GlobalCountdown extends HTMLElement {
    constructor(){
        super();
        this.targetDate = this.getAttribute("data-target-date");
        this.unitsMode = this.getAttribute("data-units") || "smart";
        this.hideZero = this.hasAttribute("data-hide-zero");
        this.hideZeroUnits = this.hasAttribute("data-hide-zero-units");
        this.zeroPad = this.hasAttribute("data-zero-pad");
        this.textOnly = this.hasAttribute("data-text-only");
        this.msInSecond = 1000;
        this.msInMinute = 60000;
        this.msInHour = 3600000;
        this.msInDay = 86400000;
        this.msInWeek = 604800000;
        this.animationFrameId = null;
        this.lastUpdateTime = 0;
        this.isTabVisible = true;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    connectedCallback() {
        this.targetDate = this.getAttribute("data-target-date");
        this.unitsMode = this.getAttribute("data-units") || "smart";
        this.zeroPad = this.getAttribute("data-zero-pad") === "true";
        this.hideZeroUnits = this.getAttribute("data-hide-zero-units") === "true";
        this.hideOnZero = this.getAttribute("data-hide-zero") === "true";
        this.textOnly = this.getAttribute("data-text-only") === "true";
        this.endDate = Date.parse(this.targetDate);
        if (isNaN(this.endDate)) {
            console.error("GlobalCountdown: Invalid target date format", this.targetDate);
            return;
        }
        this.units = this.parseUnits(this.unitsMode);
        this.loadTranslations();
        this.setupAccessibility();
        this.setupVisibilityListener();
        this.startCountdown();
    }
    disconnectedCallback() {
        this.stopCountdown();
        this.cleanupListeners();
    }
    /**
   * Parse unit display configuration
   * @param {string} unitsString - 'smart', 'all', or colon-separated units
   * @returns {Object} Parsed unit configuration
   */ parseUnits(unitsString) {
        if (unitsString === "smart") return {
            mode: "smart"
        };
        if (unitsString === "all") return {
            mode: "all",
            units: [
                "weeks",
                "days",
                "hours",
                "minutes",
                "seconds"
            ]
        };
        const units = unitsString.split(":").map((u)=>u.trim());
        const validUnits = [
            "weeks",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        const filteredUnits = units.filter((u)=>validUnits.includes(u));
        if (filteredUnits.length === 0) {
            console.warn("GlobalCountdown: No valid units specified, defaulting to smart mode");
            return {
                mode: "smart"
            };
        }
        return {
            mode: "custom",
            units: filteredUnits
        };
    }
    /**
   * Load translation strings from data attributes
   */ loadTranslations() {
        this.translations = {
            week: this.getAttribute("data-i18n-week") || "Week",
            weeks: this.getAttribute("data-i18n-weeks") || "Weeks",
            day: this.getAttribute("data-i18n-day") || "Day",
            days: this.getAttribute("data-i18n-days") || "Days",
            hour: this.getAttribute("data-i18n-hour") || "Hour",
            hours: this.getAttribute("data-i18n-hours") || "Hours",
            minute: this.getAttribute("data-i18n-minute") || "Minute",
            minutes: this.getAttribute("data-i18n-minutes") || "Minutes",
            second: this.getAttribute("data-i18n-second") || "Second",
            seconds: this.getAttribute("data-i18n-seconds") || "Seconds"
        };
    }
    /**
   * Setup ARIA attributes for accessibility
   */ setupAccessibility() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "timer");
        if (!this.hasAttribute("aria-live")) this.setAttribute("aria-live", "polite");
        if (!this.hasAttribute("aria-atomic")) this.setAttribute("aria-atomic", "true");
    }
    /**
   * Setup Page Visibility API listener
   */ setupVisibilityListener() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    /**
   * Cleanup event listeners
   */ cleanupListeners() {
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    /**
   * Handle tab visibility changes (pause/resume)
   */ handleVisibilityChange() {
        if (document.hidden) {
            this.isTabVisible = false;
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null;
            }
        } else {
            this.isTabVisible = true;
            this.startCountdown();
        }
    }
    /**
   * Start the countdown loop
   */ startCountdown() {
        const updateLoop = (timestamp)=>{
            if (!this.isTabVisible) return;
            const remaining = this.endDate - Date.now();
            if (remaining <= 0) {
                this.handleComplete();
                return;
            }
            if (remaining <= 10000 && this.getAttribute("aria-live") !== "assertive") {
                this.setAttribute("aria-live", "assertive");
                this.setAttribute("role", "alert");
            }
            if (timestamp - this.lastUpdateTime >= 1000) {
                this.render(remaining);
                this.lastUpdateTime = timestamp;
            }
            this.animationFrameId = requestAnimationFrame(updateLoop);
        };
        this.animationFrameId = requestAnimationFrame(updateLoop);
    }
    /**
   * Stop the countdown loop
   */ stopCountdown() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }
    /**
   * Calculate time units from milliseconds
   * @param {number} ms - Milliseconds remaining
   * @returns {Object} Time broken down into units
   */ calculateTimeUnits(ms) {
        const weeks = Math.floor(ms / this.msInWeek);
        const days = Math.floor(ms % this.msInWeek / this.msInDay);
        const hours = Math.floor(ms % this.msInDay / this.msInHour);
        const minutes = Math.floor(ms % this.msInHour / this.msInMinute);
        const seconds = Math.floor(ms % this.msInMinute / this.msInSecond);
        return {
            weeks: weeks,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    /**
   * Render countdown display
   * @param {number} ms - Milliseconds remaining
   */ render(ms) {
        const time = this.calculateTimeUnits(ms);
        if (this.units.mode === "smart") this.renderSmart(time);
        else this.renderUnits(time, this.units.units);
    }
    /**
   * Render smart mode (show only most significant unit)
   * @param {Object} time - Time units object
   */ renderSmart(time) {
        let value, unit;
        if (time.weeks > 0) {
            value = time.weeks;
            unit = "week";
        } else if (time.days > 0) {
            value = time.days;
            unit = "day";
        } else if (time.hours > 0) {
            value = time.hours;
            unit = "hour";
        } else if (time.minutes > 0) {
            value = time.minutes;
            unit = "minute";
        } else {
            value = time.seconds;
            unit = "second";
        }
        this.updateDisplay({
            [unit]: value
        });
    }
    /**
   * Render specific units
   * @param {Object} time - Time units object
   * @param {Array} requestedUnits - Units to display
   */ renderUnits(time, requestedUnits) {
        const displayTime = {};
        const unitMap = {
            weeks: time.weeks,
            days: time.days,
            hours: time.hours,
            minutes: time.minutes,
            seconds: time.seconds
        };
        requestedUnits.forEach((unit)=>{
            const singularUnit = unit.replace(/s$/, "");
            displayTime[singularUnit] = unitMap[unit];
        });
        this.updateDisplay(displayTime);
    }
    /**
   * Update DOM with formatted time
   * @param {Object} timeObj - Object with unit keys and values
   */ updateDisplay(timeObj) {
        if (this.textOnly) this.renderTextOnly(timeObj);
        else this.renderVisualDisplay(timeObj);
    }
    /**
   * Render text-only display (localized list format)
   * @param {Object} timeObj - Object with unit keys and values
   */ renderTextOnly(timeObj) {
        const parts = [];
        Object.entries(timeObj).forEach(([unit, value])=>{
            if (this.hideZeroUnits && value === 0) return;
            const formattedValue = this.zeroPad && value < 10 ? `0${value}` : value;
            const translationKey = value === 1 ? unit : `${unit}s`;
            const label = this.translations[translationKey] || unit;
            parts.push(`${formattedValue} ${label}`);
        });
        if (parts.length === 0) {
            this.textContent = "";
            return;
        }
        const locale = document.documentElement.lang || "en";
        if (typeof Intl !== "undefined" && typeof Intl.ListFormat !== "undefined") try {
            const formatter = new Intl.ListFormat(locale, {
                style: "long",
                type: "conjunction"
            });
            this.textContent = formatter.format(parts);
        } catch (error) {
            console.warn("GlobalCountdown: Intl.ListFormat error, using fallback", error);
            this.textContent = parts.join(" ");
        }
        else this.textContent = parts.join(" ");
    }
    /**
   * Render visual display (HTML structure)
   * @param {Object} timeObj - Object with unit keys and values
   */ renderVisualDisplay(timeObj) {
        let html = "";
        Object.entries(timeObj).forEach(([unit, value])=>{
            if (this.hideZeroUnits && value === 0) return;
            const formattedValue = this.zeroPad && value < 10 ? `0${value}` : value;
            const translationKey = value === 1 ? unit : `${unit}s`;
            const label = this.translations[translationKey] || unit;
            const isSecond = unit === "second";
            const ariaHidden = isSecond ? ' aria-hidden="true"' : "";
            html += `
        <span class="countdown__unit" data-unit="${unit}"${ariaHidden}>
          <strong class="countdown__value" data-value>${formattedValue}</strong>
          <span class="countdown__label" data-label>${label}</span>
        </span>
      `;
        });
        this.innerHTML = `<div class="countdown__units">${html}</div>`;
    }
    /**
   * Handle countdown completion
   */ handleComplete() {
        this.stopCountdown();
        if (this.hideZero) this.style.display = "none";
        else {
            const zeroTime = this.units.mode === "smart" ? {
                second: 0
            } : this.units.units.reduce((acc, unit)=>{
                acc[unit.replace(/s$/, "")] = 0;
                return acc;
            }, {});
            this.updateDisplay(zeroTime);
        }
        this.dispatchEvent(new CustomEvent("countdown:complete", {
            bubbles: true,
            detail: {
                endDate: this.endDate
            }
        }));
    }
}
if (!customElements.get("global-countdown")) customElements.define("global-countdown", $be36d76f30f554f6$var$GlobalCountdown);


if (!customElements.get("style-guide")) {
    class StyleGuide extends HTMLElement {
        constructor(){
            super();
            this.setEventListeners();
            this.startGuide();
        }
        async startGuide() {
            this.intro = this.querySelector(".question-and-answer-wrap[data-step='0']");
            this.totalSteps = this.getAttribute("data-total-steps");
            this.questionIndex = 0;
            this.targetCollection = this.getAttribute("data-target-collection");
            this.redirectDelay = this.getAttribute("data-redirect-delay");
            this.typeDelay = this.getAttribute("data-type-delay");
            document.querySelector("body").style.overflow = "hidden"; // remove scroll on body
            this.intro.classList.add("ready");
            await this.showText(this.intro); // Wait for intro text to finish
            this.startStep(1); // Then start step 1
        }
        setEventListeners() {
            this.querySelectorAll(".answer").forEach((answer)=>{
                answer.addEventListener("click", this.selectOption.bind(this));
            });
            this.querySelector(".close-icon").addEventListener("click", this.returnToPreviousPage);
        }
        selectOption(event) {
            const selectedOption = event.target.closest(".answer");
            const optionQuestion = event.target.closest(".question-and-answer-wrap");
            const optionQuestionIndex = optionQuestion.getAttribute("data-step");
            // deselect all other option in this question
            optionQuestion.querySelectorAll(".answer").forEach((option)=>{
                option.classList.remove("selected");
            });
            // select the clicked option
            selectedOption.classList.add("selected");
            // start the next step if the option that is changed is part of the last question that has been opened
            if (parseInt(optionQuestionIndex) == this.questionIndex) {
                const newProgress = this.questionIndex * (90 / this.totalSteps) + 10 + "%";
                this.style.setProperty("--progress", newProgress);
                if (this.questionIndex == this.totalSteps) this.completeGuide();
                else this.startStep(this.questionIndex + 1);
            }
        }
        async startStep(index) {
            this.questionIndex = index;
            const questionWrap = this.querySelector(".question-and-answer-wrap[data-step='" + index + "']");
            const answersWrap = questionWrap.querySelector(".answers-wrap");
            const scrollWrap = document.querySelector(".style-guide__questions-wrapper");
            questionWrap.classList.add("ready");
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            await this.showText(questionWrap); // Wait for each text in step 1 to show one by one
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            answersWrap.classList.add("ready"); // then show the answer options
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            window.scrollBy(0, 48); // Scroll 3rem (48px) further after block end
        }
        async showText(elem) {
            elem.textStrings = elem.querySelectorAll("[data-text]");
            // Loop through each text string and await its animation one by one
            for (const textString of elem.textStrings)await this.animateText(textString); // Wait for the current text to finish before moving to the next
        }
        // Animate text and return a Promise that resolves when animation completes
        animateText(textString) {
            return new Promise((resolve)=>{
                const text = textString.getAttribute("data-text");
                let index = 0;
                function animateText() {
                    textString.textContent = text.slice(0, index);
                    index++;
                    if (index > text.length) {
                        clearInterval(intervalId); // Stop when the text is fully displayed
                        resolve(); // Resolve when the text animation is complete
                    }
                }
                const intervalId = setInterval(animateText, this.typeDelay);
            });
        }
        completeGuide() {
            // show guide complete message and loading animation
            this.querySelector(".quiz-complete-wrap").classList.add("ready");
            document.querySelector(".style-guide__questions-wrapper").scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            this.querySelectorAll(".animated_dot").forEach((dot)=>{
                dot.style.animationPlayState = "running";
            });
            // create filterURL and redirect after the chosen "loading" delay
            setTimeout(()=>{
                const urlString = this.createFilterURL();
                window.location.href = urlString;
            }, this.redirectDelay);
        }
        createFilterURL() {
            let urlString = "/collections/" + this.targetCollection + "?sort_by=title-ascending";
            let index = 0;
            this.querySelectorAll(".question-and-answer-wrap").forEach((question)=>{
                if (question.querySelector(".answer.selected")) {
                    index++;
                    const filterHandle = question.getAttribute("data-filter-handle");
                    const selectedOptionHandles = question.querySelector(".answer.selected").getAttribute("data-option-handle").split(",");
                    selectedOptionHandles.forEach((handle)=>{
                        const questionString = "&" + filterHandle + "=" + handle;
                        urlString = urlString + questionString;
                    });
                }
            });
            return urlString;
        }
        returnToPreviousPage() {
            window.history.back();
        }
    }
    customElements.define("style-guide", StyleGuide);
}


function $196e129cf5f68d08$var$initWidget(openWidget) {
    const cartWidget = $196e129cf5f68d08$var$getUniqueElement("#cart-widget");
    const openPopupBtn = $196e129cf5f68d08$var$getUniqueElement("#open-popup-button");
    if (!cartWidget || !openPopupBtn) return;
    let cartData = cartWidget.querySelector("[data-cart]")?.dataset?.cart;
    if (!cartData) return;
    else cartData = JSON.parse(cartData);
    const lastAddedProductName = cartData.find((item)=>item.type !== "Accessories")?.title;
    const cartWidgetProductNames = cartWidget.querySelectorAll(".cart__widget__product-name");
    const lastAddedProduct = [
        ...cartWidgetProductNames
    ].find((item)=>{
        if (lastAddedProductName?.includes(item.innerText)) return true;
    });
    const closeBtns = cartWidget.querySelectorAll(".cart__widget__close-button");
    const removeProductBtns = cartWidget.querySelectorAll(".cart__widget__card-x");
    const tabButtons = cartWidget.querySelectorAll(".cart__widget__tab-button");
    const tabContents = cartWidget.querySelectorAll(".cart__widget__tab-content-item");
    const checkoutButtons = cartWidget?.querySelectorAll(".cart__widget__checkout-button");
    $196e129cf5f68d08$var$setDescriptionTextCount(tabContents);
    $196e129cf5f68d08$var$setActiveView(lastAddedProduct, tabButtons, tabContents);
    $196e129cf5f68d08$var$setEventListeners({
        cartWidget: cartWidget,
        tabButtons: tabButtons,
        tabContents: tabContents,
        openPopupBtn: openPopupBtn,
        closeBtns: closeBtns,
        removeProductBtns: removeProductBtns,
        checkoutButtons: checkoutButtons
    });
    if (lastAddedProduct) {
        if (openWidget) $196e129cf5f68d08$var$setActive(cartWidget, false);
        $196e129cf5f68d08$var$setActive(openPopupBtn, true);
    }
    if (!lastAddedProduct) {
        $196e129cf5f68d08$var$setActive(cartWidget, false);
        $196e129cf5f68d08$var$setActive(openPopupBtn, false);
    }
}
function $196e129cf5f68d08$var$setActive(element, enable) {
    if (enable) element.classList.add("active");
    if (!enable) element.classList.remove("active");
}
function $196e129cf5f68d08$var$setWidget(chosenElement, elements) {
    elements.forEach(function(el) {
        $196e129cf5f68d08$var$setActive(el, false);
    });
    $196e129cf5f68d08$var$setActive(chosenElement, true);
}
function $196e129cf5f68d08$var$getUniqueElement(elId) {
    const els = document.querySelectorAll(elId);
    let uniqueEl;
    els.forEach((el, index)=>{
        if (index == 0) uniqueEl = el;
        if (index > 0) el.remove();
    });
    return uniqueEl;
}
function $196e129cf5f68d08$var$setDescriptionTextCount(tabContents) {
    tabContents.forEach((tabContent)=>{
        const emptyBoxes = tabContent.querySelectorAll(".empty")?.length;
        const desc = tabContent.querySelector(".cart__widget__description");
        if (!desc) return;
        const unlockOfferText = desc?.dataset?.unlockText || "";
        const text = desc?.innerText;
        const newText = emptyBoxes && text ? text.replace(/{{\s*count\s*}}/g, emptyBoxes) : unlockOfferText;
        desc.innerText = newText;
    });
}
function $196e129cf5f68d08$var$setActiveView(lastAddedProduct, tabButtons, tabContents) {
    if (!lastAddedProduct || !tabButtons.length || !tabContents.length) return;
    const lastAddedTabContent = lastAddedProduct.closest(".cart__widget__tab-content-item");
    console.log("last added tab content", lastAddedTabContent, lastAddedProduct);
    const lastTabName = lastAddedTabContent?.id;
    const lastTabButton = lastAddedTabContent?.closest(".cart__widget__tab-content")?.previousElementSibling?.querySelector(`[data-tab-target="${lastTabName}"]`);
    if (lastTabButton) $196e129cf5f68d08$var$setWidget(lastTabButton, tabButtons);
    if (lastAddedTabContent) $196e129cf5f68d08$var$setWidget(lastAddedTabContent, tabContents);
}
function $196e129cf5f68d08$var$getProductData(formDataArray) {
    const productData = formDataArray.reduce((acc, [key, value])=>{
        // Extract the index (1, 2, 3) from the key
        const match = key.match(/items\[(\d+)]\[(id|quantity)]/);
        if (match) {
            // index is a number, field is 'id' or 'quantity'
            const [, index, field] = match;
            // Find or create the object for this index
            const existingItem = acc[index - 1] || {
                id: null,
                quantity: null
            };
            existingItem[field] = Number(value);
            // Add obj at the correct index
            acc[index - 1] = existingItem;
        }
        return acc;
    }, []);
    return productData;
}
async function $196e129cf5f68d08$var$addToCart(productData) {
    const requestBody = {
        items: productData
    };
    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody)
        });
        const json = await response.json();
        if (json.items) return {
            success: true
        };
        else return {
            success: false,
            response: json.description
        };
    } catch (error) {
        return {
            success: false,
            response: error
        };
    }
}
function $196e129cf5f68d08$var$setEventListeners({ cartWidget: cartWidget, tabButtons: tabButtons, tabContents: tabContents, openPopupBtn: openPopupBtn, closeBtns: closeBtns, removeProductBtns: removeProductBtns, checkoutButtons: checkoutButtons }) {
    const powerStepForm = cartWidget?.querySelector("#care-package-form");
    const acceptPowerStepBtn = cartWidget?.querySelector(".accept-power-step");
    const errorMessageContainer = cartWidget?.querySelector(".power-step-error-message ");
    powerStepForm?.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const productData = $196e129cf5f68d08$var$getProductData(Array.from(formData));
        $196e129cf5f68d08$var$setActive(errorMessageContainer, false);
        acceptPowerStepBtn.classList.add("loading");
        const resp = await $196e129cf5f68d08$var$addToCart(productData);
        acceptPowerStepBtn.classList.remove("loading");
        if (resp?.success || resp?.response?.includes("You can't add more")) window.location.href = "/checkout";
        else {
            $196e129cf5f68d08$var$setActive(errorMessageContainer, true);
            errorMessageContainer.innerHTML = resp?.response;
        }
    });
    tabButtons.forEach((button)=>{
        button.addEventListener("click", function() {
            const targetId = button.dataset.tabTarget;
            const content = cartWidget.querySelector(`#${targetId}`);
            $196e129cf5f68d08$var$setWidget(button, tabButtons);
            $196e129cf5f68d08$var$setWidget(content, tabContents);
        });
    });
    removeProductBtns.forEach((btn)=>{
        btn.addEventListener("click", function() {
            const openCartBtn = document.querySelector('.cart__toggle[aria-expanded="false"]');
            if (openCartBtn) openCartBtn.click();
            const cartDrawer = document.querySelector("#cart-drawer");
            const productTitle = btn.dataset.productTitle;
            const removeButton = cartDrawer?.querySelector(`[data-item-title="${productTitle}"]`)?.querySelector(".cart__item__remove");
            if (removeButton) removeButton.click();
        });
    });
    checkoutButtons.forEach((checkoutBtn)=>{
        const mainWidgetContent = cartWidget.querySelector(".cart__widget__main-step");
        const powerStepContent = cartWidget.querySelector(".cart__widget__power-step");
        checkoutBtn.addEventListener("click", ()=>{
            const powerProdInCart = cartWidget?.querySelector("[data-power-prod-in-cart]");
            if (powerProdInCart) {
                window.location.href = "/checkout";
                return;
            }
            $196e129cf5f68d08$var$setActive(mainWidgetContent, false);
            $196e129cf5f68d08$var$setActive(powerStepContent, true);
        });
    });
    // Close widget when outside click
    document.addEventListener("click", (e)=>{
        const clickTarget = e.target;
        const isOpenButton = clickTarget?.classList.contains("cart__open-button");
        !cartWidget.contains(clickTarget) && !isOpenButton && $196e129cf5f68d08$var$setActive(cartWidget, false);
    });
    openPopupBtn?.addEventListener("click", ()=>$196e129cf5f68d08$var$setActive(cartWidget, true));
    closeBtns.forEach((closeBtn)=>{
        closeBtn?.addEventListener("click", ()=>$196e129cf5f68d08$var$setActive(cartWidget, false));
    });
}
$196e129cf5f68d08$var$initWidget();
document.addEventListener("cart-widget:updated", (e)=>{
    $196e129cf5f68d08$var$initWidget(e.detail.isSupposedToTriggerWidget);
});


class $2bb81151451f121c$var$ColorSwatches extends HTMLElement {
    constructor(){
        super();
        this.collectionProductWrapper = this.closest(".collection__products");
        this.productGridItem = this.closest(".product-grid-item");
        this.originalSwatches = this.productGridItem.querySelector(".original-swatches color-swatches");
        this.limitColorSwatchOptions();
        this.addEventListener("change", this.onColorSwatchChange);
        this.addEventListener("click", this.onColorSwatchClick, true);
    }
    onColorSwatchClick(ev) {
        const swatchLi = ev.target.closest(".connected-product__swatch");
        if (!swatchLi) return;
        if (swatchLi.classList.contains("more-swatch")) return;
        ev.preventDefault();
        ev.stopPropagation();
        const input = swatchLi.querySelector("input");
        if (input) this.onColorSwatchChange({
            target: input
        });
    }
    onColorSwatchChange(ev) {
        let currentSwatch = ev.target;
        if (currentSwatch.tagName !== "INPUT") currentSwatch = currentSwatch.querySelector("input");
        if (!currentSwatch) return;
        this.updateMasterDataset(currentSwatch);
        if (this.variantId) this.renderProduct(currentSwatch);
    }
    limitColorSwatchOptions() {
        const limit = 4;
        const allColorSwatchOptions = this.querySelectorAll("li.connected-product__swatch");
        if (!allColorSwatchOptions) return;
        const allColorSwatchLen = allColorSwatchOptions.length;
        if (allColorSwatchLen <= limit) return;
        const swatchArray = Array.from(allColorSwatchOptions);
        const excessSwatches = swatchArray.slice(limit);
        excessSwatches.forEach((swatch)=>swatch.remove());
        const moreSwatch = document.createElement("li");
        moreSwatch.className = "connected-product__swatch more-swatch";
        moreSwatch.textContent = "+";
        swatchArray[limit - 1].parentNode.appendChild(moreSwatch);
    }
    updateProductOptions() {
        try {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            if (!fieldsets) return;
            this.options = fieldsets.map((fieldset)=>{
                return {
                    value: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value,
                    connectedProductId: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.connectedProductId,
                    connectedProductHandle: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.handle
                };
            });
        } catch (e) {
            console.warn("error:", e);
        }
    }
    updateMasterDataset(currentSwatch) {
        this.productId = currentSwatch.dataset.connectedProductId;
        this.variantId = currentSwatch.dataset.connectedVariantId;
        this.productHandle = currentSwatch.dataset.handle;
    }
    async renderProduct(currentSwatch) {
        try {
            const response = await fetch(`/products/${this.productHandle}?section_id=product-grid-item-section`);
            const responseText = await response.text();
            const parsedHtml = new DOMParser().parseFromString(responseText, "text/html");
            const productGridItem = parsedHtml.querySelector(".product-grid-item .product-grid-item__inner ");
            this.renderNewSwatches(productGridItem, currentSwatch);
        } catch (error) {
            console.error("Error fetching product data", error);
        }
    }
    renderNewSwatches(productGridItem, currentSwatch) {
        const newGridItem = this.closest(".product-grid-item .product-grid-item__inner");
        newGridItem.innerHTML = productGridItem.innerHTML;
        const newColorSwatches = newGridItem.querySelector("color-swatches");
        newColorSwatches.innerHTML = this.originalSwatches.innerHTML;
        newColorSwatches.limitColorSwatchOptions();
        this.activateSwatch(newColorSwatches, currentSwatch);
    }
    activateSwatch(newColorSwatches, currentSwatch) {
        const currentSwatchVariantId = currentSwatch.dataset.connectedVariantId;
        const newColorSwatchesElements = newColorSwatches.querySelectorAll("li input");
        newColorSwatchesElements.forEach((swatch)=>{
            swatch.classList.remove("selected");
        });
        const newColorSwatchesElementsArray = [
            ...newColorSwatchesElements
        ];
        newColorSwatchesElementsArray.find((swatch)=>swatch.dataset.connectedVariantId === currentSwatchVariantId).classList.add("selected");
    }
}
$2bb81151451f121c$var$ColorSwatches.productData = [];
customElements.define("color-swatches", $2bb81151451f121c$var$ColorSwatches);
document.addEventListener("click", function(ev) {
    var target = ev.target.closest(".more-swatch");
    if (!target) return;
    var link = target.closest(".product-grid-item")?.querySelector('a[href*="/products/"]');
    if (link?.href) window.location.href = link.href;
}, true);


(function() {
    function updateFilterCount() {
        const urlParams = new URLSearchParams(window.location.search);
        let filterCount = 0;
        for (const [key, value] of urlParams.entries())if (key !== "sort_by" && key !== "page" && key !== "view" && key !== "filter.v.availability") filterCount++;
        const filtersToggle = document.querySelector("[data-toggle-filters]");
        if (filtersToggle) {
            let buttonText = filtersToggle.innerHTML;
            if (filterCount === 0) buttonText = buttonText.replace(/\s*$$\d+$$/, "");
            else if (buttonText.includes("(")) buttonText = buttonText.replace(/$$\d+$$/, `(${filterCount})`);
            else buttonText = buttonText.replace(/<span>(.+?)<\/span>/, `<span>$1</span> (${filterCount})`);
            filtersToggle.innerHTML = buttonText;
        }
        return filterCount;
    }
    window.updateFilterCount = updateFilterCount;
    document.addEventListener("DOMContentLoaded", updateFilterCount);
    document.addEventListener("ajaxComplete", updateFilterCount);
    let lastUrl = window.location.href;
    setInterval(function() {
        if (lastUrl !== window.location.href) {
            lastUrl = window.location.href;
            updateFilterCount();
        }
    }, 100);
    updateFilterCount();
})();


/**
 * Filtered Product List Web Component
 *
 * Dynamically loads and filters products via Shopify Section Rendering API
 * Replaces skeleton cards with real products based on liquid filter parameters
 */ class $af4a55e1509d5ac0$var$FilteredProductList extends HTMLElement {
    constructor(){
        super();
        this.observer = null;
        this.hasLoaded = false;
    }
    connectedCallback() {
        this.sectionId = this.getAttribute("section-id");
        this.collectionUrl = this.getAttribute("collection-url");
        this.parameters = new URLSearchParams();
        this.productId = this.getAttribute("product-id");
        this.minimumVisible = Number(this.getAttribute("minimum-visible")) || 0;
        this.maximumVisible = Number(this.getAttribute("maximum-visible")) || 20;
        if (Number.isNaN(this.minimumVisible)) this.minimumVisible = 0;
        // Parse filter parameters from liquid output
        const filterString = this.getAttribute("filters")?.trim() || "";
        const filterParameters = filterString.split(",").filter((param)=>param.trim());
        for (const param of filterParameters){
            const [key, value] = param.split("=");
            if (!key || !value) continue;
            this.parameters.append(key.trim(), value.trim());
        }
        // Add required parameters
        this.parameters.set("section_id", this.sectionId);
        this.parameters.set("filter.v.availability", "1"); // Only show available products
        // Only setup observer if we have filters to apply
        if (filterParameters.length > 0) this.setupObserver();
    }
    setupObserver() {
        const options = {
            root: null,
            rootMargin: "20% 0px",
            threshold: 0
        };
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.hasLoaded) {
                    this.hasLoaded = true;
                    this.loadContent();
                    this.observer.disconnect();
                }
            });
        }, options);
        this.observer.observe(this);
    }
    /**
   * Helper: Find product cards in the document using multiple selector strategies
   */ findProductCards(doc) {
        const selectors = [
            ".product-grid-item",
            "[data-product-block]",
            ".grid__item",
            ".carousel__item"
        ];
        for (const selector of selectors){
            const cards = doc.querySelectorAll(selector);
            if (cards.length > 0) {
                // Filter to ensure we only get actual product cards, not promo blocks
                const productCards = [
                    ...cards
                ].filter((card)=>{
                    // Exclude promo blocks (they never have product-grid-item class)
                    if (card.classList.contains("collection-promo") || card.hasAttribute("data-promo")) return false;
                    // Must have product-grid-item class or data-product-block attribute
                    return card.classList.contains("product-grid-item") || card.hasAttribute("data-product-block");
                });
                if (productCards.length > 0) return productCards;
            }
        }
        console.warn("No product cards found in response");
        return [];
    }
    /**
   * Helper: Extract product ID from a product card element
   * Product cards have ID format: "product-item--{section-id}-{product-id}"
   */ getProductIdFromCard(card) {
        // Try to get product ID from the card's ID attribute
        // Format: "product-item--{section-id}-{product-id}"
        const cardId = card.id;
        if (cardId && cardId.startsWith("product-item--")) {
            const parts = cardId.split("-");
            const productId = parts[parts.length - 1];
            if (productId) return productId;
        }
        // Fallback: Look for product form with data-product-form
        const productForm = card.querySelector("[data-product-form]");
        if (productForm && productForm.id) {
            // Form ID format: "{section-id}-{product-id}"
            const formParts = productForm.id.split("-");
            const productId = formParts[formParts.length - 1];
            if (productId) return productId;
        }
        // Fallback: Look for product link
        const productLink = card.querySelector('a[href*="/products/"]');
        if (productLink) {
            const href = productLink.getAttribute("href");
            const match = href.match(/\/products\/([^?#]+)/);
            if (match) return match[1]; // Return product handle
        }
        return null;
    }
    /**
   * Helper: Preserve static content elements before DOM replacement
   * Finds all elements with data-static attribute and stores their outerHTML
   * @param {Element} container - The container to search for static elements
   * @returns {Map} Map of data-static keys to outerHTML strings
   */ preserveStaticContent(container) {
        const staticElements = container.querySelectorAll("[data-static]");
        const preserved = new Map();
        staticElements.forEach((element)=>{
            const key = element.getAttribute("data-static");
            if (key) preserved.set(key, element.outerHTML);
        });
        return preserved;
    }
    /**
   * Helper: Restore static content elements after DOM replacement
   * Finds all elements with data-static attribute and replaces them with preserved content
   * @param {Element} container - The container to search for static elements
   * @param {Map} preserved - Map of data-static keys to outerHTML strings
   */ restoreStaticContent(container, preserved) {
        if (!preserved || preserved.size === 0) return;
        const staticElements = container.querySelectorAll("[data-static]");
        staticElements.forEach((element)=>{
            const key = element.getAttribute("data-static");
            if (key && preserved.has(key)) element.outerHTML = preserved.get(key);
        });
    }
    /**
   * Helper: Update collection links with filter parameters
   * Updates the view all button and heading link hrefs with filter query params
   * @param {Element} container - The container to search for links
   */ updateCollectionLinks(container) {
        // Build filter query string (without section_id)
        const params = new URLSearchParams(this.parameters);
        params.delete("section_id");
        const filterQuery = params.toString();
        if (!filterQuery) return;
        // Update all view all buttons (desktop + mobile)
        const viewAllButtons = container.querySelectorAll(".btn--view-all");
        viewAllButtons.forEach((button)=>{
            button.href = `${this.collectionUrl}?${filterQuery}`;
        });
        // Update heading link if it exists
        const headingLink = container.querySelector(".section__link");
        if (headingLink) headingLink.href = `${this.collectionUrl}?${filterQuery}`;
    }
    async loadContent() {
        try {
            const url = `${this.collectionUrl}?${this.parameters.toString()}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const html = await response.text();
            const shopifySection = this.closest(".shopify-section");
            if (!shopifySection) {
                console.error("Could not find .shopify-section container");
                return;
            }
            // Parse the response HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            // Find product cards using dynamic selector
            const productCards = this.findProductCards(doc);
            if (productCards.length === 0) {
                console.error("No products found in Section Rendering API response");
                this.hideSection();
                return;
            }
            // Count actual products (excluding current product if on PDP)
            let validProductCount = productCards.length;
            // Remove current product from the list if on PDP
            if (this.productId) {
                const currentProductIndex = productCards.findIndex((card)=>{
                    const cardProductId = this.getProductIdFromCard(card);
                    return cardProductId && cardProductId === this.productId;
                });
                if (currentProductIndex !== -1) {
                    const productToRemove = productCards[currentProductIndex];
                    // The product card itself IS the grid/carousel item
                    productToRemove.remove();
                    productCards.splice(currentProductIndex, 1);
                    validProductCount--;
                }
            }
            // Limit to maximum visible products if needed
            if (validProductCount > this.maximumVisible) {
                const cardsToRemove = productCards.slice(this.maximumVisible);
                cardsToRemove.forEach((card)=>{
                    // The product card itself IS the grid/carousel item
                    card.remove();
                });
                validProductCount = this.maximumVisible;
            }
            // Check if we have enough products to show
            if (validProductCount < this.minimumVisible) {
                this.hideSection();
                return;
            }
            // Find the section container (with data-section-type attribute)
            const sectionContainer = shopifySection.querySelector('[data-section-type="filtered-collection"]');
            const newSectionContainer = doc.querySelector('[data-section-type="filtered-collection"]');
            if (!sectionContainer || !newSectionContainer) {
                console.error("Could not find section containers");
                return;
            }
            // Get the section instance from Shopify's section management system
            const instance = window.Shopify?.theme?.sections?.instances?.find((inst)=>inst.id === this.sectionId) || null;
            // Preserve static content (e.g., product-specific headings) before replacement
            const preservedContent = this.preserveStaticContent(sectionContainer);
            // Unload the old section instance (cleanup carousels, etc.)
            if (instance && typeof instance.onUnload === "function") instance.onUnload();
            // Replace the content (preserves the section container)
            sectionContainer.innerHTML = newSectionContainer.innerHTML;
            // Restore static content (e.g., product-specific headings) after replacement
            this.restoreStaticContent(sectionContainer, preservedContent);
            // Update collection links with filter parameters (after static restoration)
            this.updateCollectionLinks(sectionContainer);
            // Reload the section instance (reinitialize carousels, etc.)
            if (instance && typeof instance.onLoad === "function") instance.onLoad();
            // Dispatch event for other features to reinitialize (e.g., sticky product)
            this.reinitializeScripts();
        } catch (error) {
            console.error("Failed to load filtered products:", error);
            // On error, hide the section gracefully
            this.hideSection();
        }
    }
    hideSection() {
        const shopifySection = this.closest(".shopify-section");
        if (shopifySection) shopifySection.style.display = "none";
    }
    reinitializeScripts() {
        // Reinitialize AOS (Animate On Scroll) if present
        if (window.AOS) window.AOS.refresh();
        // Dispatch custom event for other scripts to hook into
        document.dispatchEvent(new CustomEvent("filtered-product-list:loaded", {
            detail: {
                sectionId: this.sectionId
            }
        }));
    }
    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }
}
// Register the custom element
if (!customElements.get("filtered-product-list")) customElements.define("filtered-product-list", $af4a55e1509d5ac0$var$FilteredProductList);
var $af4a55e1509d5ac0$export$2e2bcd8739ae039 = $af4a55e1509d5ac0$var$FilteredProductList;


const $b8e7a5ff257b7361$var$KLAVIYO_REVISION = "2024-06-15";
const $b8e7a5ff257b7361$var$KLAVIYO_CLIENT_SUBSCRIPTION_REVISION = "2024-10-15";
function $b8e7a5ff257b7361$var$getConfig() {
    return window.klaviyoBackInStockConfig || null;
}
function $b8e7a5ff257b7361$var$getKlaviyoHeaders(revision = $b8e7a5ff257b7361$var$KLAVIYO_REVISION) {
    return {
        "Content-Type": "application/json",
        revision: revision
    };
}
function $b8e7a5ff257b7361$var$isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function $b8e7a5ff257b7361$var$buildShopifyVariantId(variantId) {
    return `$shopify:::$default:::${variantId}`;
}
async function $b8e7a5ff257b7361$var$parseKlaviyoResponse(response) {
    const text = await response.text();
    if (!text) return {
        data: null
    };
    try {
        return {
            data: JSON.parse(text)
        };
    } catch  {
        return {
            data: null
        };
    }
}
function $b8e7a5ff257b7361$var$getErrorDetail(errors, fallback) {
    return errors?.[0]?.detail || fallback;
}
async function $b8e7a5ff257b7361$var$subscribeToBackInStock({ accountId: accountId, email: email, variantId: variantId }) {
    const payload = {
        data: {
            type: "back-in-stock-subscription",
            attributes: {
                channels: [
                    "EMAIL"
                ],
                profile: {
                    data: {
                        type: "profile",
                        attributes: {
                            email: email
                        }
                    }
                }
            },
            relationships: {
                variant: {
                    data: {
                        type: "catalog-variant",
                        id: $b8e7a5ff257b7361$var$buildShopifyVariantId(variantId)
                    }
                }
            }
        }
    };
    const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(accountId)}`, {
        method: "POST",
        headers: $b8e7a5ff257b7361$var$getKlaviyoHeaders(),
        body: JSON.stringify(payload)
    });
    if (response.status === 202) return {
        success: true
    };
    const { data: data } = await $b8e7a5ff257b7361$var$parseKlaviyoResponse(response);
    const firstError = data?.errors?.[0];
    return {
        success: false,
        error: $b8e7a5ff257b7361$var$getErrorDetail(data?.errors),
        code: firstError?.code
    };
}
function $b8e7a5ff257b7361$var$isVariantNotFoundError(result) {
    const error = result?.error?.toLowerCase() || "";
    return result?.code === "variant_not_found" || error.includes("variant") && error.includes("does not exist");
}
async function $b8e7a5ff257b7361$var$subscribeToBackInStockWithFallback({ accountId: accountId, email: email, variantIds: variantIds }) {
    const uniqueIds = [
        ...new Set(variantIds.filter(Boolean).map(String))
    ];
    let lastResult = {
        success: false
    };
    for (const variantId of uniqueIds){
        const result = await $b8e7a5ff257b7361$var$subscribeToBackInStock({
            accountId: accountId,
            email: email,
            variantId: variantId
        });
        if (result.success) return result;
        lastResult = result;
        if (!$b8e7a5ff257b7361$var$isVariantNotFoundError(result)) break;
    }
    return lastResult;
}
function $b8e7a5ff257b7361$var$normalizeListId(listId) {
    const id = String(listId || "").trim();
    return id || null;
}
function $b8e7a5ff257b7361$var$buildListSubscribePayload(email, listId) {
    return {
        data: {
            type: "subscription",
            attributes: {
                custom_source: "Back in stock",
                profile: {
                    data: {
                        type: "profile",
                        attributes: {
                            email: email
                        }
                    }
                }
            },
            relationships: {
                list: {
                    data: {
                        type: "list",
                        id: listId
                    }
                }
            }
        }
    };
}
async function $b8e7a5ff257b7361$var$subscribeToList({ accountId: accountId, email: email, listId: listId }) {
    const normalizedListId = $b8e7a5ff257b7361$var$normalizeListId(listId);
    if (!normalizedListId) return {
        success: true,
        skipped: true
    };
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(accountId)}`, {
        method: "POST",
        headers: $b8e7a5ff257b7361$var$getKlaviyoHeaders($b8e7a5ff257b7361$var$KLAVIYO_CLIENT_SUBSCRIPTION_REVISION),
        body: JSON.stringify($b8e7a5ff257b7361$var$buildListSubscribePayload(email, normalizedListId))
    });
    if (response.status === 202) return {
        success: true
    };
    const { data: data } = await $b8e7a5ff257b7361$var$parseKlaviyoResponse(response);
    const error = $b8e7a5ff257b7361$var$getErrorDetail(data?.errors);
    return {
        success: false,
        error: error
    };
}
class $b8e7a5ff257b7361$var$BackInStockForm extends HTMLElement {
    connectedCallback() {
        this.config = $b8e7a5ff257b7361$var$getConfig();
        if (!this.config?.accountId) return;
        this.fields = this.querySelector(".product__back-in-stock__fields");
        this.emailInput = this.querySelector("[data-bis-email]");
        this.submitBtn = this.querySelector("[data-bis-submit]");
        this.variantInput = this.querySelector("[data-bis-variant-id]");
        this.newsletterCheckbox = this.querySelector("[data-bis-newsletter]");
        this.confirmation = this.querySelector("[data-bis-confirmation]");
        this.errorMessage = this.querySelector("[data-bis-error]");
        this.emailError = this.querySelector("[data-bis-email-error]");
        this.defaultErrorText = this.errorMessage?.textContent?.trim() || "";
        this.isSubmitting = false;
        this.onSubmit = this.onSubmit.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onProductSelectChange = this.onProductSelectChange.bind(this);
        this.onEmailInput = this.onEmailInput.bind(this);
        this.stopParentFormSubmit = this.stopParentFormSubmit.bind(this);
        this.productSection = this.closest('[data-section-type="product-template"]') || this.closest(".shopify-section--product");
        this.submitBtn?.addEventListener("click", this.onSubmit);
        this.emailInput?.addEventListener("input", this.onEmailInput);
        this.emailInput?.addEventListener("change", this.onEmailInput);
        this.updateSubmitState();
        this.emailInput?.addEventListener("keydown", (event)=>{
            if (event.key !== "Enter") return;
            event.preventDefault();
            event.stopPropagation();
            if (!this.submitBtn?.disabled) this.onSubmit(event);
        });
        this.productForm = this.closest('form[action*="/cart/add"]');
        const productSelect = this.productForm?.querySelector("[data-product-select]");
        this.lastSelectorVariantId = String(productSelect?.value || this.variantInput?.value || "");
        this.productForm?.addEventListener("submit", this.stopParentFormSubmit);
        this.productForm?.addEventListener("change", this.onProductSelectChange);
        this.productSection?.addEventListener("theme:variant:change", this.onVariantChange);
        document.addEventListener("theme:variant:change", this.onVariantChange);
    }
    disconnectedCallback() {
        this.submitBtn?.removeEventListener("click", this.onSubmit);
        this.emailInput?.removeEventListener("input", this.onEmailInput);
        this.emailInput?.removeEventListener("change", this.onEmailInput);
        this.productForm?.removeEventListener("submit", this.stopParentFormSubmit);
        this.productForm?.removeEventListener("change", this.onProductSelectChange);
        this.productSection?.removeEventListener("theme:variant:change", this.onVariantChange);
        document.removeEventListener("theme:variant:change", this.onVariantChange);
    }
    stopParentFormSubmit(event) {
        if (!this.contains(document.activeElement)) return;
        event.preventDefault();
        event.stopPropagation();
    }
    getVariantIdsToTry() {
        const ids = [];
        if (this.dataset.pageVariantId) ids.push(this.dataset.pageVariantId);
        if (this.cartVariantId) ids.push(this.cartVariantId);
        const currentId = this.variantInput?.value;
        if (currentId) ids.push(currentId);
        return [
            ...new Set(ids.map(String))
        ];
    }
    isEventForThisProduct(event) {
        if (!this.productSection) return true;
        const target = event.target;
        if (!target) return false;
        return target === this.productSection || this.productSection.contains(target);
    }
    updateActiveVariant(variant) {
        if (!variant?.id) return;
        const variantId = String(variant.id);
        this.cartVariantId = variantId;
        if (this.dataset.pageVariantId) {
            if (this.variantInput) this.variantInput.value = this.dataset.pageVariantId;
        } else if (this.variantInput) this.variantInput.value = variantId;
    }
    onVariantChange(event) {
        if (!this.isEventForThisProduct(event)) return;
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        const nextVariantId = String(variant.id);
        if (nextVariantId === this.lastSelectorVariantId) return;
        this.lastSelectorVariantId = nextVariantId;
        this.updateActiveVariant(variant);
        this.resetForm();
    }
    onProductSelectChange(event) {
        const select = event.target?.matches?.("[data-product-select]") ? event.target : event.target?.closest?.("[data-product-select]");
        if (!select || !this.productForm?.contains(select)) return;
        const nextVariantId = String(select.value || "");
        if (!nextVariantId || nextVariantId === this.lastSelectorVariantId) return;
        this.lastSelectorVariantId = nextVariantId;
        this.updateActiveVariant({
            id: nextVariantId
        });
        this.resetForm();
    }
    updateSubmitState() {
        if (!this.submitBtn) return;
        if (this.isSubmitting) {
            this.submitBtn.disabled = true;
            return;
        }
        const email = this.emailInput?.value?.trim() || "";
        this.submitBtn.disabled = !$b8e7a5ff257b7361$var$isValidEmail(email);
    }
    showEmailError() {
        this.emailError?.removeAttribute("hidden");
        this.emailInput?.setAttribute("aria-invalid", "true");
    }
    hideEmailError() {
        this.emailError?.setAttribute("hidden", "");
        this.emailInput?.removeAttribute("aria-invalid");
    }
    onEmailInput() {
        this.hideEmailError();
        this.updateSubmitState();
    }
    resetForm() {
        this.classList.remove("is-success");
        this.confirmation?.setAttribute("hidden", "");
        this.errorMessage?.setAttribute("hidden", "");
        this.hideEmailError();
        this.setLoading(false);
        if (this.errorMessage) this.errorMessage.textContent = this.defaultErrorText;
    }
    resetMessages() {
        this.resetForm();
    }
    setLoading(loading) {
        this.submitBtn?.classList.toggle("is-loading", loading);
        this.isSubmitting = loading;
        this.updateSubmitState();
    }
    showError(message) {
        if (this.errorMessage) {
            this.errorMessage.textContent = message || this.defaultErrorText;
            this.errorMessage.removeAttribute("hidden");
        }
        this.confirmation?.setAttribute("hidden", "");
    }
    showSuccess() {
        this.classList.add("is-success");
        this.confirmation?.removeAttribute("hidden");
        this.errorMessage?.setAttribute("hidden", "");
    }
    async onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const config = this.config || $b8e7a5ff257b7361$var$getConfig();
        if (!config?.accountId || !this.emailInput || !this.variantInput) return;
        const email = this.emailInput.value.trim();
        const variantId = this.variantInput.value;
        if (!email || !$b8e7a5ff257b7361$var$isValidEmail(email)) {
            this.showEmailError();
            this.emailInput?.focus();
            return;
        }
        this.resetMessages();
        this.setLoading(true);
        try {
            const variantIds = this.getVariantIdsToTry();
            const bisResult = await $b8e7a5ff257b7361$var$subscribeToBackInStockWithFallback({
                accountId: config.accountId,
                email: email,
                variantIds: variantIds.length ? variantIds : [
                    variantId
                ]
            });
            if (!bisResult.success) {
                this.showError(bisResult.error);
                return;
            }
            this.hideEmailError();
            if (this.newsletterCheckbox?.checked) {
                const listResult = await $b8e7a5ff257b7361$var$subscribeToList({
                    accountId: config.accountId,
                    email: email,
                    listId: config.listId
                });
                if (!listResult.success && !listResult.skipped) console.warn("[back-in-stock] Newsletter list subscribe failed:", listResult.error, {
                    listId: $b8e7a5ff257b7361$var$normalizeListId(config.listId),
                    accountId: config.accountId
                });
            }
            this.showSuccess();
        } catch  {
            this.showError();
        } finally{
            this.setLoading(false);
        }
    }
}
if (!customElements.get("back-in-stock-form")) customElements.define("back-in-stock-form", $b8e7a5ff257b7361$var$BackInStockForm);




document.addEventListener("DOMContentLoaded", ()=>{
    const menuContainer = document.getElementById("nav-drawer__container");
    const submenuToggles = document.querySelectorAll(".nav-drawer__submenu-toggle");
    const backButton = document.querySelector(".nav-drawer__back-to-menu");
    const drawerLogo = document.querySelector(".drawer__title");
    const menuTitle = document.querySelector(".drawer__menu-title");
    const secondaryMenu = document.querySelector(".nav-drawer__menu-secondary");
    const updateContainerHeight = (menu)=>{
        const height = menu.scrollHeight;
        menuContainer.style.height = `${height}px`;
    };
    const resizeObserver = new ResizeObserver(()=>{
        updateContainerHeight(document.querySelector(".nav-drawer__level.active"));
    });
    resizeObserver.observe(menuContainer);
    submenuToggles.forEach((toggle)=>{
        toggle.addEventListener("click", (e)=>{
            const target = document.getElementById(e.currentTarget.dataset.target);
            const currentMenu = e.currentTarget.dataset.menuTitle;
            document.querySelector(".nav-drawer__level.active").classList.remove("active");
            drawerLogo?.classList.remove("active");
            target.classList.add("active");
            backButton.classList.add("active");
            updateContainerHeight(target);
            menuTitle.classList.remove("hidden");
            menuTitle.textContent = currentMenu;
        });
    });
    backButton.addEventListener("click", (e)=>{
        const target = document.getElementById(e.currentTarget.dataset.target);
        document.querySelector(".nav-drawer__level.active").classList.remove("active");
        backButton.classList.remove("active");
        drawerLogo?.classList.add("active");
        target.classList.add("active");
        menuTitle.classList.add("hidden");
        setTimeout(()=>{
            updateContainerHeight(target);
        }, 100);
    });
});


/**
 * Power step: the 3-for-2 bundle step that opens after add to cart on product pages.
 *
 * Document events, all bubbling CustomEvents:
 * - `power-step:opened` — detail `{ productId, variantId, strength, cartItemCount }`.
 *   Fired once the power step is shown for the added line.
 * - `power-step:strength-changed` — detail `{ strength, previous, swapped }`.
 *   Fired when the active strength changes; `swapped` is true when cart lines were changed too.
 * - `power-step:purchase` — detail `{ items, count }`.
 *   Fired after the staged items were added to the cart, before the checkout redirect.
 */ 
var $iqkY1 = parcelRequire("iqkY1");
/**
 * The strength a customer last bought at, kept so a product page opens at their
 * strength and does not ask again.
 *
 * The key holds one option value, e.g. "+2.0". It does not expire: a reading
 * strength changes over years, and the value is corrected as soon as the
 * customer buys at another strength. An expiry sends a returning customer back
 * to the wrong strength for no gain.
 *
 * snippets/preferred-strength.liquid reads the key. Change the two together.
 */ const $ca0af4416dd94155$export$5c10a2ef1e6d4d96 = "preferred_strength";
function $ca0af4416dd94155$var$localStorageOrNull() {
    try {
        return window.localStorage;
    } catch (error) {
        return null;
    }
}
function $ca0af4416dd94155$export$c9971476af11ad57(strength, storage = $ca0af4416dd94155$var$localStorageOrNull()) {
    if (!strength) return;
    try {
        storage?.setItem($ca0af4416dd94155$export$5c10a2ef1e6d4d96, strength);
    } catch (error) {
    // Safari private mode refuses to write. The preference is a convenience only.
    }
}


const $51f958ce30b62b80$export$4140309872475f50 = 3;
const $51f958ce30b62b80$export$bc90872e265d166e = 6;
const $51f958ce30b62b80$export$639f367bc3559851 = "power-step";
/**
 * @typedef {Object} CartLine
 * @property {string} key - Shopify line item key
 * @property {number} variantId
 * @property {number} productId
 * @property {number} quantity
 * @property {string|null} strength - Strength option value, e.g. "+2"
 * @property {string|null} collection - Glasses collection metafield value
 * @property {Object} [properties] - Line item properties
 * @property {string} [title]
 * @property {string} [image]
 */ /**
 * @typedef {Object} Product
 * @property {number} productId
 * @property {number} variantId - Variant at the active strength
 * @property {string} title
 * @property {string} image
 * @property {string} [model] - Glasses model metafield value
 * @property {boolean} [available] - Variant at the active strength is in stock
 */ /** @typedef {{ variantId: number, productId: number }} AddedLine */ /** @typedef {{ strength: string|null, variantId: number }} StagedPair */ /**
 * @typedef {Object<number, StagedPair[]>} Staged - Staged pairs per product id, oldest first.
 * Each pair holds the strength it was staged at, so a later strength change
 * leaves it where the customer put it.
 */ function $51f958ce30b62b80$var$quantityOf(lines, predicate = ()=>true) {
    return lines.filter(predicate).reduce((total, line)=>total + line.quantity, 0);
}
function $51f958ce30b62b80$export$877cf27532547c5a(cartLines, addedLine) {
    return cartLines.find((line)=>line.variantId === addedLine.variantId) || null;
}
function $51f958ce30b62b80$var$linesInCollection(cartLines, addedLine) {
    const added = $51f958ce30b62b80$export$877cf27532547c5a(cartLines, addedLine);
    if (!added || !added.collection) return [];
    return cartLines.filter((line)=>line.collection === added.collection);
}
function $51f958ce30b62b80$var$stagedPairs(staged, productId) {
    return staged[productId] || [];
}
function $51f958ce30b62b80$var$stagedQuantity(staged, productId) {
    return $51f958ce30b62b80$var$stagedPairs(staged, productId).length;
}
function $51f958ce30b62b80$export$46e2bf5b109a972e(staged, product, strength) {
    const pairs = [
        ...$51f958ce30b62b80$var$stagedPairs(staged, product.productId),
        {
            strength: strength,
            variantId: product.variantId
        }
    ];
    return {
        ...staged,
        [product.productId]: pairs
    };
}
function $51f958ce30b62b80$export$d22c1ab0de84ea1b(staged, productId) {
    const pairs = $51f958ce30b62b80$var$stagedPairs(staged, productId).slice(0, -1);
    const next = {
        ...staged
    };
    if (pairs.length > 0) next[productId] = pairs;
    else delete next[productId];
    return next;
}
// Plus has no cap: the bundle is three pairs, but a customer can build a larger
// order. Minus stays open on the staged pairs only, so a pair already in the
// cart cannot be removed here.
function $51f958ce30b62b80$var$deriveCards(products, cartLines, staged) {
    return products.map((product)=>{
        const floor = $51f958ce30b62b80$var$quantityOf(cartLines, (line)=>line.productId === product.productId);
        const stagedCount = $51f958ce30b62b80$var$stagedQuantity(staged, product.productId);
        return {
            product: product,
            quantity: floor + stagedCount,
            floor: floor,
            minusEnabled: stagedCount > 0,
            plusEnabled: true
        };
    });
}
function $51f958ce30b62b80$var$repeat(entry, times) {
    return Array.from({
        length: times
    }, ()=>({
            ...entry
        }));
}
function $51f958ce30b62b80$export$ab724b8489ef3956(line, model) {
    return {
        productId: line.productId,
        variantId: line.variantId,
        title: line.title,
        image: line.image,
        model: model
    };
}
function $51f958ce30b62b80$var$productForLine(products, line) {
    return products.find((product)=>product.productId === line.productId) || $51f958ce30b62b80$export$ab724b8489ef3956(line, line.glassesModel);
}
function $51f958ce30b62b80$export$a8a2e6c947191d19({ cartLines: cartLines, addedLine: addedLine }) {
    const seen = new Set([
        addedLine.productId
    ]);
    return $51f958ce30b62b80$var$linesInCollection(cartLines, addedLine).flatMap((line)=>{
        if (seen.has(line.productId)) return [];
        seen.add(line.productId);
        return [
            $51f958ce30b62b80$export$ab724b8489ef3956(line, line.glassesModel)
        ];
    });
}
function $51f958ce30b62b80$export$7dd0ac1224095132(filled) {
    const rows = Math.max(1, Math.ceil(filled / $51f958ce30b62b80$export$4140309872475f50));
    return rows * $51f958ce30b62b80$export$4140309872475f50 - filled;
}
function $51f958ce30b62b80$var$deriveSlots(lines, products, staged) {
    const cartSlots = lines.flatMap((line)=>$51f958ce30b62b80$var$repeat({
            type: "cart",
            product: $51f958ce30b62b80$var$productForLine(products, line),
            strength: line.strength
        }, line.quantity));
    const stagedSlots = products.flatMap((product)=>$51f958ce30b62b80$var$stagedPairs(staged, product.productId).map((pair)=>({
                type: "staged",
                product: product,
                strength: pair.strength
            })));
    const filled = [
        ...cartSlots,
        ...stagedSlots
    ];
    return [
        ...filled,
        ...$51f958ce30b62b80$var$repeat({
            type: "empty"
        }, $51f958ce30b62b80$export$7dd0ac1224095132(filled.length))
    ];
}
// One line per variant, so pairs of the same product staged at two strengths
// are added as the two variants the customer chose.
function $51f958ce30b62b80$var$buildAddPayload(products, staged) {
    return products.flatMap((product)=>{
        const byVariant = new Map();
        $51f958ce30b62b80$var$stagedPairs(staged, product.productId).forEach((pair)=>{
            byVariant.set(pair.variantId, (byVariant.get(pair.variantId) || 0) + 1);
        });
        return [
            ...byVariant
        ].map(([id, quantity])=>({
                id: id,
                quantity: quantity,
                properties: {
                    _source: $51f958ce30b62b80$export$639f367bc3559851
                }
            }));
    });
}
function $51f958ce30b62b80$export$12ff36e475de1761({ cartLines: cartLines, addedLine: addedLine, products: products, staged: staged }) {
    const lines = $51f958ce30b62b80$var$linesInCollection(cartLines, addedLine);
    const count = $51f958ce30b62b80$var$quantityOf(lines) + Object.values(staged).reduce((total, pairs)=>total + pairs.length, 0);
    const finished = count >= $51f958ce30b62b80$export$4140309872475f50;
    return {
        cards: $51f958ce30b62b80$var$deriveCards(products, cartLines, staged),
        count: count,
        finished: finished,
        mode: finished ? "inline" : "sticky",
        slots: $51f958ce30b62b80$var$deriveSlots(lines, products, staged),
        payload: $51f958ce30b62b80$var$buildAddPayload(products, staged)
    };
}
function $51f958ce30b62b80$export$5fdfaec0a0e51296({ added: added, cartProducts: fromCart = [], modelProducts: modelProducts, shapeProducts: shapeProducts, currentModel: currentModel, limit: limit = $51f958ce30b62b80$export$bc90872e265d166e }) {
    const model = modelProducts || [];
    const shape = (shapeProducts || []).filter((product)=>product.model !== currentModel);
    const fetched = [
        ...model,
        ...shape
    ];
    const pick = (product)=>fetched.find((entry)=>entry.productId === product.productId && entry.available !== false) || product;
    const result = [
        pick(added)
    ];
    // A cart pair earns its place whether or not the fetches returned it, so it
    // is not held to the availability check the suggestions are.
    for (const product of fromCart){
        if (result.length >= limit) break;
        if (!result.some((entry)=>entry.productId === product.productId)) result.push(pick(product));
    }
    for (const product of fetched){
        if (result.length >= limit) break;
        const seen = result.some((entry)=>entry.productId === product.productId);
        if (!seen && product.available !== false) result.push(product);
    }
    return result;
}
function $51f958ce30b62b80$export$d477ea1ec460f5ff(staged, products, restageAt = null) {
    return Object.fromEntries(products.filter((product)=>$51f958ce30b62b80$var$stagedQuantity(staged, product.productId) > 0).map((product)=>[
            product.productId,
            $51f958ce30b62b80$var$stagedPairs(staged, product.productId).map((pair)=>restageAt ? {
                    strength: restageAt,
                    variantId: product.variantId
                } : pair)
        ]));
}
function $51f958ce30b62b80$export$bfbcea8b1806dbcd({ cartLines: cartLines, addedLine: addedLine, targetStrength: targetStrength }) {
    return $51f958ce30b62b80$var$linesInCollection(cartLines, addedLine).filter((line)=>line.strength !== targetStrength);
}
function $51f958ce30b62b80$export$b52e8a27e8680b25(products) {
    return Object.fromEntries(products.filter((product)=>product.available !== false).map((product)=>[
            product.productId,
            product.variantId
        ]));
}
function $51f958ce30b62b80$export$e04e0f0a30b43537(strengths) {
    return [
        ...strengths
    ].sort((a, b)=>parseFloat(a.value) - parseFloat(b.value));
}
function $51f958ce30b62b80$export$82a21b7f98d42cdf(productJson, optionName, strength) {
    const index = productJson.options.findIndex((option)=>option.name === optionName);
    if (index < 0) return null;
    const variant = productJson.variants.find((entry)=>entry.available && entry.options[index] === strength);
    return variant ? variant.id : null;
}
function $51f958ce30b62b80$export$984e6f17d3ff676({ cartLines: cartLines, addedLine: addedLine, targetStrength: targetStrength, variantByProductId: variantByProductId, swap: swap }) {
    if (!swap) return null;
    const lines = $51f958ce30b62b80$export$bfbcea8b1806dbcd({
        cartLines: cartLines,
        addedLine: addedLine,
        targetStrength: targetStrength
    });
    const swappable = lines.filter((line)=>variantByProductId[line.productId]);
    if (swappable.length === 0) return null;
    return {
        changes: swappable.map((line)=>({
                id: line.key,
                quantity: 0
            })),
        adds: swappable.map((line)=>({
                id: variantByProductId[line.productId],
                quantity: line.quantity,
                properties: line.properties || {}
            })),
        skipped: lines.filter((line)=>!variantByProductId[line.productId])
    };
}
function $51f958ce30b62b80$export$2fab8f42a4cf4958({ enabled: enabled, product: product, cartLines: cartLines }) {
    if (!enabled || !product.glassesModel || !product.glassesCollection) return "drawer";
    const pairsInCollection = $51f958ce30b62b80$var$quantityOf(cartLines, (line)=>line.collection === product.glassesCollection);
    return pairsInCollection < $51f958ce30b62b80$export$4140309872475f50 ? "power-step" : "drawer";
}
const $51f958ce30b62b80$export$abc6a760d454260f = 0.8;
const $51f958ce30b62b80$export$5e1e8358cf9bb44f = 8;
function $51f958ce30b62b80$export$9922c042d395195c(scrollTop) {
    return scrollTop <= $51f958ce30b62b80$export$5e1e8358cf9bb44f;
}
function $51f958ce30b62b80$export$9f94acbb6f280a51({ latched: latched, coverage: coverage, atTop: atTop = false }) {
    if (atTop) return false;
    return latched || coverage >= $51f958ce30b62b80$export$abc6a760d454260f;
}
function $51f958ce30b62b80$export$14e311c260622076({ finished: finished, latched: latched, desktop: desktop = false }) {
    return desktop || finished || latched;
}


const $2aefe1b1f1135b10$var$BODY_OPEN_CLASS = "power-step-open";
const $2aefe1b1f1135b10$var$BODY_DECIDING_CLASS = "power-step-deciding";
const $2aefe1b1f1135b10$var$DECIDING_TIMEOUT = 10000;
const $2aefe1b1f1135b10$var$HISTORY_STATE = {
    powerStep: true
};
const $2aefe1b1f1135b10$var$GENDER_FILTER = "Unisex";
const $2aefe1b1f1135b10$var$COVERAGE_STEPS = Array.from({
    length: 101
}, (_, index)=>index / 100);
function $2aefe1b1f1135b10$var$readJson(element) {
    try {
        return JSON.parse(element.textContent);
    } catch (error) {
        return null;
    }
}
function $2aefe1b1f1135b10$var$productFromCard(card) {
    return {
        productId: Number(card.dataset.productId),
        variantId: Number(card.dataset.variantId),
        title: card.dataset.title,
        image: card.dataset.image,
        model: card.dataset.model,
        available: card.dataset.available === "true"
    };
}
function $2aefe1b1f1135b10$var$cloneTemplate(template) {
    return template.content.firstElementChild.cloneNode(true);
}
function $2aefe1b1f1135b10$var$setBusy(region, button, busy) {
    button.disabled = busy;
    region.setAttribute("aria-busy", String(busy));
}
async function $2aefe1b1f1135b10$var$postJson(url, body) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(`${url} ${response.status}`);
    return response.json();
}
class $2aefe1b1f1135b10$var$PowerStep extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.pending = false;
        this.lockedScroll = false;
        this.pendingTimer = null;
        this.lastFocus = null;
        this.staged = {};
        this.products = [];
        this.cards = new Map();
        this.strengths = [];
        this.fetchedProducts = [];
        this.fetchedStrength = null;
        this.pendingRemovals = [];
        this.activeStrength = null;
        this.loadToken = 0;
        this.modalBusy = false;
        this.barLatched = false;
        this.barCoverage = 0;
        this.purchasing = false;
        this.onCartAdd = this.onCartAdd.bind(this);
        this.onCartAdded = this.onCartAdded.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.updateSwapQuestion = this.updateSwapQuestion.bind(this);
        this.onModalSubmit = this.onModalSubmit.bind(this);
        this.onModalCancel = this.onModalCancel.bind(this);
        this.onCoverage = this.onCoverage.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = (0, $iqkY1.debounce)(()=>{
            if (!this.isOpen) return;
            this.observeCoverage();
            this.updateBarVisibility();
        }, 200);
    }
    connectedCallback() {
        this.product = $2aefe1b1f1135b10$var$readJson(this.querySelector("[data-power-step-product]"));
        this.overlay = this.querySelector("[data-power-step-overlay]");
        this.body = this.querySelector("[data-power-step-body]");
        this.strengthChip = this.querySelector("[data-power-step-strength]");
        this.strengthValue = this.querySelector("[data-power-step-strength-value]");
        this.cartCount = this.querySelector("[data-power-step-cart-count]");
        this.offer = this.querySelector("[data-power-step-offer]");
        this.grid = this.querySelector("[data-power-step-grid]");
        this.skeletonTemplate = this.querySelector("[data-power-step-skeleton]");
        this.cardTemplate = this.querySelector("[data-power-step-card-template]");
        this.cartSection = this.dataset.cartSection;
        this.productsSection = this.dataset.productsSection;
        this.productsUrl = this.dataset.productsUrl;
        this.modal = this.querySelector("[data-power-step-modal]");
        this.modalForm = this.querySelector("[data-power-step-modal-form]");
        this.strengthOptions = this.querySelector("[data-power-step-strength-options]");
        this.strengthOptionTemplate = this.querySelector("[data-power-step-strength-option]");
        this.swapBlock = this.querySelector("[data-power-step-swap]");
        this.modalError = this.querySelector("[data-power-step-modal-error]");
        this.confirmButton = this.querySelector("[data-power-step-confirm]");
        this.bar = this.querySelector("[data-power-step-bar]");
        this.barCount = this.querySelector("[data-power-step-count]");
        this.barDone = this.querySelector("[data-power-step-done]");
        this.barError = this.querySelector("[data-power-step-bar-error]");
        this.barSegments = [
            ...this.querySelectorAll("[data-power-step-segment]")
        ];
        this.slots = this.querySelector("[data-power-step-slots]");
        this.slotTemplate = this.querySelector("[data-power-step-slot-template]");
        this.slotEmptyTemplate = this.querySelector("[data-power-step-slot-empty]");
        this.barHead = this.querySelector("[data-power-step-bar-head]");
        this.buyButton = this.querySelector("[data-power-step-buy]");
        this.container = this.querySelector(".power-step__container");
        if (!this.product || !this.overlay) return;
        // The bar grows with its slot titles, so the room reserved under the grid is measured.
        this.barSize = new ResizeObserver(()=>this.reserveBarRoom());
        this.barSize.observe(this.bar);
        this.modalForm.addEventListener("change", this.updateSwapQuestion);
        this.modalForm.addEventListener("submit", this.onModalSubmit);
        this.modal.addEventListener("cancel", this.onModalCancel);
        document.addEventListener("theme:cart:add", this.onCartAdd);
        document.addEventListener("theme:cart:added", this.onCartAdded);
        document.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("popstate", this.onPopState);
        window.addEventListener("resize", this.onResize);
        this.addEventListener("click", this.onClick);
    }
    disconnectedCallback() {
        document.removeEventListener("theme:cart:add", this.onCartAdd);
        document.removeEventListener("theme:cart:added", this.onCartAdded);
        document.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("popstate", this.onPopState);
        window.removeEventListener("resize", this.onResize);
        this.removeEventListener("click", this.onClick);
        this.modalForm?.removeEventListener("change", this.updateSwapQuestion);
        this.modalForm?.removeEventListener("submit", this.onModalSubmit);
        this.modal?.removeEventListener("cancel", this.onModalCancel);
        this.observer?.disconnect();
        this.scroller?.removeEventListener("scroll", this.onScroll);
        this.barSize?.disconnect();
    }
    /**
   * Only the main product form on this product page can open the power step.
   * Quick view, try-on, and drawer upsells keep the cart drawer.
   * @param {Element|undefined} selector - The clicked add-to-cart element
   * @returns {HTMLFormElement|null}
   */ productPageForm(selector) {
        const form = selector?.closest?.("form[data-product-form]");
        if (!form || !form.closest("[data-main]")) return null;
        if (form.closest(".popup-quick-view, .to__add-to-cart")) return null;
        const productId = Number(form.querySelector('[name="product-id"]')?.value);
        return productId === this.product.id ? form : null;
    }
    onCartAdd(event) {
        const form = this.productPageForm(event.detail?.selector);
        if (!form) return;
        this.addedLine = {
            variantId: Number(form.querySelector('[name="id"]')?.value),
            productId: this.product.id
        };
        this.pending = true;
        // The theme moves focus while the drawer opens, so the button is captured now.
        this.lastFocus = event.detail?.selector || form.querySelector('[type="submit"]') || document.activeElement;
        document.body.classList.add($2aefe1b1f1135b10$var$BODY_DECIDING_CLASS);
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(()=>this.releaseDrawer(), $2aefe1b1f1135b10$var$DECIDING_TIMEOUT);
    }
    async onCartAdded() {
        if (!this.pending) return;
        this.pending = false;
        clearTimeout(this.pendingTimer);
        const cart = await this.fetchCart();
        const target = cart ? (0, $51f958ce30b62b80$export$2fab8f42a4cf4958)({
            enabled: true,
            product: this.product,
            cartLines: cart.lines
        }) : "drawer";
        if (target === "power-step") this.open(cart);
        else this.releaseDrawer();
    }
    async fetchCart() {
        try {
            const response = await fetch(`${window.theme.routes.cart_url}?section_id=${this.cartSection}`);
            if (!response.ok) return null;
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            return $2aefe1b1f1135b10$var$readJson(doc.querySelector("[data-power-step-cart]"));
        } catch (error) {
            return null;
        }
    }
    releaseDrawer() {
        this.pending = false;
        clearTimeout(this.pendingTimer);
        document.body.classList.remove($2aefe1b1f1135b10$var$BODY_DECIDING_CLASS);
    }
    /**
   * Stores the latest cart and refreshes what depends on it. Purchase and swap
   * actions call this after they change the cart.
   * @param {{ itemCount: number, lines: Array }} cart
   */ setCart(cart) {
        this.cart = cart;
        this.renderHeader();
        this.renderGrid();
    }
    addedCartLine() {
        return this.cart && this.addedLine ? (0, $51f958ce30b62b80$export$877cf27532547c5a)(this.cart.lines, this.addedLine) : null;
    }
    buildProductsUrl(filters) {
        const params = new URLSearchParams({
            section_id: this.productsSection,
            "filter.p.m.custom.glasses_collection": this.product.glassesCollection,
            "filter.p.product_type": this.product.productType,
            "filter.v.availability": "1",
            // The bundle is offered to everyone, so the grid never suggests a
            // men's or women's pair. The gender filter values are Unisex, Women, Men.
            "filter.p.m.custom.glasses_gender": $2aefe1b1f1135b10$var$GENDER_FILTER
        });
        if (this.activeStrength) params.set("filter.v.option.strength", this.activeStrength);
        Object.entries(filters).forEach(([key, value])=>params.set(key, value));
        return `${this.productsUrl}?${params.toString()}`;
    }
    /**
   * One Section Rendering API call. Returns null on any failure so the caller
   * can fall back to the other set.
   * @param {Object<string, string>} filters - Filter params for this set, added to the shared ones
   * @param {AbortSignal} signal
   * @returns {Promise<{ products: Array, cards: Map<number, Element>, strengths: Array }|null>}
   */ async fetchProducts(filters, signal) {
        try {
            const response = await fetch(this.buildProductsUrl(filters), {
                signal: signal
            });
            if (!response.ok) return null;
            const doc = new DOMParser().parseFromString(await response.text(), "text/html");
            const cards = new Map();
            const products = [
                ...doc.querySelectorAll("[data-power-step-card]")
            ].map((card)=>{
                const product = $2aefe1b1f1135b10$var$productFromCard(card);
                cards.set(product.productId, card);
                return product;
            });
            const strengths = $2aefe1b1f1135b10$var$readJson(doc.querySelector("[data-power-step-strengths]")) || [];
            return {
                products: products,
                cards: cards,
                strengths: strengths
            };
        } catch (error) {
            return null;
        }
    }
    /**
   * Fetches the model set and the shape set in parallel and builds the grid.
   * A newer call cancels an older one, so a strength change never shows stale cards.
   * @param {string|null} [restageAt] - New strength, when the customer swapped the cart
   */ async loadProducts(restageAt = null) {
        const line = this.addedCartLine();
        if (!line) {
            this.offer.hidden = true;
            this.grid.replaceChildren();
            this.grid.removeAttribute("aria-busy");
            return;
        }
        const token = ++this.loadToken;
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal: signal } = this.controller;
        this.showSkeleton();
        const [model, shape] = await Promise.all([
            this.fetchProducts({
                "filter.p.m.custom.glasses_model": this.product.glassesModel
            }, signal),
            this.product.shapeGid ? this.fetchProducts({
                "filter.p.m.custom.glasses_shapes": this.product.shapeGid
            }, signal) : Promise.resolve(null)
        ]);
        if (token !== this.loadToken) return;
        const failed = !model && !shape;
        this.offer.hidden = failed;
        this.strengths = (0, $51f958ce30b62b80$export$e04e0f0a30b43537)(model?.strengths || shape?.strengths || []);
        this.fetchedProducts = [
            ...model?.products || [],
            ...shape?.products || []
        ];
        this.fetchedStrength = this.activeStrength;
        this.products = (0, $51f958ce30b62b80$export$5fdfaec0a0e51296)({
            added: (0, $51f958ce30b62b80$export$ab724b8489ef3956)(line, this.product.glassesModel),
            cartProducts: (0, $51f958ce30b62b80$export$a8a2e6c947191d19)({
                cartLines: this.cart.lines,
                addedLine: this.addedLine
            }),
            modelProducts: model?.products || null,
            shapeProducts: shape?.products || null,
            currentModel: this.product.glassesModel
        });
        this.cards = new Map(this.products.map((product)=>[
                product.productId,
                this.cardFor(product, model, shape)
            ]));
        this.staged = (0, $51f958ce30b62b80$export$d477ea1ec460f5ff)(this.staged, this.products, restageAt);
        this.grid.removeAttribute("aria-busy");
        this.renderGrid();
    }
    cardFor(product, ...sets) {
        const fetched = sets.find((set)=>set?.cards.has(product.productId));
        if (fetched) return fetched.cards.get(product.productId);
        const card = $2aefe1b1f1135b10$var$cloneTemplate(this.cardTemplate);
        Object.assign(card.dataset, {
            productId: product.productId,
            variantId: product.variantId,
            title: product.title,
            image: product.image,
            model: product.model || ""
        });
        const img = card.querySelector("[data-power-step-card-img]");
        img.src = product.image;
        img.alt = product.title;
        card.querySelector("[data-power-step-card-title]").textContent = product.title;
        return card;
    }
    showSkeleton() {
        this.products = [];
        this.cards = new Map();
        this.grid.setAttribute("aria-busy", "true");
        this.grid.replaceChildren(...Array.from({
            length: (0, $51f958ce30b62b80$export$bc90872e265d166e)
        }, ()=>$2aefe1b1f1135b10$var$cloneTemplate(this.skeletonTemplate)));
    }
    renderGrid() {
        if (!this.cart || !this.addedLine || this.products.length === 0) return;
        this.view = (0, $51f958ce30b62b80$export$12ff36e475de1761)({
            cartLines: this.cart.lines,
            addedLine: this.addedLine,
            products: this.products,
            staged: this.staged
        });
        const cards = this.view.cards.map(({ product: product, quantity: quantity, minusEnabled: minusEnabled, plusEnabled: plusEnabled })=>{
            const card = this.cards.get(product.productId);
            card.querySelector("[data-power-step-quantity]").textContent = quantity;
            card.querySelector("[data-power-step-minus]").disabled = !minusEnabled;
            card.querySelector("[data-power-step-plus]").disabled = !plusEnabled;
            card.querySelector("[data-power-step-card-strength]").textContent = this.activeStrength || "";
            return card;
        });
        this.grid.replaceChildren(...cards);
        this.renderBar();
    }
    renderBar() {
        const { count: count, finished: finished, mode: mode, slots: slots } = this.view;
        const filled = Math.min(count, this.barSegments.length);
        const justFinished = finished && !this.wasFinished;
        this.wasFinished = finished;
        if (!finished) this.clearScrollRoom();
        this.barSegments.forEach((segment, index)=>segment.classList.toggle("is-filled", index < filled));
        this.barCount.textContent = this.bar.dataset.selectedText.replace("[count]", count);
        this.barCount.hidden = finished;
        this.barHead.hidden = finished;
        this.barDone.hidden = !finished;
        this.buyButton.hidden = !finished;
        this.bar.classList.toggle("power-step__bar--inline", mode === "inline");
        this.bar.classList.toggle("power-step__bar--sticky", mode === "sticky");
        this.slots.replaceChildren(...slots.map((slot)=>this.renderSlot(slot)));
        this.updateBarVisibility();
        if (justFinished) this.scrollToBar();
    }
    /**
   * The bar leaves the bottom of the screen when the set is complete, so the
   * finished view is brought to the middle of the viewport. On desktop the
   * dialog is the scroller, and `scrollIntoView` inside it would move the page
   * behind the dialog instead, so the offset inside the dialog is measured.
   */ scrollToBar() {
        requestAnimationFrame(()=>{
            if (!(0, $iqkY1.isDesktopViewport)() || !this.overlay) {
                this.bar.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return;
            }
            const bar = this.bar.getBoundingClientRect();
            const view = this.overlay.getBoundingClientRect();
            const top = this.overlay.scrollTop + bar.top - view.top - (view.height - bar.height) / 2;
            // The finished view is the last thing in the dialog, so the room that
            // brings it to the middle has to be added under it first.
            const end = this.overlay.scrollHeight - this.overlay.clientHeight;
            if (top > end) this.overlay.style.paddingBottom = `${Math.ceil(top - end)}px`;
            this.overlay.scrollTo({
                top: Math.max(0, top),
                behavior: "smooth"
            });
        });
    }
    clearScrollRoom() {
        if (this.overlay) this.overlay.style.paddingBottom = "";
    }
    renderSlot(slot) {
        if (slot.type === "empty") return $2aefe1b1f1135b10$var$cloneTemplate(this.slotEmptyTemplate);
        const element = $2aefe1b1f1135b10$var$cloneTemplate(this.slotTemplate);
        element.classList.add(`power-step__slot--${slot.type}`);
        const img = element.querySelector("[data-power-step-slot-img]");
        const label = element.querySelector("[data-power-step-slot-label]");
        const { title: title, model: model } = slot.product;
        const colour = model ? title.replace(model, "").trim() : title;
        img.src = slot.product.image;
        img.alt = title;
        element.querySelector("[data-power-step-slot-model]").textContent = model || title;
        element.querySelector("[data-power-step-slot-color]").textContent = colour;
        element.querySelector("[data-power-step-slot-strength]").textContent = slot.strength || "";
        if (slot.type === "cart") label.textContent = this.bar.dataset.inCartText;
        else label.remove();
        return element;
    }
    /**
   * The bar follows the bundle section into view. On desktop the overlay is
   * the scroll container, on mobile the document is, so the root differs.
   * Thresholds are 1% steps of the section, so a tall grid still reports
   * viewport coverage without visible lag.
   */ observeCoverage() {
        this.observer?.disconnect();
        const root = (0, $iqkY1.isDesktopViewport)() ? this.overlay : null;
        this.observer = new IntersectionObserver(this.onCoverage, {
            root: root,
            threshold: $2aefe1b1f1135b10$var$COVERAGE_STEPS
        });
        this.observer.observe(this.body);
        this.scroller?.removeEventListener("scroll", this.onScroll);
        this.scroller = root || window;
        this.scroller.addEventListener("scroll", this.onScroll, {
            passive: true
        });
    }
    scrollTop() {
        return (0, $iqkY1.isDesktopViewport)() ? this.overlay.scrollTop : window.scrollY;
    }
    // The observer only reports threshold crossings, so the return to the top,
    // which releases the latch, is read from the scroller itself.
    onScroll() {
        this.updateLatch();
    }
    updateLatch() {
        this.barLatched = (0, $51f958ce30b62b80$export$9f94acbb6f280a51)({
            latched: this.barLatched,
            coverage: this.barCoverage,
            atTop: (0, $51f958ce30b62b80$export$9922c042d395195c)(this.scrollTop())
        });
        this.updateBarVisibility();
    }
    /**
   * Coverage is measured against the shorter of viewport and section, so a
   * grid shorter than 80% of a tall screen can still fill its share.
   */ onCoverage(entries) {
        const entry = entries[entries.length - 1];
        const rootHeight = entry.rootBounds?.height || window.innerHeight;
        const reference = Math.min(rootHeight, entry.boundingClientRect.height);
        this.barCoverage = reference > 0 ? entry.intersectionRect.height / reference : 0;
        this.updateLatch();
    }
    updateBarVisibility() {
        if (!this.view) return;
        const shown = (0, $51f958ce30b62b80$export$14e311c260622076)({
            finished: this.view.finished,
            latched: this.barLatched,
            desktop: (0, $iqkY1.isDesktopViewport)()
        });
        this.bar.hidden = false;
        this.bar.classList.toggle("power-step__bar--stowed", !shown);
        this.reserveBarRoom(shown);
    }
    reserveBarRoom(shown = !this.bar.classList.contains("power-step__bar--stowed")) {
        const sticky = this.view && !this.view.finished && shown;
        const height = sticky ? this.bar.getBoundingClientRect().height : 0;
        this.container.style.setProperty("--power-step-bar-height", `${Math.ceil(height)}px`);
    }
    setPurchasing(busy) {
        this.purchasing = busy;
        $2aefe1b1f1135b10$var$setBusy(this.bar, this.buyButton, busy);
        this.buyButton.classList.toggle("is-loading", busy);
    }
    /**
   * Adds the staged pairs and goes to checkout. Nothing staged means the cart
   * already holds the set, so checkout opens at once.
   */ async purchase() {
        if (this.purchasing || !this.view?.finished) return;
        this.setPurchasing(true);
        this.barError.hidden = true;
        const items = this.view.payload;
        try {
            if (items.length > 0) await $2aefe1b1f1135b10$var$postJson(`${window.theme.routes.root}cart/add.js`, {
                items: items
            });
            document.dispatchEvent(new CustomEvent("power-step:purchase", {
                bubbles: true,
                detail: {
                    items: items,
                    count: this.view.count
                }
            }));
            window.location.href = `${window.theme.routes.root}checkout`;
        } catch (error) {
            this.setPurchasing(false);
            this.barError.hidden = false;
            await this.reloadCart().catch(()=>{});
        }
    }
    stage(productId, delta) {
        const card = this.view?.cards.find((entry)=>entry.product.productId === productId);
        if (!card) return;
        if (delta < 0 ? !card.minusEnabled : !card.plusEnabled) return;
        this.staged = delta > 0 ? (0, $51f958ce30b62b80$export$46e2bf5b109a972e)(this.staged, card.product, this.activeStrength) : (0, $51f958ce30b62b80$export$d22c1ab0de84ea1b)(this.staged, productId);
        this.renderGrid();
    }
    openStrengthModal() {
        if (!this.modal || this.strengths.length === 0) return;
        const options = this.strengths.map(({ value: value, label: label })=>{
            const option = $2aefe1b1f1135b10$var$cloneTemplate(this.strengthOptionTemplate);
            const input = option.querySelector("input");
            input.value = value;
            input.checked = value === this.activeStrength;
            option.querySelector("[data-power-step-strength-label]").textContent = label || value;
            return option;
        });
        this.strengthOptions.replaceChildren(this.strengthOptions.querySelector("legend"), ...options);
        this.swapBlock.querySelector('input[value="yes"]').checked = true;
        this.modalError.hidden = true;
        this.updateSwapQuestion();
        this.modal.showModal();
    }
    closeStrengthModal() {
        if (this.modalBusy) return;
        this.modal.close();
    }
    selectedStrength() {
        return this.modalForm.querySelector('input[name="power-step-strength"]:checked')?.value || null;
    }
    swapInput(targetStrength) {
        return {
            cartLines: this.cart.lines,
            addedLine: this.addedLine,
            targetStrength: targetStrength
        };
    }
    updateSwapQuestion() {
        const targetStrength = this.selectedStrength();
        const pairs = targetStrength ? (0, $51f958ce30b62b80$export$bfbcea8b1806dbcd)(this.swapInput(targetStrength)) : [];
        this.swapBlock.hidden = pairs.length === 0;
    }
    setModalBusy(busy) {
        this.modalBusy = busy;
        $2aefe1b1f1135b10$var$setBusy(this.modal, this.confirmButton, busy);
    }
    onModalCancel(event) {
        if (this.modalBusy) event.preventDefault();
    }
    /**
   * Applies the chosen strength to the grid, then swaps cart lines when asked.
   * The grid change stands even when the swap fails; the modal then stays open
   * with the error so the customer can retry the swap alone.
   */ async onModalSubmit(event) {
        event.preventDefault();
        if (this.modalBusy) return;
        const strength = this.selectedStrength();
        if (!strength) return;
        const swap = !this.swapBlock.hidden && this.modalForm.querySelector('input[name="power-step-swap"]:checked')?.value === "yes";
        const changed = strength !== this.activeStrength;
        if (!changed && !swap) {
            this.modal.close();
            return;
        }
        this.setModalBusy(true);
        this.modalError.hidden = true;
        const previous = this.activeStrength;
        this.activeStrength = strength;
        if (changed) {
            // A strength picked here is as deliberate as one picked on the product page.
            (0, $ca0af4416dd94155$export$c9971476af11ad57)(strength);
            await this.loadProducts(swap ? strength : null);
        }
        const result = swap ? await this.swapCart(strength) : "nothing";
        this.setModalBusy(false);
        if (changed) document.dispatchEvent(new CustomEvent("power-step:strength-changed", {
            bubbles: true,
            detail: {
                strength: strength,
                previous: previous,
                swapped: result === "swapped"
            }
        }));
        if (result === "failed") {
            // Escape can close a busy dialog despite the cancel guard, so the error must reopen it.
            if (!this.modal.open) this.modal.showModal();
            this.modalError.hidden = false;
            this.updateSwapQuestion();
            return;
        }
        this.modal.close();
    }
    /**
   * Moves the cart lines in the collection to the target strength. Adds run
   * before removals so a failure half way never loses the customer's pairs;
   * removals left over from such a failure are finished first on the next call.
   * @param {string} strength
   * @returns {Promise<'swapped'|'nothing'|'failed'>}
   */ async swapCart(strength) {
        try {
            await this.finishPendingRemovals();
            const lines = (0, $51f958ce30b62b80$export$bfbcea8b1806dbcd)(this.swapInput(strength));
            const variantByProductId = await this.variantsAtStrength(lines, strength);
            const plan = (0, $51f958ce30b62b80$export$984e6f17d3ff676)({
                ...this.swapInput(strength),
                variantByProductId: variantByProductId,
                swap: true
            });
            if (!plan) return "nothing";
            const addedKey = this.addedCartLine()?.key;
            await $2aefe1b1f1135b10$var$postJson(`${window.theme.routes.root}cart/add.js`, {
                items: plan.adds
            });
            this.pendingRemovals = plan.changes.map(({ id: id })=>id);
            await this.removeLines(this.pendingRemovals);
            this.pendingRemovals = [];
            if (plan.changes.some(({ id: id })=>id === addedKey)) this.addedLine = {
                ...this.addedLine,
                variantId: variantByProductId[this.addedLine.productId]
            };
            await this.reloadCart();
            return "swapped";
        } catch (error) {
            await this.reloadCart().catch(()=>{});
            return "failed";
        }
    }
    async finishPendingRemovals() {
        const keys = this.pendingRemovals.filter((key)=>this.cart.lines.some((line)=>line.key === key));
        if (keys.length === 0) return;
        await this.removeLines(keys);
        this.pendingRemovals = [];
        await this.reloadCart();
    }
    removeLines(keys) {
        return $2aefe1b1f1135b10$var$postJson(`${window.theme.routes.root}cart/update.js`, {
            updates: Object.fromEntries(keys.map((key)=>[
                    key,
                    0
                ]))
        });
    }
    async reloadCart() {
        const cart = await this.fetchCart();
        if (!cart) throw new Error("cart reload failed");
        this.setCart(cart);
    }
    /**
   * Variant id at the strength per product id. The grid sets fetched at that
   * strength already carry it; other cart lines use the product JSON endpoint.
   * @param {Array} lines - Cart lines that need a variant
   * @param {string} strength
   * @returns {Promise<Object<number, number>>}
   */ async variantsAtStrength(lines, strength) {
        const map = this.fetchedStrength === strength ? (0, $51f958ce30b62b80$export$b52e8a27e8680b25)(this.fetchedProducts) : {};
        const missing = new Map(lines.filter((line)=>!map[line.productId] && line.handle).map((line)=>[
                line.productId,
                line.handle
            ]));
        await Promise.all([
            ...missing
        ].map(async ([productId, handle])=>{
            const variantId = await this.fetchVariantAt(handle, strength);
            if (variantId) map[productId] = variantId;
        }));
        return map;
    }
    async fetchVariantAt(handle, strength) {
        try {
            const response = await fetch(`${window.theme.routes.root}products/${handle}.js`);
            if (!response.ok) return null;
            return (0, $51f958ce30b62b80$export$82a21b7f98d42cdf)(await response.json(), this.product.strengthOptionName, strength);
        } catch (error) {
            return null;
        }
    }
    renderHeader() {
        const line = this.addedCartLine();
        if (!line) return;
        const strength = line.strength;
        this.cartCount.textContent = this.cart.itemCount;
        this.strengthChip.hidden = !strength;
        this.strengthValue.textContent = strength || "";
    }
    open(cart) {
        if (this.isOpen) return;
        this.staged = {};
        this.products = [];
        this.view = null;
        this.barLatched = false;
        this.barCoverage = 0;
        this.wasFinished = false;
        this.clearScrollRoom();
        this.bar.hidden = true;
        this.activeStrength = (0, $51f958ce30b62b80$export$877cf27532547c5a)(cart.lines, this.addedLine)?.strength || null;
        this.setCart(cart);
        this.isOpen = true;
        this.barError.hidden = true;
        this.setPurchasing(false);
        this.loadProducts();
        this.observeCoverage();
        // The theme closes its cart drawer on this event. The drawer was already open but hidden while deciding.
        document.dispatchEvent(new CustomEvent("theme:popup:open", {
            bubbles: true
        }));
        document.body.classList.remove($2aefe1b1f1135b10$var$BODY_DECIDING_CLASS);
        document.body.classList.add($2aefe1b1f1135b10$var$BODY_OPEN_CLASS);
        window.history.pushState($2aefe1b1f1135b10$var$HISTORY_STATE, "");
        if ((0, $iqkY1.isDesktopViewport)()) {
            this.lockedScroll = true;
            this.overlay.scrollTop = 0;
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: true,
                detail: this.overlay
            }));
        } else window.scrollTo({
            top: 0
        });
        // The drawer close blurs the active element on the next frame, so focus lands after it.
        requestAnimationFrame(()=>requestAnimationFrame(()=>this.overlay.focus({
                    preventScroll: true
                })));
        document.dispatchEvent(new CustomEvent("power-step:opened", {
            bubbles: true,
            detail: {
                productId: this.addedLine.productId,
                variantId: this.addedLine.variantId,
                strength: this.activeStrength,
                cartItemCount: cart.itemCount
            }
        }));
    }
    /**
   * Closes through history when the power step owns the current entry,
   * so the back button and the close controls leave the same history.
   */ requestClose() {
        if (!this.isOpen) return;
        if (window.history.state?.powerStep) window.history.back();
        else this.close();
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.observer?.disconnect();
        this.scroller?.removeEventListener("scroll", this.onScroll);
        this.scroller = null;
        document.body.classList.remove($2aefe1b1f1135b10$var$BODY_OPEN_CLASS);
        if (this.lockedScroll) {
            this.lockedScroll = false;
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: true
            }));
        }
        if (this.lastFocus?.focus) this.lastFocus.focus({
            preventScroll: true
        });
        this.lastFocus = null;
    }
    onPopState() {
        if (this.isOpen) this.close();
    }
    onKeyDown(event) {
        if (event.key !== "Escape" || !this.isOpen) return;
        // An open strength modal owns Escape through its own cancel event.
        if (!this.modal?.open) this.requestClose();
    }
    /**
   * Hands the customer over to the theme's cart drawer. The drawer opens from
   * its own toggle, which is the only way into the theme's open routine, and
   * the step closes first so the page and the history entry come back.
   * @returns {boolean} False when the theme has no drawer, so the link navigates
   */ openCartDrawer() {
        const toggle = document.querySelector("[data-cart-drawer-toggle]");
        if (!toggle) return false;
        this.close();
        if (window.history.state?.powerStep) window.history.back();
        toggle.click();
        return true;
    }
    onClick(event) {
        if (event.target.closest("[data-power-step-cart-link]")) {
            if (this.openCartDrawer()) event.preventDefault();
            return;
        }
        // The desktop overlay covers the backdrop element, so a click on the room
        // around the dialog panel lands here instead.
        if (event.target === this.overlay && (0, $iqkY1.isDesktopViewport)()) {
            this.requestClose();
            return;
        }
        if (event.target.closest("[data-power-step-close]")) {
            this.requestClose();
            return;
        }
        if (event.target.closest("[data-power-step-change]")) {
            this.openStrengthModal();
            return;
        }
        if (event.target.closest("[data-power-step-buy]")) {
            this.purchase();
            return;
        }
        // A click on the dialog itself is a click on its backdrop.
        if (event.target === this.modal || event.target.closest("[data-power-step-modal-close]")) {
            this.closeStrengthModal();
            return;
        }
        const stepper = event.target.closest("[data-power-step-plus], [data-power-step-minus]");
        if (!stepper) return;
        const productId = Number(stepper.closest("[data-power-step-card]").dataset.productId);
        this.stage(productId, stepper.hasAttribute("data-power-step-plus") ? 1 : -1);
    }
}
if (!customElements.get("power-step")) customElements.define("power-step", $2aefe1b1f1135b10$var$PowerStep);




/**
 * Saves the strength a customer adds to the cart, so
 * snippets/preferred-strength.liquid can open the next product page at it.
 *
 * The value is read from the option inputs of the form that was submitted, and
 * only after the cart accepts the line, so a refused add leaves it alone.
 */ 
// The try-on cart builds its inputs in JS with the untranslated option name.
const $bceedbd9cce31171$var$FALLBACK_OPTION_NAME = "Strength";
let $bceedbd9cce31171$var$pendingStrength = null;
function $bceedbd9cce31171$var$optionNames() {
    const localised = window.theme?.strings?.strengthOptionName;
    return localised && localised !== $bceedbd9cce31171$var$FALLBACK_OPTION_NAME ? [
        localised,
        $bceedbd9cce31171$var$FALLBACK_OPTION_NAME
    ] : [
        $bceedbd9cce31171$var$FALLBACK_OPTION_NAME
    ];
}
// Radios first: a form that holds both radios and a hidden popout input for one
// option keeps the truth on the checked radio.
function $bceedbd9cce31171$var$strengthInForm(form) {
    for (const name of $bceedbd9cce31171$var$optionNames()){
        const inputs = [
            ...form.querySelectorAll(`[name="options[${name}]"]`)
        ];
        const selected = inputs.find((input)=>input.checked) || inputs.find((input)=>input.type !== "radio");
        if (selected?.value) return selected.value;
    }
    return null;
}
document.addEventListener("theme:cart:add", (event)=>{
    const form = event.detail?.selector?.closest?.("form");
    $bceedbd9cce31171$var$pendingStrength = form ? $bceedbd9cce31171$var$strengthInForm(form) : null;
});
document.addEventListener("theme:cart:added", ()=>{
    (0, $ca0af4416dd94155$export$c9971476af11ad57)($bceedbd9cce31171$var$pendingStrength);
    $bceedbd9cce31171$var$pendingStrength = null;
});




/**
 * Sticky Product Sidebar
 *
 * Manages sticky behavior for product details sidebar on desktop.
 * Uses a class-based state machine with automatic layout detection.
 */ /**
 * StickyProductController - Main controller for sticky product sidebar behavior
 *
 * Manages the lifecycle of the sticky product sidebar, including:
 * - Element discovery and validation
 * - Scroll handling with RAF batching
 * - Observer management for layout changes
 * - State transitions and CSS application
 */ /**
 * Configuration and constants for sticky product sidebar
 */ const $8fe52b714aee1e42$export$96d9f1a404a17825 = {
    STATIC: "static",
    STICKY: "sticky",
    STOPPED: "stopped" // Past stop marker (element pinned at stop position)
};
const $8fe52b714aee1e42$export$1630b5343357e8b5 = {
    selectors: {
        // Main container with sticky enabled
        container: '.product-single[data-sticky-enabled="true"]',
        // The element that will become sticky
        stickyElement: ".product-single__details",
        // Navigation for offset calculation (legacy, now using CSS variable)
        navigation: "nav#NavStandard",
        // Marker indicating where sticky should stop
        stopMarker: "[sticky-stop-marker]",
        // Main content container (absolute positioning parent)
        mainContent: "#MainContent",
        // Fallback stop element if no marker found
        footer: "#SiteFooter"
    },
    // Minimum viewport width for sticky behavior
    breakpoint: 768,
    // Spacing below sticky element when stopped
    spacing: {
        withMarker: 0,
        withoutMarker: 60 // Extra spacing when using footer as fallback
    }
};


/**
 * MeasurementCache - Caches expensive DOM measurements and handles invalidation
 *
 * This class stores all dimension and position measurements needed for sticky calculations.
 * It prevents redundant getBoundingClientRect() calls on every scroll event.
 */ class $295074703a2485a5$export$3c29232e51c6f838 {
    constructor(){
        this.cache = {};
        this.valid = false;
        this.stableValid = false; // Stable values (offset, height) remain valid on layout changes
        this.timestamp = null;
    }
    /**
	 * Measure all required dimensions and positions
	 * @param {Object} elements - Object containing all required DOM elements
	 * @returns {Object} The measured values
	 */ measure(elements) {
        if (!elements || !elements.stickyElement) {
            this.valid = false;
            return null;
        }
        try {
            // Sticky header height from CSS variable (works on all breakpoints)
            const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-sticky-height")) || 60;
            this.cache.navHeight = stickyHeaderHeight;
            // Main content top position (absolute positioning parent)
            const mainContentRect = elements.mainContent?.getBoundingClientRect();
            this.cache.mainContentTop = mainContentRect ? window.scrollY + mainContentRect.top : 0;
            // Product section (container) top position
            const containerRect = elements.container.getBoundingClientRect();
            this.cache.containerTop = window.scrollY + containerRect.top;
            // Sticky element height and RELATIVE offset from container
            // We store the offset instead of absolute position because:
            // - The offset doesn't change when other sections load above
            // - Absolute position can be computed: containerTop + offset
            const stickyRect = elements.stickyElement.getBoundingClientRect();
            this.cache.stickyHeight = stickyRect.height;
            this.cache.stickyOffsetFromContainer = stickyRect.top - containerRect.top;
            // Stop element top position
            if (elements.stopElement) {
                const stopRect = elements.stopElement.getBoundingClientRect();
                this.cache.stopElementTop = window.scrollY + stopRect.top;
            } else this.cache.stopElementTop = null;
            this.valid = true;
            this.stableValid = true;
            this.timestamp = Date.now();
            return this.cache;
        } catch (error) {
            console.error("Error measuring sticky product elements:", error);
            this.valid = false;
            this.stableValid = false;
            return null;
        }
    }
    /**
	 * Remeasure only layout-dependent values (container/stop positions)
	 * Use when sections load and push content down, but sticky element itself hasn't changed
	 * @param {Object} elements - Object containing all required DOM elements
	 */ measureLayout(elements) {
        if (!elements?.container) return;
        // Remeasure container position
        const containerRect = elements.container.getBoundingClientRect();
        this.cache.containerTop = window.scrollY + containerRect.top;
        // Remeasure main content position
        const mainContentRect = elements.mainContent?.getBoundingClientRect();
        this.cache.mainContentTop = mainContentRect ? window.scrollY + mainContentRect.top : 0;
        // Remeasure stop element position
        if (elements.stopElement) {
            const stopRect = elements.stopElement.getBoundingClientRect();
            this.cache.stopElementTop = window.scrollY + stopRect.top;
        }
        this.valid = true;
        this.timestamp = Date.now();
    }
    /**
	 * Mark the cache as fully invalid (needs full remeasurement)
	 */ invalidate() {
        this.valid = false;
        this.stableValid = false;
    }
    /**
	 * Mark only layout-dependent values as invalid
	 * Stable values (stickyHeight, stickyOffsetFromContainer, navHeight) remain valid
	 */ invalidateLayout() {
        this.valid = false;
    // stableValid stays true
    }
    /**
	 * Check if cache is valid
	 * @returns {boolean}
	 */ isValid() {
        return this.valid;
    }
    /**
	 * Check if stable values are still valid (can use measureLayout instead of full measure)
	 * @returns {boolean}
	 */ hasStableValues() {
        return this.stableValid;
    }
    /**
	 * Get a specific cached value
	 * @param {string} key - The measurement key
	 * @returns {*} The cached value or null if invalid
	 */ get(key) {
        return this.valid ? this.cache[key] : null;
    }
    /**
	 * Get all cached measurements
	 * @returns {Object|null} All measurements or null if invalid
	 */ getAll() {
        return this.valid ? {
            ...this.cache
        } : null;
    }
}


/**
 * Position Calculator - Pure functions for sticky state and position calculations
 *
 * These functions have no side effects and are fully testable.
 * They determine the sticky state and calculate the appropriate CSS values.
 */ 
function $66c2bd715374aa9e$export$9e989860e91bda4b(cache) {
    if (!cache) return {
        stickyStart: 0,
        stickyEnd: 0
    };
    const STICKY_OFFSET = 16; // Additional spacing below header when sticky
    // Compute absolute stickyElementTop from container position + relative offset
    // This works correctly even when other sections load and push content down,
    // because the offset (relative position within container) doesn't change
    const stickyElementTop = cache.containerTop + cache.stickyOffsetFromContainer;
    // Sticky starts when scroll would push sidebar behind header
    const stickyStart = stickyElementTop - (cache.navHeight + STICKY_OFFSET);
    // Sticky ends when bottom of sticky element would pass stop marker
    const stickyEnd = cache.stopElementTop ? cache.stopElementTop - (cache.navHeight + STICKY_OFFSET) - cache.stickyHeight : Infinity;
    return {
        stickyStart: stickyStart,
        stickyEnd: stickyEnd
    };
}
function $66c2bd715374aa9e$export$698fa70a2ac15688(scrollY, thresholds) {
    if (scrollY < thresholds.stickyStart) return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC;
    if (thresholds.stickyEnd !== Infinity && scrollY >= thresholds.stickyEnd) return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STOPPED;
    return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STICKY;
}
function $66c2bd715374aa9e$export$a5b21f38d58b1de0(state, cache, hasStopMarker) {
    if (!cache) return {
        position: "",
        top: ""
    };
    switch(state){
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC:
            // Position absolute to override default CSS fixed positioning
            // But don't set top value - let element stay at natural layout position
            return {
                position: "absolute",
                top: ""
            };
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STICKY:
            // Fixed to viewport with 16px spacing below header
            return {
                position: "fixed",
                top: `${cache.navHeight + 16}px`
            };
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STOPPED:
            // Absolute position pinned at stop marker
            const spacing = hasStopMarker ? 0 : 60;
            const absoluteTop = cache.stopElementTop - cache.mainContentTop - cache.stickyHeight - spacing;
            return {
                position: "absolute",
                top: `${absoluteTop}px`
            };
        default:
            return {
                position: "",
                top: ""
            };
    }
}


class $d4d227e85f07adb6$export$fd284eb6bfa30e95 {
    constructor(config = (0, $8fe52b714aee1e42$export$1630b5343357e8b5)){
        this.config = config;
        this.elements = null;
        this.cache = new (0, $295074703a2485a5$export$3c29232e51c6f838)();
        this.currentState = null;
        this.scrollRAF = null;
        this.stickyResizeObserver = null; // For sticky element - needs full invalidation
        this.layoutResizeObserver = null; // For layout elements - only layout invalidation
        this.mutationObserver = null;
        this.boundScrollHandler = null;
        this.hasStopMarker = false;
        this.activeStopSectionId = null; // Track which section we're using as stop marker
        this.isActive = false; // Track if controller is currently active
    }
    /**
	 * Initialize the sticky product behavior
	 */ init() {
        // Check viewport width
        if (window.innerWidth <= this.config.breakpoint) {
            this.isActive = false;
            return;
        }
        // Find and validate elements
        this.elements = this.findElements();
        if (!this.elements) {
            this.isActive = false;
            return;
        }
        // Reset any previous inline styles
        this.resetStyles();
        // Initial measurement
        this.cache.measure(this.elements);
        // Set initial position to STATIC (natural position) to prevent CLS jump
        // Even if scroll is past sticky threshold, start at natural position
        // Scroll handler will smoothly transition to sticky when needed
        const measurements = this.cache.getAll();
        if (measurements) {
            this.currentState = (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC;
            this.applyStyles((0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC, measurements);
        }
        // Setup event listeners and observers
        this.setupEventListeners();
        this.setupObservers();
        // Mark as active after successful initialization
        this.isActive = true;
    }
    /**
	 * Find all required DOM elements with scoped selection
	 * @returns {Object|null} Elements object or null if not found
	 */ findElements() {
        const container = document.querySelector(this.config.selectors.container);
        if (!container) return null;
        // Scoped selection: find sticky element within container
        const stickyElement = container.querySelector(this.config.selectors.stickyElement);
        if (!stickyElement) return null;
        const navigation = document.querySelector(this.config.selectors.navigation);
        const mainContent = document.querySelector(this.config.selectors.mainContent);
        const stopElement = this.findStopElement();
        if (!navigation || !mainContent) return null;
        return {
            container: container,
            stickyElement: stickyElement,
            navigation: navigation,
            mainContent: mainContent,
            stopElement: stopElement
        };
    }
    /**
	 * Find the stop element (marker or footer fallback)
	 * Filters out hidden sections and returns the first visible marker
	 * @returns {HTMLElement|null}
	 */ findStopElement() {
        // Find all markers
        const markers = document.querySelectorAll(this.config.selectors.stopMarker);
        if (markers.length === 0) {
            // No markers found, fallback to footer
            this.hasStopMarker = false;
            this.activeStopSectionId = null;
            return document.querySelector(this.config.selectors.footer);
        }
        // Filter to visible markers only
        const visibleMarkers = Array.from(markers).filter((marker)=>{
            const section = marker.closest(".shopify-section");
            if (!section) return false;
            // Check if section is hidden
            const styles = window.getComputedStyle(section);
            return styles.display !== "none" && styles.visibility !== "hidden";
        });
        if (visibleMarkers.length === 0) {
            // No visible markers, use footer
            this.hasStopMarker = false;
            this.activeStopSectionId = null;
            return document.querySelector(this.config.selectors.footer);
        }
        // Get the first visible marker (the section element itself)
        const stopElement = visibleMarkers[0];
        this.hasStopMarker = true;
        // Store the section ID of the stop element we're using
        const stopSection = stopElement.closest("[data-section-id]");
        this.activeStopSectionId = stopSection?.getAttribute("data-section-id") || null;
        return stopElement;
    }
    /**
	 * Reset inline styles to prevent stale state
	 */ resetStyles() {
        if (this.elements?.stickyElement) {
            this.elements.stickyElement.style.position = "";
            this.elements.stickyElement.style.top = "";
        }
    }
    /**
	 * Setup scroll event listener with RAF batching
	 */ setupEventListeners() {
        this.boundScrollHandler = ()=>this.handleScroll();
        window.addEventListener("scroll", this.boundScrollHandler, {
            passive: true
        });
    }
    /**
	 * Setup ResizeObserver and MutationObserver for automatic invalidation
	 */ setupObservers() {
        // ResizeObserver for sticky element - needs full invalidation
        // (stickyHeight and stickyOffsetFromContainer may have changed)
        this.stickyResizeObserver = new ResizeObserver(()=>{
            this.invalidate();
        });
        if (this.elements.stickyElement) this.stickyResizeObserver.observe(this.elements.stickyElement);
        // ResizeObserver for layout elements - only layout invalidation
        // (only container/stop positions changed, not the sticky element itself)
        this.layoutResizeObserver = new ResizeObserver(()=>{
            this.invalidateLayout();
        });
        if (this.elements.stopElement) this.layoutResizeObserver.observe(this.elements.stopElement);
        if (this.elements.mainContent) this.layoutResizeObserver.observe(this.elements.mainContent);
        // MutationObserver: Watch for new sections AND attribute/style changes
        this.mutationObserver = new MutationObserver((mutations)=>{
            let needsRefind = false;
            mutations.forEach((mutation)=>{
                // Check for new nodes added
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) needsRefind = true;
                // Check for style/attribute changes that might hide/show sections
                if (mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) // A section might have been hidden or shown
                needsRefind = true;
            });
            if (needsRefind) this.refindStopElement();
        });
        if (this.elements.mainContent) this.mutationObserver.observe(this.elements.mainContent, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "style",
                "class"
            ] // Only style/class changes
        });
    }
    /**
	 * Refind the stop element and update observers if it changed
	 * This handles cases where sections are hidden/shown or added/removed
	 */ refindStopElement() {
        const newStopElement = this.findStopElement();
        if (newStopElement !== this.elements.stopElement) {
            // Disconnect old observer from old stop element
            if (this.elements.stopElement && this.layoutResizeObserver) this.layoutResizeObserver.unobserve(this.elements.stopElement);
            // Update reference
            this.elements.stopElement = newStopElement;
            // Observe new stop element
            if (newStopElement && this.layoutResizeObserver) this.layoutResizeObserver.observe(newStopElement);
            // Use layout invalidation to preserve stable values (stickyOffsetFromContainer)
            // Full invalidation would cause wrong measurements if element is in STICKY state
            this.invalidateLayout();
        }
    }
    /**
	 * Handle scroll event with RAF batching
	 */ handleScroll() {
        // Cancel pending frame if scrolling quickly
        if (this.scrollRAF) cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Update position based on current scroll position
	 */ updatePosition() {
        // Guard against missing elements
        if (!this.elements || !document.body.contains(this.elements.stickyElement)) return;
        // Check viewport width
        if (window.innerWidth < this.config.breakpoint) return;
        // Remeasure if cache is invalid
        if (!this.cache.isValid()) {
            // Use partial remeasurement if stable values are still valid
            // (e.g., when other sections loaded but sticky element itself didn't change)
            if (this.cache.hasStableValues()) this.cache.measureLayout(this.elements);
            else this.cache.measure(this.elements);
        }
        const measurements = this.cache.getAll();
        if (!measurements) return;
        // Calculate thresholds and determine state
        const scrollY = window.scrollY;
        const thresholds = (0, $66c2bd715374aa9e$export$9e989860e91bda4b)(measurements);
        const newState = (0, $66c2bd715374aa9e$export$698fa70a2ac15688)(scrollY, thresholds);
        // Apply styles if state changed
        if (newState !== this.currentState) {
            this.currentState = newState;
            this.applyStyles(newState, measurements);
            this.dispatchStateChange(newState, scrollY);
        }
    }
    /**
	 * Apply CSS styles for the given state
	 * @param {string} state - STICKY_STATE value
	 * @param {Object} measurements - Cached measurements
	 */ applyStyles(state, measurements) {
        if (!this.elements?.stickyElement) return;
        const styles = (0, $66c2bd715374aa9e$export$a5b21f38d58b1de0)(state, measurements, this.hasStopMarker);
        this.elements.stickyElement.style.position = styles.position;
        this.elements.stickyElement.style.top = styles.top;
    }
    /**
	 * Dispatch custom event when state changes
	 * @param {string} state - New state
	 * @param {number} scrollY - Current scroll position
	 */ dispatchStateChange(state, scrollY) {
        const event = new CustomEvent("sticky-product:state-change", {
            detail: {
                state: state,
                scrollY: scrollY,
                measurements: this.cache.getAll()
            }
        });
        document.dispatchEvent(event);
    }
    /**
	 * Invalidate cache and trigger recalculation
	 */ invalidate() {
        this.cache.invalidate();
        // Trigger immediate recalculation
        requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Invalidate only layout-dependent values (for when other sections load)
	 * This preserves stable measurements like stickyOffsetFromContainer
	 */ invalidateLayout() {
        this.cache.invalidateLayout();
        requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Cleanup and destroy the controller
	 */ destroy() {
        // Remove scroll listener
        if (this.boundScrollHandler) {
            window.removeEventListener("scroll", this.boundScrollHandler);
            this.boundScrollHandler = null;
        }
        // Cancel pending RAF
        if (this.scrollRAF) {
            cancelAnimationFrame(this.scrollRAF);
            this.scrollRAF = null;
        }
        // Disconnect observers
        if (this.stickyResizeObserver) {
            this.stickyResizeObserver.disconnect();
            this.stickyResizeObserver = null;
        }
        if (this.layoutResizeObserver) {
            this.layoutResizeObserver.disconnect();
            this.layoutResizeObserver = null;
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = null;
        }
        // Reset styles
        this.resetStyles();
        // Clear references
        this.elements = null;
        this.cache.invalidate();
        this.currentState = null;
        // Mark as inactive
        this.isActive = false;
    }
}


// Global controller instance
let $5901807e870bca0b$var$stickyController = null;
/**
 * Initialize or reinitialize the sticky product controller
 */ function $5901807e870bca0b$var$initializeStickyProduct() {
    // Destroy existing instance if present
    if ($5901807e870bca0b$var$stickyController) {
        $5901807e870bca0b$var$stickyController.destroy();
        $5901807e870bca0b$var$stickyController = null;
    }
    // Create and initialize new controller
    $5901807e870bca0b$var$stickyController = new (0, $d4d227e85f07adb6$export$fd284eb6bfa30e95)();
    $5901807e870bca0b$var$stickyController.init();
}
/**
 * Reinitialize with double RAF for layout settling
 */ function $5901807e870bca0b$var$reinitialize() {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            $5901807e870bca0b$var$initializeStickyProduct();
        });
    });
}
// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", ()=>{
    $5901807e870bca0b$var$initializeStickyProduct();
});
// Handle viewport resize (mobile ↔ desktop transitions)
let $5901807e870bca0b$var$lastViewportWasDesktop = window.innerWidth > 768;
window.addEventListener("resize", ()=>{
    const isDesktop = window.innerWidth > 768;
    // Mobile → Desktop: Initialize if not already active
    if (!$5901807e870bca0b$var$lastViewportWasDesktop && isDesktop) {
        if (!$5901807e870bca0b$var$stickyController || !$5901807e870bca0b$var$stickyController.isActive) $5901807e870bca0b$var$initializeStickyProduct();
    }
    // Desktop → Mobile: Destroy and clean up
    if ($5901807e870bca0b$var$lastViewportWasDesktop && !isDesktop) {
        if ($5901807e870bca0b$var$stickyController) {
            $5901807e870bca0b$var$stickyController.destroy();
            $5901807e870bca0b$var$stickyController = null;
        }
    }
    $5901807e870bca0b$var$lastViewportWasDesktop = isDesktop;
});
// Smart reinitialization when filtered product list rerenders
// Only do full reinit if the changed section is the active stop marker
document.addEventListener("filtered-product-list:loaded", (event)=>{
    const changedSectionId = event.detail?.sectionId;
    // Check if this section is the one we're using as stop marker
    if ($5901807e870bca0b$var$stickyController && $5901807e870bca0b$var$stickyController.isActive) {
        const isActiveStopSection = $5901807e870bca0b$var$stickyController.activeStopSectionId === changedSectionId;
        if (isActiveStopSection) // Stop marker section changed - need full reinit
        $5901807e870bca0b$var$reinitialize();
        else // Other section loaded - just invalidate layout measurements
        // This recalculates container/stop positions while preserving
        // the stable stickyOffsetFromContainer value
        $5901807e870bca0b$var$stickyController.invalidateLayout();
    }
});


class $5d82383b721ae4ef$var$ShippingCutoffCountdown extends HTMLElement {
    constructor(){
        super();
        this.timezone = this.dataset.timezone || "Europe/Copenhagen";
        this.cutoffHour = parseInt(this.dataset.cutoffHour) || 14;
        this.cutoffMinute = parseInt(this.dataset.cutoffMinute) || 0;
        this.minimumHours = parseInt(this.dataset.minimumHours) || 6;
        this.updateInterval = null;
        this.countdownWrapper = null;
        this.tomorrowWrapper = null;
        this.globalCountdown = null;
    }
    connectedCallback() {
        this.countdownWrapper = this.querySelector('[data-countdown-state="countdown"]');
        this.tomorrowWrapper = this.querySelector('[data-countdown-state="tomorrow"]');
        this.countdownContainer = this.querySelector(".shipping-cutoff__countdown-container");
        this.checkAndRender();
        this.startCountdown();
        document.addEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
    }
    disconnectedCallback() {
        this.stopCountdown();
        document.removeEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
    }
    handleVisibilityChange() {
        if (document.hidden) this.stopCountdown();
        else {
            this.checkAndRender();
            this.startCountdown();
        }
    }
    getCopenhagenComponents() {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: this.timezone,
            hour12: false,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            weekday: "short"
        });
        const parts = formatter.formatToParts(now);
        const components = {};
        parts.forEach(({ type: type, value: value })=>{
            components[type] = value;
        });
        return components;
    }
    getCopenhagenDate() {
        const cph = this.getCopenhagenComponents();
        return new Date(`${cph.year}-${cph.month}-${cph.day}T${cph.hour}:${cph.minute}:${cph.second}`);
    }
    getDayOfWeek() {
        const cph = this.getCopenhagenComponents();
        const weekdayMap = {
            "Sun": 0,
            "Mon": 1,
            "Tue": 2,
            "Wed": 3,
            "Thu": 4,
            "Fri": 5,
            "Sat": 6
        };
        return weekdayMap[cph.weekday];
    }
    calculateTimeRemaining() {
        const cph = this.getCopenhagenComponents();
        const currentHour = parseInt(cph.hour);
        const currentMinute = parseInt(cph.minute);
        const currentSecond = parseInt(cph.second);
        const currentTotalSeconds = currentHour * 3600 + currentMinute * 60 + currentSecond;
        const cutoffTotalSeconds = this.cutoffHour * 3600 + this.cutoffMinute * 60;
        let secondsRemaining = cutoffTotalSeconds - currentTotalSeconds;
        if (secondsRemaining < 0) secondsRemaining = 0;
        const hours = Math.floor(secondsRemaining / 3600);
        const minutes = Math.floor(secondsRemaining % 3600 / 60);
        const seconds = secondsRemaining % 60;
        return {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            totalSeconds: secondsRemaining
        };
    }
    shouldDisplay() {
        const dayOfWeek = this.getDayOfWeek();
        if (dayOfWeek === 0 || dayOfWeek === 6) return {
            display: false,
            reason: "weekend"
        };
        const { hours: hours, totalSeconds: totalSeconds } = this.calculateTimeRemaining();
        if (totalSeconds === 0) {
            const isNextDayBusinessDay = this.isNextDayBusinessDay(dayOfWeek);
            if (isNextDayBusinessDay) return {
                display: true,
                state: "tomorrow"
            };
            return {
                display: false,
                reason: "past_cutoff_weekend"
            };
        }
        if (hours >= this.minimumHours) return {
            display: false,
            reason: "too_early"
        };
        return {
            display: true,
            state: "countdown"
        };
    }
    isNextDayBusinessDay(currentDayOfWeek) {
        return currentDayOfWeek >= 1 && currentDayOfWeek <= 4;
    }
    calculateCutoffDate() {
        const cph = this.getCopenhagenComponents();
        const cutoffHourStr = String(this.cutoffHour).padStart(2, "0");
        const cutoffMinuteStr = String(this.cutoffMinute).padStart(2, "0");
        const dateString = `${cph.year}-${cph.month}-${cph.day}T${cutoffHourStr}:${cutoffMinuteStr}:00`;
        const testDate = new Date(`${cph.year}-${cph.month}-${cph.day}`);
        const isDST = this.isDSTActive(testDate);
        const offset = isDST ? "+02:00" : "+01:00";
        return `${dateString}${offset}`;
    }
    isDSTActive(date) {
        const dateStr = date.toLocaleString("en-US", {
            timeZone: this.timezone,
            timeZoneName: "short"
        });
        return dateStr.includes("CEST");
    }
    checkAndRender() {
        const shouldDisplay = this.shouldDisplay();
        if (!shouldDisplay.display) {
            this.style.display = "none";
            return;
        }
        this.style.display = "block";
        if (shouldDisplay.state === "countdown") this.renderCountdown();
        else if (shouldDisplay.state === "tomorrow") this.renderTomorrow();
    }
    renderCountdown() {
        const { hours: hours } = this.calculateTimeRemaining();
        const cutoffDateISO = this.calculateCutoffDate();
        if (this.countdownContainer) {
            if (!this.countdownContainer.querySelector("global-countdown")) {
                const countdown = document.createElement("global-countdown");
                countdown.setAttribute("data-target-date", cutoffDateISO);
                countdown.setAttribute("data-units", "hours:minutes:seconds");
                countdown.setAttribute("data-text-only", "true");
                countdown.setAttribute("data-zero-pad", "true");
                countdown.setAttribute("data-hide-zero-units", "true");
                countdown.setAttribute("data-i18n-hour", this.countdownContainer.dataset.i18nHour || "Hour");
                countdown.setAttribute("data-i18n-hours", this.countdownContainer.dataset.i18nHours || "Hours");
                countdown.setAttribute("data-i18n-minute", this.countdownContainer.dataset.i18nMinute || "Minute");
                countdown.setAttribute("data-i18n-minutes", this.countdownContainer.dataset.i18nMinutes || "Minutes");
                countdown.setAttribute("data-i18n-second", this.countdownContainer.dataset.i18nSecond || "Second");
                countdown.setAttribute("data-i18n-seconds", this.countdownContainer.dataset.i18nSeconds || "Seconds");
                countdown.setAttribute("role", "timer");
                countdown.setAttribute("aria-live", "polite");
                countdown.setAttribute("aria-atomic", "true");
                countdown.setAttribute("aria-label", this.countdownContainer.dataset.ariaLabel || "Shipping countdown");
                this.countdownContainer.appendChild(countdown);
            } else {
                const existingCountdown = this.countdownContainer.querySelector("global-countdown");
                const currentDate = existingCountdown.getAttribute("data-target-date");
                if (currentDate !== cutoffDateISO) existingCountdown.setAttribute("data-target-date", cutoffDateISO);
            }
        }
        const urgencyClass = hours < 1 ? "shipping-cutoff--high-urgency" : "shipping-cutoff--countdown";
        if (this.countdownWrapper) {
            this.countdownWrapper.className = `shipping-cutoff__countdown-wrapper ${urgencyClass}`;
            this.countdownWrapper.style.display = "block";
        }
        if (this.tomorrowWrapper) this.tomorrowWrapper.style.display = "none";
        this.dispatchEvent(new CustomEvent("shipping-cutoff:displayed", {
            bubbles: true,
            detail: {
                hoursRemaining: hours,
                state: "countdown"
            }
        }));
    }
    renderTomorrow() {
        if (this.countdownWrapper) this.countdownWrapper.style.display = "none";
        if (this.countdownContainer) this.countdownContainer.innerHTML = "";
        if (this.tomorrowWrapper) {
            this.tomorrowWrapper.className = "shipping-cutoff__tomorrow-wrapper shipping-cutoff--tomorrow";
            this.tomorrowWrapper.style.display = "block";
        }
        this.dispatchEvent(new CustomEvent("shipping-cutoff:displayed", {
            bubbles: true,
            detail: {
                state: "tomorrow"
            }
        }));
    }
    startCountdown() {
        this.stopCountdown();
        this.updateInterval = setInterval(()=>{
            this.checkAndRender();
        }, 30000);
    }
    stopCountdown() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }
}
customElements.define("shipping-cutoff-countdown", $5d82383b721ae4ef$var$ShippingCutoffCountdown);


parcelRequire("adV76");
parcelRequire("gQTes");
parcelRequire("h17mq");
parcelRequire("ghscK");
parcelRequire("jPzyF");


class $bdc21248912ce98f$var$BundleBuilder extends HTMLElement {
    connectedCallback() {
        this.fromCartItems = [];
        document.addEventListener("bundle:add", this.onAdd);
        document.addEventListener("bundle:variant-change", this.onVariantChange);
        this.addEventListener("bundle:item-changed", this.onItemChanged);
        this.submitButton?.addEventListener("click", this.onSubmit);
        this.initFromUrl();
    }
    disconnectedCallback() {
        document.removeEventListener("bundle:add", this.onAdd);
        document.removeEventListener("bundle:variant-change", this.onVariantChange);
        this.removeEventListener("bundle:item-changed", this.onItemChanged);
        this.submitButton?.removeEventListener("click", this.onSubmit);
    }
    get items() {
        return Array.from(this.querySelectorAll("bundle-item"));
    }
    get submitButton() {
        return this.querySelector(".bundle-builder__cta");
    }
    async initFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const itemsParam = params.get("items");
        if (!itemsParam) return;
        const keys = itemsParam.split(",").filter(Boolean);
        if (!keys.length) return;
        try {
            const res = await fetch("/cart.js");
            const cart = await res.json();
            let lastVariantTitle = null;
            for (const key of keys){
                const li = cart.items.find((i)=>i.key === key);
                if (!li) continue;
                const modelName = li.product_title.split(" ")[0];
                const product = {
                    productId: li.product_id,
                    title: li.product_title,
                    modelName: modelName,
                    productType: li.product_type,
                    image: li.image,
                    variantId: li.variant_id,
                    variantTitle: li.variant_title,
                    fromCart: true,
                    lineItemKey: li.key
                };
                this.fromCartItems.push(product);
                const slot = this.items.find((item)=>!item.checkbox?.checked);
                if (!slot) break;
                document.dispatchEvent(new CustomEvent("bundle:update", {
                    detail: {
                        bundleId: slot.bundleId,
                        action: "add",
                        product: product
                    }
                }));
                lastVariantTitle = li.variant_title;
            }
            if (lastVariantTitle) {
                this.preferredVariant = lastVariantTitle;
                this.querySelectorAll("bundle-product").forEach((bp)=>{
                    bp.applyPreferredVariant?.(lastVariantTitle);
                });
            }
            this.broadcastCounts();
        } catch  {
        // Cart fetch failed — slots stay empty
        }
        const url = new URL(window.location);
        url.searchParams.delete("items");
        history.replaceState(null, "", url);
    }
    onVariantChange = (event)=>{
        const { variantTitle: variantTitle } = event.detail;
        if (variantTitle) this.preferredVariant = variantTitle;
    };
    onAdd = (event)=>{
        const { productId: productId, variantId: variantId, variantTitle: variantTitle, maxQty: maxQty, productTitle: productTitle, modelName: modelName, productType: productType, image: image } = event.detail;
        if (variantTitle) this.preferredVariant = variantTitle;
        const variantCount = this.items.filter((item)=>item.variantId === variantId).length;
        if (maxQty > 0 && variantCount >= maxQty) return;
        const slot = this.items.find((item)=>!item.checkbox?.checked);
        if (!slot) return;
        this.variantMaxQty = this.variantMaxQty || {};
        this.variantMaxQty[variantId] = maxQty;
        document.dispatchEvent(new CustomEvent("bundle:update", {
            detail: {
                bundleId: slot.bundleId,
                action: "add",
                product: {
                    productId: productId,
                    title: productTitle,
                    modelName: modelName,
                    productType: productType,
                    image: image,
                    variantId: variantId,
                    variantTitle: variantTitle
                }
            }
        }));
    };
    onItemChanged = ()=>{
        this.broadcastCounts();
        this.updateSubmitState();
    };
    updateSubmitState() {
        const button = this.submitButton;
        if (!button) return;
        const allRequired = this.items.every((item)=>!item.checkbox?.required || item.checkbox.checked);
        button.disabled = !allRequired;
    }
    onSubmit = async ()=>{
        const button = this.submitButton;
        if (!button || button.disabled) return;
        const selected = this.items.filter((item)=>item.checkbox?.checked && item.variantId);
        if (!selected.length) return;
        button.disabled = true;
        button.classList.add("is-loading");
        const toAdd = selected.filter((item)=>!item.fromCart);
        const activeCartKeys = new Set(selected.filter((item)=>item.fromCart).map((item)=>item.lineItemKey));
        const toRemove = this.fromCartItems.filter((p)=>!activeCartKeys.has(p.lineItemKey));
        try {
            for (const item of toRemove)await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: item.lineItemKey,
                    quantity: 0
                })
            });
            if (toAdd.length) await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items: toAdd.map((item)=>({
                            id: item.variantId,
                            quantity: 1,
                            properties: {
                                _source: "bundle-builder"
                            }
                        }))
                })
            });
            window.location.href = "/checkout";
        } catch  {
            button.disabled = false;
            button.classList.remove("is-loading");
        }
    };
    broadcastCounts() {
        const counts = {};
        const variantCounts = {};
        for (const item of this.items){
            if (item.checkbox?.checked && item.productId) counts[item.productId] = (counts[item.productId] || 0) + 1;
            if (item.checkbox?.checked && item.variantId) variantCounts[item.variantId] = (variantCounts[item.variantId] || 0) + 1;
        }
        const full = this.items.every((item)=>item.checkbox?.checked);
        this.bundleCounts = counts;
        this.bundleFull = full;
        document.dispatchEvent(new CustomEvent("bundle:counts-updated", {
            detail: {
                counts: counts,
                variantCounts: variantCounts,
                variantMaxQty: this.variantMaxQty || {},
                full: full
            }
        }));
    }
}
customElements.define("bundle-builder", $bdc21248912ce98f$var$BundleBuilder);


class $ce9f307b061b1036$var$BundleFilterNav extends HTMLElement {
    connectedCallback() {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>this.init(), {
            once: true
        });
        else this.init();
    }
    init() {
        const sectionId = this.dataset.sectionId;
        this.filters = window.BundleBuilder?.[sectionId]?.filters || [];
        if (this.filters.length < 2) return;
        this.render();
        this.activateFilter(this.filters[0]);
    }
    render() {
        const nav = document.createElement("nav");
        nav.className = "bundle-filter-nav";
        nav.setAttribute("aria-label", "Product type filters");
        for (const filter of this.filters){
            const button = document.createElement("button");
            button.type = "button";
            button.className = "bundle-filter-nav__tab";
            button.textContent = filter.title;
            button.dataset.value = filter.value;
            button.addEventListener("click", ()=>this.activateFilter(filter));
            let hoverTimer = null;
            button.addEventListener("pointerenter", ()=>{
                if (this.activeValue === filter.value) return;
                if (navigator.connection?.saveData) return;
                hoverTimer = setTimeout(()=>{
                    document.dispatchEvent(new CustomEvent("bundle:prefetch-filter", {
                        detail: {
                            param: filter.param,
                            value: filter.value
                        }
                    }));
                }, 80);
            });
            button.addEventListener("pointerleave", ()=>{
                clearTimeout(hoverTimer);
            });
            nav.appendChild(button);
        }
        this.appendChild(nav);
    }
    activateFilter(filter) {
        if (this.activeValue === filter.value) return;
        this.activeValue = filter.value;
        for (const tab of this.querySelectorAll(".bundle-filter-nav__tab"))tab.classList.toggle("is-active", tab.dataset.value === filter.value);
        document.dispatchEvent(new CustomEvent("bundle:filter-changed", {
            detail: {
                param: filter.param,
                value: filter.value
            }
        }));
    }
}
customElements.define("bundle-filter-nav", $ce9f307b061b1036$var$BundleFilterNav);


function $4d66a594e9664bf7$var$pt() {
    return {
        scroller: null,
        end: 300,
        isDragging: !1,
        scrollerScrollWidth: 300,
        scrollerWidth: 300,
        scrollerScrollHeight: 300,
        scrollerHeight: 300,
        padding: {
            start: 0,
            end: 0
        },
        scrollPadding: {
            start: 0,
            end: 0
        },
        slidePositions: [],
        hasSnap: !1,
        dir: 1
    };
}
function $4d66a594e9664bf7$var$vt(t, i, n) {
    return (1 - n) * t + n * i;
}
function $4d66a594e9664bf7$var$M(t, i, n, o) {
    return $4d66a594e9664bf7$var$vt(t, i, 1 - Math.exp(Math.log(1 - n) * (o / (1e3 / 60))));
}
function $4d66a594e9664bf7$var$Z(t, i, n) {
    return Math.max(i, Math.min(n, t));
}
function $4d66a594e9664bf7$var$C(t, i = 0) {
    const n = Math.pow(10, i);
    return Math.round(t * n) / n;
}
function $4d66a594e9664bf7$var$xt(t, i, n) {
    return t + i / (1 - n);
}
const $4d66a594e9664bf7$var$w = 0.72, $4d66a594e9664bf7$var$B = 0.12, $4d66a594e9664bf7$var$J = new Event("scrollend", {
    bubbles: !0,
    cancelable: !0
}), $4d66a594e9664bf7$var$O = (t, i, n)=>{
    const o = n ? new CustomEvent(i, {
        bubbles: !0,
        cancelable: !0,
        detail: n
    }) : new Event(i, {
        bubbles: !0,
        cancelable: !0
    });
    return t?.dispatchEvent(o), o;
}, $4d66a594e9664bf7$var$R = (t, i)=>$4d66a594e9664bf7$var$O(t, "overscroll", i), $4d66a594e9664bf7$var$yt = (t)=>(t?.dispatchEvent($4d66a594e9664bf7$var$J), $4d66a594e9664bf7$var$J), $4d66a594e9664bf7$var$wt = (t, i)=>$4d66a594e9664bf7$var$O(t, "scrollsnapchange", i), $4d66a594e9664bf7$var$tt = (t, i)=>$4d66a594e9664bf7$var$O(t, "scrollsnapchanging", i);
function $4d66a594e9664bf7$var$mt() {
    return {
        positions: [],
        activePosition: {
            target: null,
            x: 0,
            y: 0
        }
    };
}
function $4d66a594e9664bf7$var$Pt(t, i, n) {
    let o = [], d = 0;
    const a = (l)=>{
        if (d++, d > 100) return;
        const m = window.getComputedStyle(l).scrollSnapAlign;
        if (m !== "none") {
            o.push({
                align: m,
                el: l
            });
            return;
        }
        const x = l.children;
        if (x.length !== 0) for (let y of Array.from(x))a(y);
    };
    a(t);
    const c = t.getBoundingClientRect(), v = o.map(({ el: l, align: h }, m)=>{
        const x = l.getBoundingClientRect(), y = l.clientWidth, b = x.left - c.left + t.scrollLeft;
        switch(h){
            case "start":
                return {
                    target: l,
                    x: b - i.scrollPadding.start,
                    y: 0
                };
            case "end":
                return {
                    target: l,
                    x: b + y - i.scrollerWidth + i.scrollPadding.end,
                    y: 0
                };
            case "center":
                return {
                    target: l,
                    x: b + y * 0.5 - i.scrollerWidth / 2,
                    y: 0
                };
            default:
                return null;
        }
    }).filter((l)=>l !== null).reduce((l, h)=>((l.length === 0 || l[l.length - 1].x !== h.x) && l.push(h), l), []);
    n.positions = v;
}
function $4d66a594e9664bf7$var$bt(t, i, n, o, d) {
    const a = $4d66a594e9664bf7$var$nt(t, i, n, o, d);
    return a.x !== d.activePosition.x && $4d66a594e9664bf7$var$tt(o.scroller, {
        snapTargetInline: (a || d.activePosition).target,
        snapTargetBlock: (a || d.activePosition).target
    }), d.activePosition = a, ($4d66a594e9664bf7$var$Z(a.x, Math.min((o.scrollerScrollWidth - o.scrollerWidth) * o.dir, 0), Math.max((o.scrollerScrollWidth - o.scrollerWidth) * o.dir, 0)) - t) * (1 - $4d66a594e9664bf7$var$w) * (1 / $4d66a594e9664bf7$var$w);
}
function $4d66a594e9664bf7$var$nt(t, i, n, o, d) {
    const a = $4d66a594e9664bf7$var$xt(t, i, n);
    return d.positions.length ? d.positions.reduce((c, f)=>Math.abs(f.x - a) < Math.abs(c.x - a) ? f : c) : {
        target: null,
        x: $4d66a594e9664bf7$var$Z(a, Math.min(o.end, 0), Math.max(o.end, 0)),
        y: 0
    };
}
function $4d66a594e9664bf7$var$St(t, i) {
    $4d66a594e9664bf7$var$wt(t.scroller, {
        snapTargetInline: i.activePosition.target,
        snapTargetBlock: i.activePosition.target
    });
}
function $4d66a594e9664bf7$var$Et(t, i, n, o, d) {
    const a = $4d66a594e9664bf7$var$nt(t, i, n, o, d);
    a.x !== d.activePosition.x && (d.activePosition = a, $4d66a594e9664bf7$var$tt(o.scroller, {
        snapTargetInline: (a || d.activePosition).target,
        snapTargetBlock: (a || d.activePosition).target
    }));
}
const $4d66a594e9664bf7$var$Wt = {
    center: (t, i, n)=>t + i * 0.5 - n.scrollerWidth / 2,
    end: (t, i, n)=>t + i - n.scrollerWidth + n.scrollPadding.end,
    start: (t, i, n)=>t - n.scrollPadding.start
};
function $4d66a594e9664bf7$var$Q(t, i, n, o) {
    if (o.hasSnap) return t;
    const d = $4d66a594e9664bf7$var$Wt[n || "start"];
    return d(t, i, o);
}
function $4d66a594e9664bf7$var$et(t, i, n, o) {
    if (!n.scroller) return 0;
    const d = n.scroller.scrollLeft, a = o.positions.length ? o.positions : n.slidePositions;
    if (t === "prev") for(let c = a.length - 1; c >= 0; c--){
        const f = $4d66a594e9664bf7$var$Q(a[c].x, a[c].width || 0, i, n);
        if (f < d - 1) return f;
    }
    else for(let c = 0; c < a.length; c++){
        const f = $4d66a594e9664bf7$var$Q(a[c].x, a[c].width || 0, i, n);
        if (f > d + 1) return f;
    }
    return 0;
}
function $4d66a594e9664bf7$var$Lt(t, i, { align: n } = {}) {
    const o = $4d66a594e9664bf7$var$et("prev", n, t, i);
    o && t.scroller.scrollTo({
        left: o,
        behavior: "smooth"
    });
}
function $4d66a594e9664bf7$var$Mt(t, i, { align: n } = {}) {
    const o = $4d66a594e9664bf7$var$et("next", n, t, i);
    o && t.scroller.scrollTo({
        left: o,
        behavior: "smooth"
    });
}
const $4d66a594e9664bf7$export$6e828d9395dc5efc = (t, i)=>{
    const n = $4d66a594e9664bf7$var$pt(), o = $4d66a594e9664bf7$var$mt();
    n.scroller = t;
    let d = !0;
    const a = {
        x: 0,
        y: 0
    }, c = {
        x: 0,
        y: 0
    }, f = {
        x: 0,
        y: 0
    }, v = new Proxy({
        x: 0,
        y: 0
    }, {
        set (e, r, s) {
            return e[r] === s || (e[r] = s, (e.x >= 10 || e.y >= 10) && (p.value = !0)), !0;
        }
    }), l = new Proxy({
        x: !1,
        y: !1
    }, {
        set (e, r, s) {
            return e[r] === s || (e[r] = s, e.x || e.y ? (t.setAttribute("has-overflow", "true"), t.addEventListener("pointerdown", F), t.addEventListener("wheel", z, {
                passive: !1
            })) : (t.removeAttribute("has-overflow"), t.removeEventListener("pointerdown", F), t.removeEventListener("wheel", z))), !0;
        }
    });
    let h = null, m = null, x = null, y = null, b;
    function it() {
        t?.setAttribute("blossom-carousel", "true"), m = t?.querySelectorAll("a[href]") || null, m?.forEach((s)=>{
            s.addEventListener("click", X);
        }), window.addEventListener("keydown", _), t.addEventListener("scroll", V), x = new ResizeObserver(H), x.observe(t), y = new MutationObserver(rt), y.observe(t, {
            attributes: !1,
            childList: !0,
            subtree: !1
        });
        const e = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        n.dir = t.closest('[dir="rtl"]') ? -1 : 1;
        const { scrollSnapType: r } = window.getComputedStyle(t);
        n.hasSnap = r !== "none", t.style.setProperty("--snap-type", r), e && t.style.setProperty("scroll-snap-type", "none"), t.setAttribute("has-snap", d ? "true" : "false"), t.setAttribute("has-repeat", i?.repeat ? "true" : "false"), b = ct((s)=>{
            (s === t || t.contains(s)) && (p.value = !1);
        });
    }
    function ot() {
        t.removeAttribute("blossom-carousel"), x?.disconnect(), y?.disconnect(), h && cancelAnimationFrame(h), window.removeEventListener("keydown", _), t.removeEventListener("scroll", V), m?.forEach((e)=>{
            e.removeEventListener("click", X);
        }), b?.();
    }
    function X(e) {
        v.x > 10 && e.preventDefault();
    }
    function H() {
        if (!t) return;
        const e = "ontouchmove" in window;
        n.scrollerScrollWidth = t.scrollWidth, n.scrollerWidth = t.clientWidth, n.scrollerScrollHeight = t.scrollHeight, n.scrollerHeight = t.clientHeight;
        const r = window.getComputedStyle(t);
        l.x = !e && n.scrollerScrollWidth > n.scrollerWidth && [
            "auto",
            "scroll"
        ].includes(r.getPropertyValue("overflow-x")), l.y = !e && n.scrollerScrollHeight > n.scrollerHeight && [
            "auto",
            "scroll"
        ].includes(r.getPropertyValue("overflow-y")), n.padding.end = parseInt(r.paddingInlineEnd) || 0, n.padding.start = parseInt(r.paddingInlineStart) || 0, n.scrollPadding.start = parseInt(r.scrollPaddingInlineStart) || 0, n.scrollPadding.end = parseInt(r.scrollPaddingInlineEnd) || 0, n.dir = t.closest('[dir="rtl"]') ? -1 : 1, n.end = (n.scrollerScrollWidth - n.scrollerWidth - 4) * n.dir, n.hasSnap ? $4d66a594e9664bf7$var$Pt(t, n, o) : n.slidePositions = Array.from(t.children).map((s)=>{
            const g = s.getBoundingClientRect(), I = t.getBoundingClientRect(), P = g.left - I.left + t.scrollLeft;
            return {
                target: s,
                x: P - n.scrollPadding.start,
                y: 0,
                width: g.width,
                height: g.height
            };
        }), i?.repeat && A(null, null);
    }
    function rt() {
        H();
    }
    function V() {
        if (i?.repeat) {
            A(null, null);
            return;
        }
        if (n.isDragging || !t) return;
        const e = t.scrollLeft;
        e < 0 ? $4d66a594e9664bf7$var$R(t, {
            left: e * -1
        }) : e > n.scrollerScrollWidth - n.scrollerWidth && $4d66a594e9664bf7$var$R(t, {
            left: e * -1 + n.scrollerScrollWidth - n.scrollerWidth
        });
    }
    const u = {
        x: 0,
        y: 0
    };
    function F(e) {
        t && (l.x && (u.x = t.scrollLeft, a.x = e.clientX, f.x = 0), l.y && (u.y = t.scrollTop, a.y = e.clientY, f.y = 0), v.x = 0, n.isDragging = !0, window.addEventListener("pointermove", Y), window.addEventListener("pointerup", q));
    }
    function Y(e) {
        if (e.preventDefault(), l.x) {
            const r = a.x - e.clientX;
            c.x += r, f.x += r, a.x = e.clientX, v.x += Math.abs(r);
        }
        if (l.y) {
            const r = a.y - e.clientY;
            c.y += r, f.y += r, a.y = e.clientY, v.y += Math.abs(r);
        }
    }
    function q() {
        window.removeEventListener("pointermove", Y), window.removeEventListener("pointerup", q), n.isDragging = !1, !(v.x <= 10) && (l.x && (f.x *= 2), l.y && (f.y *= 2), f.x = $4d66a594e9664bf7$var$bt(c.x, f.x, $4d66a594e9664bf7$var$w, n, o), dt());
    }
    function z(e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            if (p.value = !1, n.isDragging || !t) return;
            l.x && (u.x = t.scrollLeft), l.y && (u.y = t.scrollTop);
        }
    }
    function _(e) {
        [
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown"
        ].includes(e.key) && (p.value = !1);
    }
    function A(e, r) {
        if (!t) return;
        const s = r ?? t.scrollLeft, g = n.padding.start - s, I = s - (n.scrollerScrollWidth - n.scrollerWidth - n.padding.end), P = Array.from(t.children), $ = (ft, K, N, T)=>{
            let k = 0;
            const ut = T ? -1 : 1, ht = T ? -(n.scrollerScrollWidth - n.scrollerWidth) : n.scrollerScrollWidth - n.scrollerWidth;
            for(let L = ft; T ? L >= K : L < K; L += ut){
                const gt = k > N;
                P[L].style.translate = `${gt ? 0 : ht}px 0`, k += P[L].clientWidth;
            }
        };
        if ($(P.length - 1, P.length / 2, g, !0), $(0, P.length / 2, I, !1), n.isDragging) return;
        const j = s > n.end ? 4 : s < 4 ? n.end : null;
        j && (W = !0, t.scrollTo({
            left: j,
            behavior: "instant"
        }));
    }
    function G(e) {
        p.value && e.stopPropagation();
    }
    const p = new Proxy({
        value: !1
    }, {
        set (e, r, s) {
            return d = !s, e[r] === s ? !0 : t ? (t.setAttribute("has-snap", d ? "true" : "false"), s && !p.value ? (D = performance.now(), l.x && (c.x = t.scrollLeft), l.y && (c.y = t.scrollTop), t.addEventListener("scrollend", G, {
                capture: !0,
                passive: !1
            }), h || (h = requestAnimationFrame(U))) : s || (h && cancelAnimationFrame(h), h = null, t.removeEventListener("scrollend", G)), e[r] = s, !0) : !1;
        }
    });
    let S = 0, D = 0;
    function U(e) {
        h = requestAnimationFrame(U), S = e - D, t && (l.x && (f.x *= $4d66a594e9664bf7$var$w, n.isDragging ? u.x = $4d66a594e9664bf7$var$M(u.x, c.x, $4d66a594e9664bf7$var$w, S) : (c.x += f.x, u.x = $4d66a594e9664bf7$var$M(u.x, c.x, $4d66a594e9664bf7$var$B, S))), l.y && (f.y *= $4d66a594e9664bf7$var$w, n.isDragging ? u.y = $4d66a594e9664bf7$var$M(u.y, c.y, $4d66a594e9664bf7$var$w, S) : (c.y += f.y, u.y = $4d66a594e9664bf7$var$M(u.y, c.y, $4d66a594e9664bf7$var$B, S))), i?.repeat && (u.x > n.end && (u.x = c.x = 4), u.x < 4 && (u.x = c.x = n.end)), W = !0, t.scrollTo({
            left: u.x,
            top: u.y,
            behavior: "instant"
        }), n.isDragging && n.hasSnap && $4d66a594e9664bf7$var$Et(c.x, f.x, $4d66a594e9664bf7$var$w, n, o), !n.isDragging && $4d66a594e9664bf7$var$C(f.x, 12) === 0 && (p.value = !1, $4d66a594e9664bf7$var$yt(t), n.hasSnap && $4d66a594e9664bf7$var$St(n, o)), i?.repeat ? A(null, u.x) : lt($4d66a594e9664bf7$var$C(u.x, 2)), D = e);
    }
    let E = 0;
    function lt(e) {
        if (!t) return;
        const r = n.end;
        let s = 0;
        if (e * n.dir <= 0 ? s = n.isDragging ? e * -0.2 : 0 : e * n.dir > r * n.dir && (s = n.isDragging ? (e - r) * -0.2 : 0), E = $4d66a594e9664bf7$var$M(E, s, n.isDragging ? 0.8 : $4d66a594e9664bf7$var$B, S), Math.abs(E) > 0.01) {
            if ($4d66a594e9664bf7$var$R(t, {
                left: E
            }).defaultPrevented) return;
            t.style.transform = `translateX(${$4d66a594e9664bf7$var$C(E, 3)}px)`;
            return;
        }
        t.style.transform = "", E = 0;
    }
    let W = !1;
    const st = t.scrollTo.bind(t);
    t.scrollTo = function(...e) {
        W === !0 || (p.value = !1), W = !1, st(...e);
    };
    const at = t.scrollBy.bind(t);
    t.scrollBy = function(...e) {
        W === !0 || (p.value = !1), W = !1, at(...e);
    };
    function ct(e) {
        const r = [], s = Element.prototype.scrollIntoView;
        return s && (Element.prototype.scrollIntoView = function(g) {
            return e(this, "scrollIntoView", [
                g
            ]), s.call(this, g);
        }, r.push(()=>{
            Element.prototype.scrollIntoView = s;
        })), ()=>r.forEach((g)=>g());
    }
    function dt() {
        const e = (r)=>{
            r.preventDefault(), r.stopPropagation(), window.removeEventListener("click", e, !0);
        };
        window.addEventListener("click", e, !0);
    }
    return {
        snap: d,
        hasOverflow: l,
        init: it,
        destroy: ot,
        prev: (e)=>$4d66a594e9664bf7$var$Lt(n, o, e),
        next: (e)=>$4d66a594e9664bf7$var$Mt(n, o, e)
    };
};


const $19bc0219c7732260$var$fetchCache = new Map();
const $19bc0219c7732260$var$requestIdle = window.requestIdleCallback || ((cb)=>setTimeout(cb, 1));
function $19bc0219c7732260$var$prefetchOffScreenSliders() {
    const sliders = document.querySelectorAll("bundle-model-slider");
    for (const slider of sliders){
        if (slider.loaded || slider.isVisible) continue;
        const url = slider.buildFetchUrl();
        if (!url || $19bc0219c7732260$var$fetchCache.has(url)) continue;
        fetch(url, {
            priority: "low"
        }).then((res)=>res.ok ? res.json() : null).then((json)=>{
            if (json) $19bc0219c7732260$var$fetchCache.set(url, Object.values(json)[0]);
        }).catch(()=>{});
    }
}
class $19bc0219c7732260$var$BundleModelSlider extends HTMLElement {
    connectedCallback() {
        this.globalFilter = null;
        this.loaded = false;
        this.isVisible = false;
        this.controller = null;
        this.carousel = null;
        this.filterParam = this.dataset.filterParam;
        this.filterValue = this.dataset.filterValue;
        this.onFilterChanged = this.onFilterChanged.bind(this);
        this.onNavClick = this.onNavClick.bind(this);
        this.onPrefetchFilter = this.onPrefetchFilter.bind(this);
        document.addEventListener("bundle:filter-changed", this.onFilterChanged);
        document.addEventListener("bundle:prefetch-filter", this.onPrefetchFilter);
        this.onScroll = ()=>this.updateNavState();
        this.wrapper = this.closest(".bundle-model");
        this.navButtons = this.wrapper?.querySelectorAll(".bundle-model__nav-btn");
        this.navButtons?.forEach((btn)=>btn.addEventListener("click", this.onNavClick));
        const filterNav = document.querySelector("bundle-filter-nav");
        if (filterNav?.activeValue) {
            const sectionId = filterNav.dataset.sectionId;
            const filters = window.BundleBuilder?.[sectionId]?.filters || [];
            const active = filters.find((f)=>f.value === filterNav.activeValue);
            if (active) this.globalFilter = {
                param: active.param,
                value: active.value
            };
        }
        this.observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                this.isVisible = entry.isIntersecting;
                if (this.isVisible && !this.loaded) this.fetchProducts();
            }
        }, {
            rootMargin: "200px"
        });
        this.observer.observe(this);
    }
    disconnectedCallback() {
        document.removeEventListener("bundle:filter-changed", this.onFilterChanged);
        document.removeEventListener("bundle:prefetch-filter", this.onPrefetchFilter);
        this.navButtons?.forEach((btn)=>btn.removeEventListener("click", this.onNavClick));
        this.activeScroller?.removeEventListener("scroll", this.onScroll);
        this.observer?.disconnect();
        this.controller?.abort();
        this.carousel?.destroy();
    }
    onNavClick(e) {
        const dir = e.currentTarget.dataset.dir;
        const scroller = this.querySelector(".bundle-model-slider__scroller");
        if (!scroller) return;
        const items = [
            ...scroller.children
        ];
        if (items.length === 0) return;
        const currentIndex = this.getActiveIndex(scroller, items);
        const targetIndex = dir === "next" ? Math.min(currentIndex + 1, items.length - 1) : Math.max(currentIndex - 1, 0);
        items[targetIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
        });
    }
    getActiveIndex(scroller, items) {
        const scrollerLeft = scroller.getBoundingClientRect().left;
        let closest = 0;
        let minDist = Infinity;
        for(let i = 0; i < items.length; i++){
            const dist = Math.abs(items[i].getBoundingClientRect().left - scrollerLeft);
            if (dist < minDist) {
                minDist = dist;
                closest = i;
            }
        }
        return closest;
    }
    updateNavState() {
        const scroller = this.querySelector(".bundle-model-slider__scroller");
        if (!scroller || !this.navButtons) return;
        const atStart = scroller.scrollLeft <= 1;
        const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
        const prevBtn = this.wrapper?.querySelector('[data-dir="prev"]');
        const nextBtn = this.wrapper?.querySelector('[data-dir="next"]');
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
    }
    onFilterChanged(event) {
        this.globalFilter = event.detail;
        this.loaded = false;
        if (this.isVisible) this.fetchProducts();
    }
    onPrefetchFilter(event) {
        const filter = event.detail;
        const url = this.buildFetchUrl(filter);
        if (!url || $19bc0219c7732260$var$fetchCache.has(url)) return;
        fetch(url, {
            priority: "low"
        }).then((res)=>res.ok ? res.json() : null).then((json)=>{
            if (json) $19bc0219c7732260$var$fetchCache.set(url, Object.values(json)[0]);
        }).catch(()=>{});
    }
    buildFetchUrl(filterOverride) {
        const builder = this.closest("bundle-builder");
        const collectionHandle = builder?.dataset.collection;
        if (!collectionHandle) return null;
        const sectionType = this.getSectionType();
        const params = new URLSearchParams();
        params.set("sections", sectionType);
        if (this.filterParam && this.filterValue) params.set(this.filterParam, this.filterValue);
        const filter = filterOverride || this.globalFilter;
        if (filter?.param && filter?.value) params.set(filter.param, filter.value);
        return `/collections/${collectionHandle}?${params.toString()}`;
    }
    async fetchProducts() {
        const url = this.buildFetchUrl();
        if (!url) return;
        this.classList.add("is-loading");
        this.showLoader();
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        try {
            let html;
            if ($19bc0219c7732260$var$fetchCache.has(url)) html = $19bc0219c7732260$var$fetchCache.get(url);
            else {
                const priority = this.getSliderIndex() < 2 ? "high" : "low";
                const response = await fetch(url, {
                    signal: this.controller.signal,
                    priority: priority
                });
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const json = await response.json();
                html = Object.values(json)[0];
                $19bc0219c7732260$var$fetchCache.set(url, html);
            }
            const doc = new DOMParser().parseFromString(html, "text/html");
            const blockId = this.dataset.blockId;
            const sourceSlider = doc.querySelector(`bundle-model-slider[data-block-id="${blockId}"]`);
            const products = sourceSlider ? sourceSlider.querySelectorAll("bundle-product") : [];
            const wrapper = this.closest(".bundle-model");
            if (products.length === 0) {
                if (wrapper) wrapper.hidden = true;
                this.hideLoader();
                this.classList.remove("is-loading");
                this.loaded = true;
                return;
            }
            if (wrapper) {
                wrapper.hidden = false;
                wrapper.classList.add("is-loaded");
            }
            if (this.carousel) {
                this.carousel.destroy();
                this.carousel = null;
            }
            const oldScroller = this.querySelector(".bundle-model-slider__scroller");
            if (oldScroller) oldScroller.remove();
            const scroller = document.createElement("div");
            scroller.className = "bundle-model-slider__scroller";
            const isFirstSlider = this.getSliderIndex() === 0;
            for(let i = 0; i < products.length; i++){
                const clone = products[i].cloneNode(true);
                if (isFirstSlider && i < 2) {
                    const img = clone.querySelector("img");
                    if (img) img.loading = "eager";
                }
                scroller.appendChild(clone);
            }
            this.appendChild(scroller);
            this.hideLoader();
            this.initCarousel(scroller);
            this.loaded = true;
            $19bc0219c7732260$var$requestIdle(()=>$19bc0219c7732260$var$prefetchOffScreenSliders());
        } catch (error) {
            if (error.name !== "AbortError") console.error("Bundle model slider fetch failed:", error);
        } finally{
            this.classList.remove("is-loading");
        }
    }
    initCarousel(scroller) {
        this.activeScroller?.removeEventListener("scroll", this.onScroll);
        this.carousel = (0, $4d66a594e9664bf7$export$6e828d9395dc5efc)(scroller, {});
        this.carousel.init();
        this.activeScroller = scroller;
        scroller.addEventListener("scroll", this.onScroll, {
            passive: true
        });
        this.updateNavState();
    }
    showLoader() {
        let loader = this.querySelector(".bundle-model-slider__loader");
        if (!loader) {
            loader = document.createElement("div");
            loader.className = "bundle-model-slider__loader";
            const spinner = document.createElement("div");
            spinner.className = "bundle-model-slider__spinner";
            loader.appendChild(spinner);
            this.appendChild(loader);
        }
        loader.hidden = false;
    }
    hideLoader() {
        const loader = this.querySelector(".bundle-model-slider__loader");
        if (loader) loader.hidden = true;
    }
    getSliderIndex() {
        const builder = this.closest("bundle-builder");
        if (!builder) return 0;
        const sliders = builder.querySelectorAll("bundle-model-slider");
        return [
            ...sliders
        ].indexOf(this);
    }
    getSectionType() {
        const section = this.closest('[id^="shopify-section-"]');
        if (!section) return "section-bundle-builder";
        return section.id.replace("shopify-section-", "");
    }
}
customElements.define("bundle-model-slider", $19bc0219c7732260$var$BundleModelSlider);


class $638ebbd6d98da413$var$BundleItem extends HTMLElement {
    constructor(){
        super();
        this.bundleId = this.getAttribute("bundle-id");
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.placeholder = this.querySelector(".bundle-builder__selection--placeholder");
        this.productCard = null;
        this.productId = null;
        this.variantId = null;
        this.fromCart = false;
        this.lineItemKey = null;
    }
    connectedCallback() {
        document.addEventListener("bundle:update", this.onBundleUpdate);
    }
    disconnectedCallback() {
        document.removeEventListener("bundle:update", this.onBundleUpdate);
    }
    onBundleUpdate = (event)=>{
        const { bundleId: bundleId, action: action, product: product } = event.detail;
        if (bundleId !== this.bundleId) return;
        if (action === "add" && product) this.selectProduct(product);
        else if (action === "remove") this.removeProduct();
    };
    selectProduct(product) {
        this.productId = product.productId;
        this.variantId = product.variantId;
        this.fromCart = product.fromCart || false;
        this.lineItemKey = product.lineItemKey || null;
        if (this.checkbox) this.checkbox.checked = true;
        if (this.productCard) this.productCard.remove();
        const color = product.modelName ? product.title.replace(product.modelName, "").trim() : product.title;
        this.productCard = document.createElement("div");
        this.productCard.className = "bundle-builder__product-card";
        this.productCard.innerHTML = `
			${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy">` : ""}
			<div class="bundle-builder__product-card__info">
				<p class="bundle-builder__product-card__model">${product.modelName || product.title}${product.productType ? ` <span class="bundle-builder__product-card__badge">${product.productType}</span>` : ""}</p>
				<p class="bundle-builder__product-card__variant"><span class="bundle-builder__product-card__color">${color}</span><span class="spacer"></span>${product.variantTitle}</p>
			</div>
			<button class="bundle-builder__product-card__remove" type="button" aria-label="Remove ${product.title}">
				&times;
			</button>
		`;
        this.productCard.querySelector("button").addEventListener("click", this.onRemoveClick);
        this.placeholder.after(this.productCard);
        this.dispatchEvent(new Event("bundle:item-changed", {
            bubbles: true
        }));
    }
    removeProduct() {
        this.productId = null;
        this.variantId = null;
        this.fromCart = false;
        this.lineItemKey = null;
        if (this.checkbox) this.checkbox.checked = false;
        if (this.productCard) {
            this.productCard.remove();
            this.productCard = null;
        }
        this.dispatchEvent(new Event("bundle:item-changed", {
            bubbles: true
        }));
    }
    onRemoveClick = ()=>{
        document.dispatchEvent(new CustomEvent("bundle:update", {
            detail: {
                bundleId: this.bundleId,
                action: "remove"
            }
        }));
    };
}
customElements.define("bundle-item", $638ebbd6d98da413$var$BundleItem);


class $07ff0f3d6f4e4c1b$var$BundleProduct extends HTMLElement {
    constructor(){
        super();
        this.productId = this.dataset.productId;
        this.select = this.querySelector("select");
        this.addButton = this.querySelector("button");
        this.countEl = this.querySelector("[data-count]");
        this.bundleFull = false;
    }
    connectedCallback() {
        document.addEventListener("bundle:variant-change", this.onVariantChange);
        document.addEventListener("bundle:counts-updated", this.onCountsUpdated);
        if (this.select) this.select.addEventListener("change", this.onSelectChange);
        if (this.addButton) this.addButton.addEventListener("click", this.onAddClick);
        const builder = this.closest("bundle-builder");
        if (builder?.preferredVariant) this.applyPreferredVariant(builder.preferredVariant);
        if (builder?.bundleCounts) {
            this.bundleFull = builder.bundleFull ?? false;
            const count = builder.bundleCounts[this.productId] || 0;
            if (this.countEl) this.countEl.textContent = count || "";
        }
        this.updateButtonState(this.select?.selectedOptions[0]);
    }
    disconnectedCallback() {
        document.removeEventListener("bundle:variant-change", this.onVariantChange);
        document.removeEventListener("bundle:counts-updated", this.onCountsUpdated);
        if (this.select) this.select.removeEventListener("change", this.onSelectChange);
        if (this.addButton) this.addButton.removeEventListener("click", this.onAddClick);
    }
    onSelectChange = ()=>{
        const selectedOption = this.select.selectedOptions[0];
        if (!selectedOption || selectedOption.value === "default") {
            this.updateButtonState(selectedOption);
            return;
        }
        this.updateButtonState(selectedOption);
        const variantTitle = selectedOption.textContent?.trim();
        if (!variantTitle) return;
        const sourceScroller = this.closest(".bundle-model-slider__scroller");
        const scrollers = document.querySelectorAll(".bundle-model-slider__scroller");
        const scrollSnapshots = new Map();
        scrollers.forEach((scroller)=>{
            if (scroller === sourceScroller) scrollSnapshots.set(scroller, {
                type: "source",
                offsetBefore: this.offsetLeft - scroller.scrollLeft
            });
            else scrollSnapshots.set(scroller, {
                type: "sibling",
                scrollLeft: scroller.scrollLeft
            });
        });
        document.dispatchEvent(new CustomEvent("bundle:variant-change", {
            detail: {
                variantTitle: variantTitle,
                source: this
            }
        }));
        if (scrollSnapshots.size > 0) requestAnimationFrame(()=>{
            scrollSnapshots.forEach((snapshot, scroller)=>{
                if (snapshot.type === "source") scroller.scrollLeft = this.offsetLeft - snapshot.offsetBefore;
                else scroller.scrollLeft = snapshot.scrollLeft;
            });
        });
    };
    onVariantChange = (event)=>{
        const { variantTitle: variantTitle, source: source } = event.detail;
        if (source === this || !variantTitle) return;
        this.applyPreferredVariant(variantTitle);
    };
    applyPreferredVariant(variantTitle) {
        if (!this.select || !variantTitle) return;
        const option = Array.from(this.select.options).find((opt)=>opt.textContent.trim().startsWith(variantTitle));
        if (!option) {
            this.select.value = "default";
            this.updateButtonState(this.select.selectedOptions[0]);
            return;
        }
        this.select.value = option.value;
        this.updateButtonState(option);
    }
    updateButtonState(option) {
        if (!this.addButton) return;
        const soldOut = option?.disabled;
        const variantId = option?.value;
        const atMaxQty = variantId && variantId !== "default" && this.variantMaxQty?.[variantId] > 0 && (this.variantCounts?.[variantId] || 0) >= this.variantMaxQty[variantId];
        this.addButton.disabled = this.bundleFull || !option || soldOut || option.value === "default" || atMaxQty;
        this.style.order = soldOut ? "2" : "";
    }
    onCountsUpdated = (event)=>{
        this.bundleFull = event.detail.full;
        this.variantCounts = event.detail.variantCounts;
        this.variantMaxQty = event.detail.variantMaxQty;
        const count = event.detail.counts[this.productId] || 0;
        if (this.countEl) this.countEl.textContent = count || "";
        const selectedOption = this.select?.selectedOptions[0];
        if (selectedOption) this.updateButtonState(selectedOption);
    };
    onAddClick = ()=>{
        const selectedOption = this.select?.selectedOptions[0];
        if (!selectedOption) return;
        const image = this.querySelector("img");
        document.dispatchEvent(new CustomEvent("bundle:add", {
            detail: {
                productId: this.productId,
                variantId: selectedOption.value,
                variantTitle: selectedOption.textContent.trim(),
                maxQty: parseInt(selectedOption.dataset.maxQty, 10) || 0,
                productTitle: this.dataset.productTitle,
                modelName: this.dataset.modelName,
                productType: this.dataset.productType,
                image: image?.src
            }
        }));
    };
}
customElements.define("bundle-product", $07ff0f3d6f4e4c1b$var$BundleProduct);




parcelRequire("aJzli");
class $b95e12d3b41f8924$var$VideoAutoplay {
    constructor(){
        this.observedVideos = new WeakSet();
        this.init();
    }
    init() {
        this.setupIntersectionObserver();
        this.observeExistingVideos();
        this.setupMutationObserver();
    }
    setupIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const video = entry.target;
                if (entry.isIntersecting) this.playVideo(video);
                else this.pauseVideo(video);
            });
        }, {
            threshold: 0.10,
            rootMargin: "0px"
        });
    }
    setupMutationObserver() {
        this.mutationObserver = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                mutation.addedNodes.forEach((node)=>{
                    if (node.nodeType === 1) {
                        if (node.tagName === "VIDEO" && node.getAttribute("data-autoplay") === "true") this.observeVideo(node);
                        const videos = node.querySelectorAll?.('video[data-autoplay="true"]');
                        videos?.forEach((video)=>this.observeVideo(video));
                    }
                });
            });
        });
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    observeExistingVideos() {
        const videos = document.querySelectorAll('video[data-autoplay="true"]');
        videos.forEach((video)=>this.observeVideo(video));
    }
    observeVideo(video) {
        if (this.observedVideos.has(video)) return;
        this.observedVideos.add(video);
        this.intersectionObserver.observe(video);
        this.setupIOSWorkaround(video);
    }
    setupIOSWorkaround(video) {
        const container = video.closest("[data-video-container]") || video.parentElement;
        const touchHandler = ()=>{
            if (video.paused && this.isVideoInViewport(video)) this.playVideo(video);
        };
        container.addEventListener("touchstart", touchHandler, {
            passive: true,
            once: true
        });
    }
    isVideoInViewport(video) {
        const rect = video.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
        const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
        return vertInView && horInView;
    }
    playVideo(video) {
        const playPromise = video.play();
        if (playPromise !== undefined) playPromise.catch((error)=>{
            console.warn("Video autoplay failed:", error);
        });
    }
    pauseVideo(video) {
        if (!video.paused) video.pause();
    }
    destroy() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
    }
}
var $b95e12d3b41f8924$export$2e2bcd8739ae039 = $b95e12d3b41f8924$var$VideoAutoplay;


let $86d221be59603aa4$var$videoAutoplayInstance = null;
document.addEventListener("DOMContentLoaded", ()=>{
    $86d221be59603aa4$var$videoAutoplayInstance = new (0, $b95e12d3b41f8924$export$2e2bcd8739ae039)();
});


parcelRequire("9sPuh");
class $54f9f862ec1657cf$var$VisionTestModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.iframe = null;
        this.iframeLoaded = false;
    }
    connectedCallback() {
        this.overlay = this.querySelector(".vision-test-modal__overlay");
        this.panel = this.querySelector(".vision-test-modal__panel");
        this.closeButton = this.querySelector(".vision-test-modal__close");
        this.iframeContainer = this.querySelector(".vision-test-modal__iframe-container");
        this.setupEventListeners();
        this.initializeTriggers();
    }
    setupEventListeners() {
        this.closeButton?.addEventListener("click", ()=>this.close());
        this.overlay?.addEventListener("click", ()=>this.close());
        document.addEventListener("keydown", (e)=>{
            if (e.key === "Escape" && this.isOpen) this.close();
        });
    }
    initializeTriggers() {
        const triggers = document.querySelectorAll("[data-vision-test-trigger]");
        triggers.forEach((trigger)=>{
            trigger.addEventListener("click", (e)=>{
                e.preventDefault();
                this.open();
            });
        });
    }
    async open() {
        if (!this.iframeLoaded) await this.loadIframe();
        this.isOpen = true;
        this.classList.add("is-open");
        document.body.style.overflow = "hidden";
        sessionStorage.setItem("vision_test_interaction", "true");
    }
    close() {
        this.isOpen = false;
        this.classList.remove("is-open");
        document.body.style.overflow = "";
    }
    async loadIframe() {
        const iframeUrl = window.theme.settings.visionTestUrl || "https://luxreaders-visiontest.netlify.app/da";
        this.iframe = document.createElement("iframe");
        this.iframe.src = iframeUrl;
        this.iframe.className = "vision-test-modal__iframe";
        this.iframe.title = window.theme.strings.vision_test.iframe_title;
        this.iframe.setAttribute("frameborder", "0");
        this.iframe.setAttribute("allowfullscreen", "true");
        this.iframeContainer.innerHTML = `<div class="vision-test-modal__loading">${window.theme.strings.vision_test.loading}</div>`;
        this.iframeContainer.appendChild(this.iframe);
        this.iframe.addEventListener("load", ()=>{
            this.iframeContainer.querySelector(".vision-test-modal__loading")?.remove();
        });
        this.iframeLoaded = true;
    }
}
customElements.define("vision-test-modal", $54f9f862ec1657cf$var$VisionTestModal);


if (window.theme?.sizes) window.theme.sizes.large = 1048;

})();
//# sourceMappingURL=parcel_scripts.js.map
